import { IData } from './types';

const data: IData = {
  ru: {
    general: {
      instance: {
        noAccess: 'Нет доступа',
        login: 'Пройдите авторизацию',
        uploadDocuments: 'Загрузите документы',
      },
    },
    components: {
      ScheduleQueue: {
        of: 'из',
        available: 'Свободно'
      },
      CheckQueue: {
        fio: 'Ф.И.О',
        title: 'Проверить свою очередь',
        dateOfBirth: 'Введите дату рождения',
        pass: 'Введите номер пропуска',
        save: 'Сохранить',
        notFound: 'Ваша заявка не найдена',
        date: 'Дата',
        time: 'Время',
        datePlaceholder: 'дд.мм.гггг',
        qrTitle: 'Приложите пропуск с QR-кодом к сканеру',
        dateError: 'Дата рождения указана некорректно'
      },
      TimeSlots: {
        noPlaces: 'Мест нет',
        choose: 'Выбрать',
        of: 'из',
        available: 'Свободно'
      },
      ReserveQueue: {
        selectCurrentTime: 'Пожалуйста, выберите актуальное время',
        conflict: 'Ваша заявка уже добавлена в очередь',
        dateOfBirth: 'Введите дату рождения',
        pass: 'Введите номер пропуска',
        save: 'Сохранить',
        title: 'Зарезервировать очередь',
        success: 'Вы успешно добаылены в электронную очередь',
        error: 'Ошибка, попробуйте позже',
        deleteApp: 'Удалить старую запись?',
        datePlaceholder: 'дд.мм.гггг',
        notFound: 'Ваша заявка не найдена',
        qrTitle: 'Приложите пропуск с QR-кодом к сканеру',
        dateError: 'Дата рождения указана некорректно',
        ageValidation: 'Кандидат не достиг 18 лет',
        blackList: 'Кандидат в черном списке',
        expire083: 'Истек срок действия мед справки',
        expirePassport: 'Истек срок действия паспорта',
        appNotVerified: 'Заявка не верифицирована',
        wrongTimeslot: 'Выбранное время не доступно. Запись возможна на {{times}}',
      },
      Header: {
        prompt: 'Вы действительно хотите выйти?',
      },
      transactionModal: {
        replenished: 'Пополнение',
        writeOff: 'Списание',
        actionType: 'Действие',
        pay: 'Оплата',
        payme: 'Payme',
        click: 'Click',
        terminal: 'Терминал',
        cash: 'Наличные',
        title: 'Транзакции',
        transactionType: 'Тип',
        amount: 'Сумма',
        status: 'Статус',
        payDate: 'Дата оплаты',
        completed: 'Успешно',
        failed: 'Ошибка оплаты',
      },
      resultsModal: {
        seeApp: 'Посмотреть заявку',
        attempt: 'Попытка',
        success: 'Вы успешно прошли практический экзамен, ваш результат',
        result: 'Ваш результат',
        print: 'Распечатать экз лист',
        exercise: 'Упражнение',
        name: 'Название',
        penaltyPoints: 'Штрафные баллы',
        total: 'Всего',
        theorySuccess: 'Вы успешно прошли теоретический экзамен, ваш результат',
        ticketNumber: 'Номер билета',
        question: 'Вопрос',
        selectedAnswer: 'Выбранный ответ',
        results: 'Результат',
      },
      newApplicationNotice: {
        newNotice: 'Новая онлайн заявка',
        open: 'Просмотреть',
        close: 'Закрыть',
      },
      passModal: {
        enterPassNumber: 'Введите номер пропуска',
        save: 'Сохранить',
      },
      pagination: {
        rowsPerPage: 'Количество на странице',
      },
      queueList: {
        car: 'Автомобиль',
        classRoom: 'Аудитория',
        choiceCar: 'Выберите авто',
        call: 'Вызвать',
        cancel: 'Отменить',
        delete: 'Удалить',
        category: 'Категория',
      },
      //fix
      TimeLine: {
        tests: 'Тесты',
        right: 'Правильно',
        wrong: 'Не правильно',
        total: 'Итого баллов',
        startDate: 'Дата начала',
        attempts: 'Попытки',
        carNumber: 'Номер машины',
        penaltyPoints: 'Штрафные баллы',
        CREATED: 'Создан',
        NOT_VERIFIED: 'Не подтвержден',
        T_PAYMENT: 'Оплатите за экзамен теория',
        T_EXAM: 'Сдайте экзамен теория',
        T_FAILED: 'Вы провалили теоретический экзамен',
        P_PAYMENT: 'Оплатите за экзамен практика',
        P_EXAM: 'Сдайте экзамен практика',
        P_FAILED: 'Вы провалили практический экзамен',
        COMPLETED: 'Успешно окончен',
        theoryEndDate: 'Дата окончания теории',
      },
      Sidebar: {
        reports: 'Протоколы',
        responsiblePerson: 'Ответственные лица',
        schools: 'Школы',
        enterName: 'Введите название для поиска',
        control: 'Управление очередью',
        classRooms: 'Кабинеты',
        cars: 'Автомобили',
        queue: 'Очередь',
        users: 'Пользователи',
        categories: 'Категории',
        docs: 'Документы',
        applications: 'Заявки',
        statuses: 'Статусы',
        practiceCategory: 'Типы транспортных средств',
        payment: 'Оплата',
        passedExam: 'Прошедшие экзамен',
        cashPayment: 'Оплата наличными',
        userId: 'Идентификация пользователя',
        visitLogs: 'История посещений',
        motordromes: 'Автодром',
        errors: 'Ошибки',
        transactions: 'Транзакции',
        verrifyApps: 'Верифицированные заявки',
        generatReport: 'Общий отчет',
        generalStatistics: 'Статистика отчет',
        schoolStatistics: 'Статистика по школам',
        gaiSchoolsReport: 'Отчет ГАИ по школам',
        sumarry: 'Cводка',
        appeals: 'Апелляция',
        report: 'Рапорты',
        vising: 'Визинг',
        requestForChangeData: 'Запросы на изм. данных',
        certificates: 'Сертификаты',
        certificatesHistory: 'История сертификата',
        calendar: 'Календарь',
        fines: 'Штрафы',
        reception: 'Ресепшн',
        security: 'Охрана',
        accounting: 'Бухгалтерия',
        cash: 'Касса',
        statistics: 'Статистика',
        integrationWithGai: 'Интеграция с гаи',
        practicalStatisticByCategory: 'Статистика ПЭ по категориям',
        timeslots: 'Время приема',
      },
      CategoryStatuses: {
        statusDeleted: 'Статус удален',
        erorrTryAgain: 'Ошибка попробуйте еще раз',
        wantToRemove: 'Вы действительно хотите удалить статус категории?',
        add: 'Добавить статус категории',
        status: 'Статус',
        successStatus: 'Статус в случае успеха',
        failureStatus: 'Статус в случае провала',
        order: 'Порядок',
        start: 'Начат',
        finished: 'Окончен',
        createdAt: 'Дата создания',
        actions: 'Действия',
      },
      Confirmation: {
        cancel: 'Отмена',
        success: 'Подтвердить',
      },
      FileUploader: {
        fileSize: 'Слишком большой размер файла',
        selectDocument: 'Выбрать документ',
        selectAnotherDocument: 'Выбрать другой документ',
        scanning: 'Сканировать',
        getDocument: 'Получить документ',
        enterPinfl: 'Введите пинфл',
        enterVehicleType: 'Выберите тип транспортного средства',
        documentReceived: 'Документ получен',
        docNotFound: 'Документ не найден',
        error: 'Ошибка, попробуйте позже',
      },
      FileUploads: {
        certificateFromSchool: 'Справка с автошколы',
        mainPassport: 'Паспорт',
        photo: 'Фотография',
        passport: 'Паспорт/ID карта (с пропиской)',
        employerReferral: 'Направление работодателя',
        replacement:
          'Замена водительского удостоверения лиц единого образца или водительского удостоверения кагегорий "В" и "С " на срок более 10 лет непрерывной трудовой деятельности водителя категориями "ВЕ" и "СЕ" на основании выписки из трудовой книжки водителя',
        driverLicence_1: 'Национальные водительские права-1',
        driverLicence_2: 'Национальные водительские права-2',
        direction: 'Направление уполномоченного органа внутренних дел',
        honey083_1: 'Мед справка 083-1',
        honey083_2: 'Мед справка 083-2',
        diplomaAnnex:
          'Диплом и приложение к нему об усвоении предметов по плану',
        nationalDriversLicence:
          'Национальные водительские удостоверение ("C", "B" и "C", "D", "C" и "D", "СE" и (или) "DE")',
        certificateSingleSample: 'Свидетельство единого образца',
        pinflForForeign: 'ПИНФЛ для иностранного гр.',
        docConfirm12: 'Документ утверждающий до 12 месяцев водил ТС',
        appForAppeal: 'Заявление на апелляцию',
        decisionAppealComission: 'Решение апелляционной комиссии',
        forWorkingDrivers:
          'Для работающих водителей — выписка из трудовой книжки или справка (выписка из приказа) с указанием вида закрепленного за ним автомототранспортного средства;',
      },
      Footer: {
        address: 'г. Ташкент, Янгихаётский район, ул. Файзли 87',
        copyRight: '2022 Все права защищены',
      },
      CreateCategoryStatuses: {
        fillFields: 'Заполните поля',
        createdSuccess: 'Статус категории создан успешно',
        alreadyExistsDefault:
          'Статус категории со статусом "по умолчанию" уже существует',
        alreadyExistsFinish:
          'Статус категории со статусом "окончен" уже существует',
        errorTryAgain: 'Ошибка попробуйте позже',
        createStatusCategory: 'Создать статус для категории',
        selectStatus: 'Выберите статус',
        successStatus: 'Статус в случае успеха',
        failureStatus: 'Статус в случае провала',
        workDays: 'Кол-во рабочих дней до повторной попытки',
        order: 'Порядок',
        defaultStatus: 'Статус «по умолчанию»',
        finished: 'Окончен',
        cancel: 'Отменить',
        save: 'Сохранить',
      },
      UpdateCategoryStatuses: {
        fillFields: 'Заполните поля',
        updateSuccess: 'Статус категории изменен',
        errorTryAgain: 'Ошибка попробуйте позже',
        updateStatusCategory: 'Изменить статус для категории',
        selectStatus: 'Выберите статус',
        successStatus: 'Статус в случае успеха',
        failureStatus: 'Статус в случае провала',
        cost: 'Цена',
        workDays: 'Кол-во рабочих дней до повторной попытки',
        order: 'Порядок',
        defaultStatus: 'Статус «по умолчанию»',
        finished: 'Окончен',
        cancel: 'Отменить',
        save: 'Сохранить',
        alreadyExistsDefault:
          'Статус категории со статусом "по умолчанию" уже существует',
        alreadyExistsFinish:
          'Статус категории со статусом "окончен" уже существует',
      },
      TokenModal: {
        copy: 'Cкопировано в буфер обмена',
        refresh: 'Обновить',
      },
      UserModal: {
        userInfo: 'Информация о пользователе',
        FIO: 'ФИО',
        dateOfBirth: 'Дата рождения',
        passport: 'Серия/номер паспорта',
        pinfl: 'ПИНФЛ',
        phone: 'Номер телефона',
        cancel: 'Отменить',
        successUser: 'Подтвертить пользователя',
        name: 'Название',
        createdAt: 'Дата создания',
        actions: 'Действия',
      },
    },
    pages: {
      ScheduleTimePage: {
        lawText: 'Внимание! Время проведения теоретического экзамена для лиц, лишенных права управления автотранспортными средствами {{times}}',
      },
      SchedulePage: {
        checkQueue: 'Проверить свою очередь',
      },
      ReportsForSchool: {
        fieldNotFilled: 'Поля не заполнены',
        schoolsStat: 'Статистика автошкол',
        search: 'Поиск',
        from: 'С',
        to: 'По',
        clear: 'Очистить',
      },
      FinesDetails: {
        from: 'С',
        to: 'По',
        penalty: 'Штраф',
        yes: 'Да',
        no: 'Нет',
        search: 'Поиск',
        clear: 'Очистить',
        createdAt: 'Дата создания',
        appLink: 'Ссылка на заявку',
        branch: 'Филиал',
        fixed: 'Исправлен',
        details: 'Детали',
        go: 'Перейти',
      },
      FinesPage: {
        from: 'С',
        to: 'По',
        search: 'Поиск',
        clear: 'Очистить',
        fullName: 'Ф.И.О.',
        phone: 'Телефон',
        branch: 'Филиал',
        finesNumber: 'Кол-во штрафов',
        details: 'Детали',
        go: 'Перейти',
      },
      OfficialReportByIdPage: {
        appConfirmed: 'Заявка подтверждена',
        error: 'Ошибка, попробуйте позже',
        title: 'Запрос на изм данных',
        penalty: 'Штраф',
        confirm: 'Подтвердить',
        confirmedBy: 'Кем подтвержден',
        currentData: 'Текущие данные',
        firstName: 'Имя',
        lastName: 'Фамилия',
        middleName: 'Отчество',
        dateOfBirth: 'Дата рождения',
        passportSerial: 'Серия паспорта',
        passportNumber: 'Номер паспорта',
        passportValid: 'Срок паспорта',
        dateMed: 'Дата мед. справки',
        changeData: 'Данные на изменение',
        fullName: 'Ф.И.О.',
        passportSerialNumber: 'Серия / Номер паспорта',
        pinfl: 'ПИНФЛ',
        branch: 'Филиал',
        status: 'Статус',
        phone: 'Телефон',
        transactionDate: 'Дата транзакции',
        cardTypeNumber: 'Тип / Номер карты',
        sum: 'Сумма',
        report: 'Рапорт',
      },
      OfficialReportsPage: {
        title: 'Запросы на изм. данных',
        completed: 'Завершенный',
        all: 'Все',
        yes: 'Да',
        no: 'Нет',
        activity: 'Активность',
        branch: 'Филиал',
        user: 'Пользователь',
        search: 'Поиск',
        clear: 'Очистить',
        createdAt: 'Дата создания',
        type: 'Тип',
        appLink: 'Ссылка на заявку',
        candidate: 'Кандидат',
        confirmedBy: 'Кем подтвержден',
        status: 'Статус',
        step: 'Шаг',
        penalty: 'Штраф',
        accomplishment: 'Выполнение',
        details: 'Детали',
        confirmed: 'Подтвержден',
        new: 'Новый',
        data: 'Данные',
        refund: 'Возврат',
      },
      AppealPageById: {
        fio: 'Ф.И.О',
        passportSerial: 'Серия/Номер паспорт',
        phone: 'Телефон',
        dateOfBirth: 'Дата рождения',
        examType: 'Тип экзамена',
        applicaiton: 'Заявка',
        applicaitionLink: 'Ссылка на заявку',
        title: 'Решение апелляционной комиссии',
      },
      AppealsPage: {
        appeal: 'Апелляция',
        fio: 'Ф.И.О',
        phone: 'Телефон',
        createdAt: 'Дата создания',
        examType: 'Тип экзамена',
        actions: 'Действия',
        choiceBranch: 'Выберите филиал',
        all: 'Все',
      },
      ReportPage: {
        //fix
        reportHistory: 'История протокола',
        FIO: 'ФИО',
        category: 'Категория',
        school: 'Школа',
        theoryAttempt: 'Попытки теория',
        theoryScore: 'Балы теория',
        practiceAttempt: 'Поптыки практика',
        practiceScore: 'Сдал/Не сдал',
        passed: 'Сдал',
        notPassed: 'Не сдал',
        certificateNumber: 'Номер сертификата',
        print: 'Распечатать',
      },
      ReportsPage: {
        enterDate: 'Введите дату',
        count: 'Количество',
        actions: 'Действие',
        createdAt: 'Дата создания',
        dayNumber: 'Число генерации протокола',
        reports: 'Протоколы',
        generation: 'Сгенерировать',
        name: 'Название',
        date: 'Дата',
        clear: 'Очистить',
        search: 'Поиск',
        branches: 'Филиалы',
        from: 'С',
        protocolNumber: '№ Протокола',
      },
      SummaryPage: {
        branch: 'Филиал',
        from: 'С',
        to: 'По',
        branches: 'Филиалы',
        summary: 'Сводка',
        application: 'Заявка',
        clear: 'Очистить',
        search: 'Найти',
        fio: 'Ф.И.О',
        appCode: 'Код заявки',
        status: 'Статус',
        createdAt: 'Дата создания',
        firstName: 'Имя',
        lastName: 'Фамилия',
        middleName: 'Отчество',
        categories: 'Категория',
        vehicleTypes: 'Тип транспортного средства',
        oldStatus: 'Предыдущий статус',
        newStatus: 'Новый статус',
        attempt: 'Попытка',
        attempts: 'Попытки',
        firstAttempt: 'Первая попытка',
        retake: 'Пересдача',
        passport: 'Серия/Номер паспорта',
        phone: 'Телефон',
        result: 'Результат',
        true: 'Успешно',
        false: 'Не успешно',
      },
      UpdateClassRoomPage: {
        choiceBranch: 'Выберите филиал',
        nameError: 'Название кабинета уже существует',
        fillFields: 'Заполните поля',
        updatedClassRoom: 'Кабинет изменен',
        updateClassRoom: 'Изменить кабинет',
        enterName: 'Введите название',
        back: 'Назад',
        save: 'Сохранить',
      },
      CreateClassRoomPage: {
        choiceBranch: 'Выберите филиал',
        nameError: 'Название кабинета уже существует',
        fillFields: 'Заполните поля',
        createdClassRoom: 'Кабинет создан',
        createClassRoom: 'Создать кабинет',
        name: 'Название',
        back: 'Назад',
        save: 'Сохранить',
      },
      ClassRoomsPage: {
        classRooms: 'Кабинеты',
        deleted: 'Кабинет удален',
        wantDeleteClassRoom: 'Вы действительно хотите удалить этот кабинет?',
        updatedDate: 'Дата изменения',
        actions: 'Действия',
        name: 'Название',
        classRoom: 'Кабинет',
      },
      ApplicationForGai: {
        fio: 'Ф.И.О',
        passport: 'Паспорт',
        dateOfBirth: 'Дата рождения',
        phone: 'Телефон',
        vehicleType: 'Тип транспортного средства',
      },
      ApplicationsForGai: {
        application: 'Заявки',
        clear: 'Очистить',
        search: 'Найти',
        fio: 'Ф.И.О',
        phone: 'Телефон',
        appCode: 'Код заявки',
        passCode: 'Номер пропуска',
        status: 'Статус',
        category: 'Категория',
        transportType: 'Тип транспортного средства',
        updatedAt: 'Дата изменения',
        actions: 'Действия',
        serial: 'Серия',
        number: 'Номер',
        pinfl: 'ПИНФЛ',
        createdAt: 'Дата создания',
        endDate: 'Дата окончания',
        firstName: 'Имя',
        lastName: 'Фамилия',
        middleName: 'Отчество',
        categories: 'Категория',
        vehicleTypes: 'Тип транспортного средства',
        statuses: 'Статус',
      },
      VisitLogsPage: {
        visitLogs: 'История посещений',
        date: 'Дата',
        search: 'Поиск',
        clear: 'Очистить',
        fio: 'Ф.И.О',
        dateOfBirth: 'Дата рождения',
        passport: 'Серия/номер паспорта',
        appCategory: 'Категория заявки',
        createdAt: 'Дата создания',
        status: 'Статус',
      },
      VehicleTypesPage: {
        deleted: 'Успешно удалено',
        wantDeleteVehicle:
          'Вы действительно хотите удалить транспортное средство?',
        vehicleTypes: 'Транспортные средства',
        name: 'Название',
        actions: 'Действия',
      },
      UsersPage: {
        error: 'Ошибка, попробуйте позже',
        users: 'Пользователи',
        serial: 'Серия',
        number: 'Номер',
        firstName: 'Имя',
        lastName: 'Фамилия',
        middleName: 'Отчество',
        search: 'Поиск',
        clear: 'Очистить',
        passport: 'Серия/номер паспорта',
        pinfl: 'ПИНФЛ',
        fio: 'Ф.И.О',
        phone: 'Телефон',
        integrated: 'Интегрирован',
        role: 'Роль',
        verrified: 'Подтвержден',
        status: 'Статус',
        actions: 'Действия',
      },
      UserIdentificationPage: {
        error: 'Ошибка, попробуйте позже',
        applicationNotFound: 'Заявка не найдена',
        userNotActive: 'Пользователь не активен',
        statusError: 'Ошибка статуса',
        appNotVerrified: 'Заявка не подтверждена',
        fio: 'Ф.И.О',
        dateOfBirth: 'Дата рождения',
        phone: 'Телефон',
        passport: 'Cерия и номер паспорта',
        pinfl: 'ПИНФЛ',
        appStatus: 'Статус заявки',
        appCategory: 'Категория заявки',
        failureDays:
          'Для повторной сдачи экзамена, должно пройти не менее 7 рабочих дней со дня проведенного экзамена',
        success: 'Успешно',
        passportExp: 'Срок паспорта',
        medicalCertValid: 'Срок мед. справки',
      },
      UpdateVehicleTypePage: {
        fillFields: 'Заполните поле',
        vehicletypeUpdated: 'Транспортное средство изменено',
        updateVehicleType: 'Изменить транспортное средство',
        enterName: 'Введите название',
        back: 'Назад',
        save: 'Сохранить',
      },
      UpdateUserPage: {
        motordrome: 'Автодром',
        phoneError: 'Пользователь с таким телефоном уже существует',
        passportError: 'Пользователь с таким паспортом уже существует',
        pinflError: 'Пользователь с таким ПИНФЛ уже существует',
        updateUser: 'Обновить пользователя',
        serial: 'Серия',
        number: 'Номер',
        phone: 'Номер телефона',
        role: 'Роль',
        firstName: 'Имя',
        lastName: 'Фамилия',
        middleName: 'Отчество',
        dateOfBirth: 'Дата рождения',
        pinfl: 'ПИНФЛ',
        getToken: 'Получить токен',
        back: 'Назад',
        save: 'Сохранить',
      },
      UpdateStatusPage: {
        updateStatus: 'Обновить статус',
        type: 'Выберите тип',
        queue: 'Выберите очередь',
        pass: 'Пропуск',
        pay: 'Оплата',
        name: 'Название',
        titleLat: 'Заголовок на узбекском (латиница)',
        titleCyr: 'Заголовок на узбекском (кириллица)',
        titleRu: 'Заголовок на русском',
        order: 'Порядок',
        back: 'Назад',
        update: 'Обновить',
        vehicleType: 'Тип транспортного средства',
      },
      UpdatePracticePenaltyPage: {
        updatePenalty: 'Обновить штрафные баллы',
        nameLat: 'Название на узбекском (латиница)',
        nameCyr: 'Название на узбекском (кириллица)',
        nameRu: 'Название на русском',
        points: 'Баллы',
        cancel: 'Отмена',
        save: 'Сохранить',
        code: 'Код',
        codeError: 'Данный код уже существует',
      },
      UpdatePracticeExercisesPage: {
        updateExercise: 'Обновить упражнение',
        nameLat: 'Название на узбекском (латиница)',
        nameCyr: 'Название на узбекском (кириллица)',
        nameRu: 'Название на русском',
        cancel: 'Отмена',
        save: 'Сохранить',
        code: 'Код',
        codeError: 'Данный код уже существует',
      },
      UpdateErrorTypePage: {
        fillFields: 'Заполните поля',
        errorTypeChanged: 'Тип ошибки изменен',
        error: 'Произошла ошибка, попробуйте позже',
        updateErrorType: 'Изменить тип ошибки',
        nameCyr: 'Название на узбекском (кириллица)',
        nameLat: 'Название на узбекском (латиница)',
        nameRu: 'Название на русском',
        back: 'Назад',
        save: 'Сохранить',
      },
      UpdateDocPage: {
        required: 'Обязательный/Не обязательный',
        nameConflict: 'Документ с таким названием уже существует',
        fillFields: 'Заполните поля',
        docUpdated: 'Документ изменен',
        error: 'Произошла ошибка, попробуйте позже',
        updateDocument: 'Редактировать документ',
        docName: 'Название документа',
        nameCyr: 'Название на узбекском (кириллица)',
        nameLat: 'Название на узбекском (латиница)',
        nameRu: 'Название на русском',
        back: 'Назад',
        save: 'Сохранить',
      },
      UpdateCategoryPage: {
        fillFields: 'Заполните поля',
        categoryUpdated: 'Категория изменена',
        error: 'Произошла ошибка, попробуйте позже',
        updateCategory: 'Редактировать категорию',
        data: 'Данные',
        statuses: 'Статусы',
        categoryName: 'Название категории',
        nameCyr: 'Название на узбекском (кириллица)',
        nameLat: 'Название на узбекском (латиница)',
        nameRu: 'Название на русском',
        order: 'Порядок',
        selectDocuments: 'Выберите документы',
        back: 'Назад',
        save: 'Сохранить',
        vehicleTypes: 'Типы транспортных средств',
      },
      ApplicationHistoryPage: {
        branch: 'Филиал',
        actions: 'Действие',
        more: 'Подробнее',
        applicationHistory: 'История заявки',
        history: 'История',
        result: 'Результат',
        success: 'Правильно',
        fail: 'Неверно',
        answer: 'Ответ',
        question: 'Вопрос',
        ticketNumber: 'Номер билета',
        createdDate: 'Дата создания',
        statuses: 'Статусы',
        transactions: 'Транзакции',
        results: 'Результаты',
        oldStatus: 'Предыдущий статус',
        nextStatus: 'Следующий статус',
        currentStatus: 'Текущий статус',
        category: 'Категория',
        errorMessage: 'Заблокировано успешно',
        error: 'Ошибка, попробуйте позже',
        sent: 'Отправлено',
        dateSendingToGai: 'Дата отправки в гаи',
        lastSubmissionDate: 'Дата последней отправки',
        status: 'Статус ГАИ',
        message: 'Сообщение',
        appeal: 'Апелляция',
        resend: 'Переотправить',
        block: 'Заблокировать',
        unblock: 'Разблокировать',
        attempt: 'Попытка',
        yesNo: 'Успешно / Нет',
      },
      UpdateApplicationPage: {
        resident: 'Гражданин РУз',
        noResident: 'Иностранец',
        isForeigner: 'Гражданин РУз / Иностранец',
        time: 'Время',
        branch: 'Филиал',
        choiceBranch: 'Выберите филиал',
        residencePlace: 'Место проживания',
        more: 'Подробнее о заявке',
        uploadDocuments: 'Заполните документы',
        notInList: 'Нет в списке',
        enterSchoolName: 'Введите название автошколы',
        choiceSchool: 'Выберите автошколу',
        selectLanguage: 'Выберите язык прохождения экзамена',
        visitDateNotValid: 'Не верная дата визита в центр',
        visitDate: 'Дата визита в центр',
        verification: 'Верифицированный пользователь',
        confirmedApplication: 'Заявка подтверждена',
        printCertificate: 'Распечатать сертификат',
        correctPhone: 'Введите корректный номер телефона',
        userNotReceived: 'Не получены данные пользователя',
        fillFields: 'Заполните поля',
        vehicleType: 'Укажите тип транспортного средства',
        applicationsUpdated: 'Заявка изменена',
        error: 'Произошла ошибка, попробуйте позже',
        canceledApplication: 'Отмените заявку',
        passportConflict: 'Пользователь с таким паспортом уже существует',
        applicationRejected: 'Заявка отклонена',
        application: 'Заявка',
        updateApplication: 'Изменить заявку',
        cancelApp: 'Отменить и сохранить заявку',
        save: 'Сохранить',
        appData: 'Данные заявки',
        transport: 'Транспорт',
        userData: 'Данные пользователя',
        userPhone: 'Введите номер телефона пользователя',
        passportSeries: 'Серия паспорта',
        passportNumber: 'Номер паспорта',
        pinfl: 'ПИНФЛ',
        firstName: 'Имя',
        lastName: 'Фамилия',
        middleName: 'Отчество',
        dateOfBirth: 'Дата рождения',
        back: 'Назад',
        phone: 'Телефон',
        category: 'Категория',
        transportType: 'Тип транспорта',
        reasonsRejectedApp: 'Причины отклонения заявки',
        docsList: 'Список документов',
        passIssue: 'Оформить пропуск',
        selectCategoryAndTryAgain: 'Выберите категорию и попробуйте снова',
        passIssued: 'Пропуск оформлен',
        confirmApplication: 'Подтвердить и сохранить заявку',
        errorTryLater: 'Ошибка попробуйте позже',
        conflictPinfl: 'Пользователь с таким ПИНФЛ уже существует',
        conflictSerialNumber:
          'Пользователь с такой серией и номером уже существует',
        conflictPhone: 'Пользователь с таким номером телефона уже существует',
        requestChanges: 'Запросить изменения',
        blacklisted: 'В черный список',
        unblock: 'Разблокировать',
        reason: 'Укажите причину добавления кандидата в черный список',
        note: 'заметку',
        update: 'Изменить',
        add: 'Добавить',
        submitAReport: 'Подать рапорт',
        CREATED: 'Создан',
        NOT_VERIFIED: 'Не подтвержден',
        T_PAYMENT: 'Оплатите за экзамен теория',
        T_EXAM: 'Сдайте экзамен теория',
        T_FAILED: 'Вы провалили теоретический экзамен',
        P_PAYMENT: 'Оплатите за экзамен практика',
        P_EXAM: 'Сдайте экзамен практика',
        P_FAILED: 'Вы провалили практический экзамен',
        COMPLETED: 'Успешно окончен',
        appeal: 'Апелляция',
        noVerified: 'Не верифицированная',
        verified: 'Верифицированная',
        passportValidity: 'Cрок паспорта',
        medCertificateValidity: 'Срок мед. справки',
      },
      TransactionsPage: {
        transactions: 'Транзакции',
        fio: 'Ф.И.О',
        paymentDate: 'Дата оплаты',
        paymentType: 'Тип оплаты',
        sum: 'Сумма',
        passport: 'Паспортные данные',
        pinfl: 'ПИНФЛ',
        id: 'ID',
        cardNumber: 'Карта(4 посл цифры)',
        datails: 'Детали',
        cashierName: 'Ф.И.О кассира',
        date: 'Дата',
        transactionsStatus: 'Статус транзакции',
        transactionsType: 'Тип транзакции',
        search: 'Поиск',
        clear: 'Очистить',
        CASH: 'Наличные',
        TERMINAL: 'Терминал',
        PAYME: 'Payme',
        CLICK: 'Сlick',
        REFUND: 'Возврат',
        FREE: 'Бесплатно',
        UZCARD: 'UZCARD',
        HUMO: 'HUMO',
        BANK: 'BANK',
        EPOS: 'EPOS',
        THEORY_PAYMENT: 'Теоретический экзамен',
        PRACTICE_PAYMENT: 'Практический экзамен',
        examType: 'Тип экзамена',
        createdAt: 'C',
        endDate: 'По',
        branch: 'Филиал',
        appId: 'ID заявки',
        qrCode: 'QR код',
        exportExcel: 'Экспортировать в EXCEL',
        totalSum: 'Общая сумма',
        failedTheTheory: 'Провалил теорию',
        retake: 'Пересдача',
        paymentOnAnotherDay: 'Оплата в другой день',
        applyForRefund: 'Подать на возврат',
        changeTransactionType: 'Изменить тип транзакции',
        go: 'Перейти',
        transactionType: 'Тип транзакции',
        change: 'Изменить',
        QR: 'QR'
      },
      StatusesPage: {
        categoryDeleted: 'Категория удалена',
        error: 'Произошла ошибка, попробуйте позже',
        statuses: 'Статусы',
        order: 'Порядок',
        name: 'Название',
        titleLat: 'Название на узбекском (латиница)',
        titleCyr: 'Название на узбекском (кириллица)',
        titleRu: 'Название на русском',
        pass: 'Пропуск',
        actions: 'Действия',
        wantDeleteStatus: 'Вы действительно хотите удалить cтатус?',
      },
      PracticePenaltiesPage: {
        penaltiesDeleted: 'Штрафные баллы удалены',
        error: 'Произошла ошибка, попробуйте позже',
        penalties: 'Штрафы',
        nameLat: 'Название на узбекском (латиница)',
        nameCyr: 'Название на узбекском (кириллица)',
        nameRu: 'Название на русском',
        penaltyPoints: 'Штрафные очки',
        actions: 'Действия',
        code: 'Код',
        wantDeletePenalty: 'Вы действительно хотите удалить штрафные баллы?',
      },
      PracticeExercisesPage: {
        exserciseDeleted: 'Упражнение удалено',
        error: 'Произошла ошибка, попробуйте позже',
        praticeExercises: 'Практические упражнения',
        titleLat: 'Заголовок на узбекском (латиница)',
        titleCyr: 'Заголовок на узбекском (кириллица)',
        titleRu: 'Заголовок на русском',
        wantDeleteExercise: 'Вы действительно хотите удалить упражнение?',
        code: 'Код',
      },
      PaymentPage: {
        payment: 'Оплата',
        search: 'Найти',
        fio: 'Ф.И.О',
        categories: 'Категория',
        statuses: 'Статус',
        certificate: 'Сертификат',
        printCertificate: 'Распечетать сертификат',
        sum: 'Сумма',
        allSum: 'Вся сумма',
        cash: 'НАЛИЧНЫЕ',
        bankCard: 'ТЕРМИНАЛ',
        pay: 'Оплатить',
        payDate: 'Дата оплаты',
        paymentType: 'Тип оплаты',
        error: 'Ошибка',
        lastDigitsOfBankCard: 'Посл 4 цифры банк карты',
      },
      ErrorTypesPage: {
        name: 'Название',
        createdAt: 'Дата создания',
        actions: 'Действия',
        errorTypeDeleted: 'Тип ошибки удален',
        error: 'Произошла ошибка, попробуйте позже',
        errors: 'Ошибки',
      },
      MotordromesPage: {
        motordromeDeleted: 'Автодром удален',
        error: 'Произошла ошибка, попробуйте позже',
        wantDeleteMotordrome: 'Вы действительно хотите удалить автодром?',
        motordromes: 'Автодромы',
        name: 'Название',
        createdAt: 'Дата создания',
        actions: 'Действия',
      },
      SchoolPage: {
        tin: 'ИНН',
        schoolDeleted: 'Школа удалена',
        error: 'Произошла ошибка, попробуйте позже',
        wantDeleteSchool: 'Вы действительно хотите удалить школу?',
        search: 'Поиск',
        clear: 'Очистить',
        schools: 'Школы',
        enterName: 'Введите название для поиска',
        name: 'Название',
        createdAt: 'Дата создания',
        actions: 'Действия',
      },
      DocsPage: {
        docDeleted: 'Документ удален',
        error: 'Произошла ошибка, попробуйте позже',
        wantDeleteDoc: 'Вы дейтвительно хотите удалить документ?',
        docs: 'Документы',
        name: 'Название',
        createdAt: 'Дата создания',
        actions: 'Действия',
      },
      CreateVehicleTypePage: {
        fillFields: 'Заполните поле',
        createdVahicleType: 'Транспортная категория создана',
        createCategory: 'Создать категорию по вождению автомобиля',
        name: 'Введите название',
        back: 'Назад',
        save: 'Сохранить',
      },
      CreateStatusPage: {
        createStatus: 'Создать статус',
        type: 'Выберите тип',
        queue: 'Выберите очередь',
        pass: 'Пропуск',
        payment: 'Оплата',
        name: 'Название',
        titleLat: 'Название на узбекском (латиница)',
        titleCyr: 'Название на узбекском (кириллица)',
        titleRu: 'Название на русском',
        order: 'Порядок',
        back: 'Назад',
        save: 'Сохранить',
        vehicleType: 'Тип транспортного средства',
      },
      CreatePracticePenaltyPage: {
        createPenalty: 'Создать штрафные баллы',
        nameLat: 'Название на узбекском (латиница)',
        nameCyr: 'Название на узбекском (кириллица)',
        nameRu: 'Название на русском',
        scores: 'Баллы',
        cancel: 'Отмена',
        save: 'Сохранить',
        code: 'Код',
        codeError: 'Данный код уже существует',
      },
      CreatePracticeExercisesPage: {
        createExercisse: 'Создать упражнение',
        nameLat: 'Название на узбекском (латиница)',
        nameCyr: 'Название на узбекском (кириллица)',
        nameRu: 'Название на русском',
        cancel: 'Отмена',
        save: 'Сохранить',
        code: 'Код',
        codeError: 'Данный код уже существует',
      },
      CreateErrorTypePage: {
        fillFields: 'Заполните поля',
        error: 'Произошла ошибка, попробуйте позже',
        errorCreateSuccesed: 'Тип ошибки создан успешно',
        createError: 'Создать тип ошибки',
        nameCyr: 'Название на узбекском (кириллица)',
        nameLat: 'Название на узбекском (латиница)',
        nameRu: 'Название на русском',
        back: 'Назад',
        save: 'Сохранить',
      },
      UpdateMotordromePage: {
        nameCyr: 'Название на узбекском (кириллица)',
        nameLat: 'Название на узбекском (латиница)',
        nameRu: 'Название на русском',
        conflictError: 'Автодром в данной очереди уже существует',
        selectQueue: 'Выберите очередь',
        updateMotordrome: 'Изменить автодром',
        fillFields: 'Заполните поля',
        error: 'Произошла ошибка, попробуйте позже',
        updatedMotordrome: 'Автодром изменен',
        name: 'Название автодрома',
        back: 'Назад',
        save: 'Сохранить',
        vehicleTypes: 'Типы транспортного средства',
      },

      CreateMotordromePage: {
        conflictError: 'Автодром в данной очереди уже существует',
        selectQueue: 'Выберите очередь',
        fillFields: 'Заполните поля',
        error: 'Произошла ошибка, попробуйте позже',
        motordromeCreatedSuccess: 'Автодром создан успешно',
        createMotordrome: 'Создать автодром',
        nameCyr: 'Название на узбекском (кириллица)',
        nameLat: 'Название на узбекском (латиница)',
        nameRu: 'Название на русском',
        name: 'Название автодрома',
        back: 'Назад',
        save: 'Сохранить',
        vehicleTypes: 'Типы транспортного средства',
      },
      UpdateSchoolPage: {
        tin: 'ИНН',
        conflict: 'Школа уже существует',
        tinConflict: 'Школа с таким ИНН уже существует',
        fillFields: 'Заполните поля',
        error: 'Произошла ошибка, попробуйте позже',
        name: 'Название школы',
        save: 'Сохранить',
        back: 'Назад',
        updateSchool: 'Изменить школу',
        updatedSchool: 'Школа изменена',
      },
      CreateSchoolPage: {
        tin: 'ИНН',
        conflict: 'Школа уже существует',
        fillFields: 'Заполните поля',
        error: 'Произошла ошибка, попробуйте позже',
        schoolCreatedSuccess: 'Школа создана успешно',
        createSchool: 'Создать школу',
        name: 'Название',
        save: 'Сохранить',
        back: 'Назад',
      },
      CreateDocPage: {
        required: 'Обязательный/Не обязательный',
        nameConflict: 'Документ с таким названием уже существует',
        fillFields: 'Заполните поля',
        error: 'Произошла ошибка, попробуйте позже',
        docCreateSuccesed: 'Документ создан успешно',
        createDoc: 'Создать документ',
        nameCyr: 'Название на узбекском (кириллица)',
        nameLat: 'Название на узбекском (латиница)',
        nameRu: 'Название на русском',
        name: 'Название документа',
        back: 'Назад',
        save: 'Сохранить',
      },
      CreateCategoryPage: {
        fillFields: 'Заполните поля',
        error: 'Произошла ошибка, попробуйте позже',
        categoryCreatSuccessed: 'Категория создана успешно',
        createdCategory: 'Создать категорию',
        categoryName: 'Название категории',
        nameCyr: 'Название на узбекском (кириллица)',
        nameLat: 'Название на узбекском (латиница)',
        nameRu: 'Название на русском',
        order: 'Порядок',
        selectDocuments: 'Выберите документы',
        back: 'Назад',
        save: 'Сохранить',
        vehicleTypes: 'Типы транспортных средств',
      },
      CreateApplicationPageByUser: {
        resident: 'Гражданин РУз',
        noResident: 'Иностранец',
        isForeigner: 'Гражданин РУз / Иностранец',
        choiceBranch: 'Выберите филиал',
        residencePlace: 'Место проживания',
        enterSchoolName: 'Введите название школы',
        notInList: 'Нет в списке',
        choiceSchool: 'Выберите автошколу',
        fillFields: 'Заполните поля',
        selectLanguage: 'Выберите язык прохождения экзамена',
        visitDateNotValid: 'Не верная дата визита в центр',
        visitDate: 'Дата визита в центр',
        fillDocs: 'Заполните документы',
        selectCategory: 'Выберите категорию',
        applicationSuccessCreated: 'Заявка создана успешно',
        error: 'Произошла ошибка, попробуйте позже',
        vehicleType: 'Укажите тип транспортного средства',
        createApplication: 'Создать заявку',
        selectVehicleType: 'Выберите тип транспорта',
        documentList: 'Список документов',
        back: 'Назад',
        save: 'Сохранить',
        applicationAlreadyExists: 'Заявка с такой категорией уже существует',
        time: 'Время',
      },
      CreateApplicationPage: {
        send: 'Отправить',
        resident: 'Гражданин РУз',
        noResident: 'Иностранец',
        isForeigner: 'Гражданин РУз / Иностранец',
        residencePlace: 'Место проживания',
        notInList: 'Нет в списке',
        enterSchoolName: 'Введите название автошколы',
        choiceSchool: 'Выберите автошколу',
        clear: 'Очистить',
        selectLanguage: 'Выберите язык прохождения экзамена',
        fillFields: 'Заполните поля',
        vehicleType: 'Укажите тип транспортного средства',
        uploadDocuments: 'Загрузите документы',
        applicationSuccessCreated: 'Заявка создана успешно',
        applicationAlreadyExists: 'Заявка с такой категорией уже существует',
        error: 'Произошла ошибка, попробуйте позже',
        userNotFound: 'Пользователь не найден',
        createApplication: 'Создать заявку',
        enterPhoneNumber: 'Введите номер телефона пользователя',
        pinfl: 'ПИНФЛ',
        passportSerial: 'Серия паспорта',
        passportNumber: 'Номер паспорта',
        selectCategory: 'Выберите категорию',
        selectVehicleType: 'Выберите тип транспорта',
        userData: 'Данные пользователя',
        firstName: 'Имя',
        lastName: 'Фамилия',
        middleName: 'Отчество',
        dateOfBirth: 'Дата рождения',
        documentList: 'Список документов',
        back: 'Назад',
        save: 'Сохранить',
        passIssued: 'Пропуск оформлен',
        choiceCategory: 'Выберите категорию',
        enterPassport: 'Введите серию и номер паспорта',
        errorPinfl: 'Ошибка в поле ПИНФЛ',
        errorPhone: 'Ошибка в поле номер телефона',
        passportExp: 'Срок паспорта',
        medicalCertValid: 'Срок мед. справки',
        getData: 'Получить данные',
      },
      CategoriesPage: {
        deletedCategory: 'Категория удалена',
        error: 'Произошла ошибка',
        wantDeleteCategory: 'Вы действительно хотите удалить категорию?',
        categories: 'Категории',
        name: 'Название',
        createdAt: 'Дата создания',
        actions: 'Действия',
      },
      CashPayment: {
        cashPayment: 'Оплата наличными',
        fio: 'Ф.И.О',
        passport: 'Серия/номер паспорта',
        pinfl: 'ПИНФЛ',
        date: 'Дата оплаты',
        sum: 'Сумма оплаты',
        details: 'Детали',
        amountEnclosed: 'Инкассированная сумма',
        dateEnclosed: 'Дата инкасации',
        fioCashier: 'ФИО кассира, принимающего оплату',
        idMachine: 'Идентификационный номер платежного аппарата',
      },
      BankCardPayment: {
        cardPayment: 'Оплата банк картой',
        fio: 'Ф.И.О',
        passport: 'Серия/номер паспорта',
        pinfl: 'ПИНФЛ',
        date: 'Дата оплаты',
        sum: 'Сумма оплаты',
        details: 'Детали',
        lastNumber: 'Последние 4 цифры карты',
        fioCashier: 'ФИО кассира, принимающего оплату',
        idMachine: 'Идентификационный номер платежного аппарата',
      },
      ApplicationsPage: {
        operator: 'Оператор',
        branch: 'Филиал',
        application: 'Заявки',
        clear: 'Очистить',
        search: 'Найти',
        fio: 'Ф.И.О',
        phone: 'Телефон',
        appCode: 'Код заявки',
        passCode: 'Номер пропуска',
        status: 'Статус',
        category: 'Категория',
        transportType: 'Тип транспорта',
        updatedAt: 'Дата изменения',
        actions: 'Действия',
        serial: 'Серия',
        number: 'Номер',
        pinfl: 'ПИНФЛ',
        createdAt: 'C',
        endDate: 'По',
        firstName: 'Имя',
        lastName: 'Фамилия',
        middleName: 'Отчество',
        categories: 'Категория',
        vehicleTypes: 'Тип транспортного средства',
        statuses: 'Статус',
        creationType: 'Тип заявки',
        choiceSchool: 'Выберите школу',
        dateOfBirth: 'Дата рождения',
        CREATED: 'Создан',
        NOT_VERIFIED: 'Не подтвержден',
        T_PAYMENT: 'Оплатите за экзамен теория',
        T_EXAM: 'Сдайте экзамен теория',
        T_FAILED: 'Вы провалили теоретический экзамен',
        P_PAYMENT: 'Оплатите за экзамен практика',
        P_EXAM: 'Сдайте экзамен практика',
        P_FAILED: 'Вы провалили практический экзамен',
        COMPLETED: 'Успешно окончен',
        blocked: 'Заблокирован',
      },
      auth: {
        notFoundUser: 'Номер телефона не найден',
        enterOtpCode: 'Введите код смс',
        passwordNotConfirmed: 'Пароли не совпадают',
        passwordNotValid: 'Длина пороля должена быть не менее 6 символов',
        login: 'Войти',
        phoneNumber: 'Номер телефона',
        password: 'Пароль',
        forgotPassword: 'Забыли пароль',
        confirmPassowrd: 'Подтвердитe пароль',
        register: 'Регистрация',
        resetPassword: 'Сбросить пароль',
        send: 'Отправить',
        confirmOffer: 'Подтвердите публичную оферту',
        enterCode: 'Введите смс код',
        newPassword: 'Новый пароль',
        smsCodeReplay: 'Отправить смс заново',
        sendCodeToMobile: 'На ваш номер отправлено смс с кодом',
        sendSmsLater: 'Повторить отправку смс через',
        sendSmsAgain: 'Повторить отправку СМС',
        authSuccess: 'Авторизация прошла успешно',
        error: 'Проверьте правильность заполнения данных',
        notValidLoginOrPassword: 'Неверный логин или пароль',
        tryLaterAgain: 'Ошибка, попробуйте позже',
        editedPassword: 'Пароль изменен!',
        registed: 'Зарегистрироваться',
        codeNotValid: 'Неверный смс код',
        registrationSuccess: 'Регистрация прошла успешно',
        alreadyUser: 'Пользователь уже существует',
        repeatPassword: 'Повторите пароль',
        offer: 'Публичная оферта',
        back: 'Назад',
        cancel: 'Отмена',
        sendCode: 'Отправить код',
        checkCorrectData: 'Проверьте правильность заполнения данных',
        passwordChanged: 'Пароль изменен',
      },
      updateQueuePage: {
        choiceBranch: 'Выберите филиал',
        choiceQueueType: 'Выберите тип очереди',
        queueUpdated: 'Очередь изменена',
        practice: 'Практика',
        theory: 'Теория',
        fillFields: 'Заполните поля',
        tryAgainLater: 'Произошла ошибка, попробуйте позже',
        updateQueue: 'Изменить очередь',
        nameOz: 'Название на узбекском (кирилица)',
        nameUz: 'Название на узбекском (латиница)',
        nameRu: 'Название на русском',
        back: 'Назад',
        save: 'Сохранить',
      },
      createQueuePage: {
        choiceBranch: 'Выберите филиал',
        choiceQueueType: 'Выберите тип очереди',
        queueCreated: 'Очередь создана успешно',
        practice: 'Практика',
        theory: 'Теория',
        fillFields: 'Заполните поля',
        tryAgainLater: 'Произошла ошибка, попробуйте позже',
        createQueue: 'Создать очередь',
        nameOz: 'Название на узбекском (кирилица)',
        nameUz: 'Название на узбекском (латиница)',
        nameRu: 'Название на русском',
        back: 'Назад',
        save: 'Сохранить',
      },
      carsPage: {
        filter: 'Фильтр',
        choiceMotordrome: 'Выберите автодром',
        search: 'Найти',
        number: 'Номер',
        model: 'Модель',
        category: 'Категория',
        cars: 'Автомобили',
      },
      timeslotsPage: {
        reserved: 'Зарезервировано',
        capacity: 'Вместимость',
        timeslotDeleted: 'Время приема удалено',
        createTimeslot: 'Создать время приема',
        save: 'Сохранить',
        back: 'Назад',
        timeslotUpdated: 'Время приема изменено',
        updateTimeslot: 'Изменить время приема',
        updatedDate: 'Дата изменения',
        actions: 'Действия',
        fromTime: 'C',
        toTime: 'По',
        branch: 'Филиал',
        choiceBranch: 'Выберите филиал',
        reservedAndCapacity: 'Зарезервировано / Вместимость',
        search: 'Поиск',
        timeslots: 'Время приема',
        addTimeslot: 'Добавить время приема',
        date: 'Дата',
        deleteTimeslot: 'Удалить время приема',
        confirmDelete: 'Вы действительно хотите удалить это время приема?',
        createdTimeslot: 'Время приема успешно создано',
        confirmDeleteTimeslot:
          'Вы действительно хотите удалить это время приема?',
        fillFields: 'Заполните поля',
        savedData: 'Данные сохранены',
      },
      queuePage: {
        branches: 'Филиал',
        confirmDelete: 'Удалить из очереди?',
        confirmLogout: 'Вы действительно хотите выйти?',
        usersCount: 'Количество людей в очереди',
        classRoom: 'Кабинет',
        selectClassRoom: 'Выберите кабинет',
        emptyQueue: 'Очередь пуста',
        confirmDeleteQueue: 'Вы действительно хотите удалить эту очередь?',
        selectQueue: 'Выберите очередь',
        clearedQueue: 'Очередь очищена',
        clear: 'Очистить',
        enterCount: 'Введите количество',
        power: 'Запустить',
        name: 'Название',
        updateDate: 'Дата изменения',
        actions: 'Действия',
        notAccept: 'Отказано в доступе, обратитесь в ресепшн',
        passNotValid: 'Пропуск не действителен',
        deletedQueue: 'Очередь удалена',
        queue: 'Очередь',
        timeslots: 'Время приема',
      },
    },
  },
  oz: {
    general: {
      instance: {
        noAccess: 'Кириш тақиқланган',
        login: 'Тизимга киринг',
        uploadDocuments: 'Хужжатларни юкланг',
      },
    },
    components: {
      ScheduleQueue: {
        of: "та жойдан",
        available: 'таси бўш'
      },
      CheckQueue: {
        fio: 'Ф.И.Ш',
        title: 'Навбатингизни текширинг',
        dateOfBirth: 'Туғилган кунингизни киритинг',
        pass: 'Талон рақамини киритинг',
        save: 'Сақлаш',
        notFound: 'Мурожаатингиз топилмади',
        date: 'Сана',
        time: 'Вақт',
        datePlaceholder: 'кк.оо.yyyy',
        qrTitle: 'QR кодли утиш ракамини сканерга теккизинг',
        dateError: 'Туғилган сана нотўғри кўрсатилган.'
      },
      TimeSlots: {
        noPlaces: 'Жой йўқ',
        choose: 'Танламоқ',
        of: "та жойдан",
        available: 'таси бўш'
      },
      ReserveQueue: {
        selectCurrentTime: 'Жорий вақтни танланг',
        conflict: 'Аризангиз аллақачон навбатга қўшилган',
        dateOfBirth: 'Туғилган кунингизни киритинг',
        pass: 'Талон рақамини киритинг',
        save: 'Сақлаш',
        title: 'Навбатни банд қилмоқ',
        success: 'Сиз электрон навбатга киритилдингиз',
        error: 'Ошибка, попробуйте позже',
        deleteApp: 'Эски қайд ўчириб ташлансинми?',
        datePlaceholder: 'кк.оо.yyyy',
        notFound: 'Мурожаатингиз топилмади',
        qrTitle: 'QR кодли чекни сканерга теккизинг',
        dateError: 'Туғилган сана нотўғри кўрсатилган.',
        ageValidation: 'Номзод 18 ёшга тўлмаган',
        blackList: 'Қора рўйхатдаги номзод',
        expire083: 'Мед маълумотнома муддати тугаган',
        expirePassport: 'Паспортнинг амал қилиш муддати тугаган',
        appNotVerified: 'Ариза тасдиқланмади',
        wrongTimeslot: 'Tanlangan vaqtga navbat mavjud emas. Navbatga yozilish vaqti soat {{times}} ga belgilangan.',
      },
      Header: {
        prompt: 'Сиз ростдан чиқиб кетмоқчимисиз?',
      },
      transactionModal: {
        replenished: 'Пополнение',
        writeOff: 'Списание',
        actionType: 'Действие',
        pay: 'Оплата',
        payme: 'Payme',
        click: 'Click',
        terminal: 'Терминал',
        cash: 'Наличные',
        title: 'Транзакции',
        transactionType: 'Тип',
        amount: 'Сумма',
        status: 'Статус',
        payDate: 'Дата оплаты',
        completed: 'Успешно',
        failed: 'Ошибка',
      },
      resultsModal: {
        seeApp: 'Посмотреть заявку',
        attempt: 'Попытка',
        success: 'Вы успешно прошли практический экзамен, ваш результат',
        result: 'Ваш результат',
        print: 'Распечатать экз лист',
        exercise: 'Упражнение',
        name: 'Название',
        penaltyPoints: 'Штрафные баллы',
        total: 'Всего',
        theorySuccess: 'Вы успешно прошли теоретический экзамен, ваш результат',
        ticketNumber: 'Номер билета',
        question: 'Вопрос',
        selectedAnswer: 'Выбранный ответ',
        results: 'Результат',
      },
      newApplicationNotice: {
        newNotice: 'Янги онлайн ариза',
        open: 'Кўриш',
        close: 'Закрыть',
      },
      passModal: {
        enterPassNumber: 'Бейжик рақамини киритинг',
        save: 'Сақлаш',
      },
      pagination: {
        rowsPerPage: 'Саҳифадаги сони',
      },
      queueList: {
        car: 'Автомобиль',
        classRoom: 'Аудитория',
        choiceCar: 'Автомобилни танланг',
        call: 'Чақириш',
        cancel: 'Бекор қилиш',
        delete: 'Ўчириш',
        category: 'Тоифа',
      },
      //fix
      TimeLine: {
        tests: 'Тест-синовлар',
        right: 'Тўғри',
        wrong: 'Нотўғри',
        total: 'Жами йиғилган баллар',
        startDate: 'Бошлаш санаси',
        attempts: 'Уринишлар',
        carNumber: 'Машина рақами',
        penaltyPoints: 'Жарима баллари',
        CREATED: 'Яратилган',
        NOT_VERIFIED: 'Тасдиқланмаган',
        T_PAYMENT: 'Назарий имтиҳон учун тўланг',
        T_EXAM: 'Назариядан имтиҳон топшириш',
        T_FAILED: 'Назарий имтиҳондан йиқилдингиз',
        P_PAYMENT: 'Амалиёт имтиҳони учун тўланг',
        P_EXAM: 'Амалиёт имтиҳонини топшириш',
        P_FAILED: 'Сиз амалий имтиҳондан йиқилдингиз',
        COMPLETED: 'Якунланди',
        theoryEndDate: 'Назариянинг тугаш санаси',
      },
      Sidebar: {
        reports: 'Протоколлар',
        responsiblePerson: 'Ответственные лица',
        schools: 'Мактаблар',
        enterName: 'Қидириш учун ном киритинг',
        control: 'Навбатни бошқариш',
        classRooms: 'Кабинет',
        cars: 'Автомобиллар',
        queue: 'Навбат',
        users: 'Фойдаланувчилар',
        categories: 'Тоифалар',
        docs: 'Хужжатлар',
        applications: 'Аризалар',
        statuses: 'Статуслар',
        practiceCategory: 'Транспорт воситалари турлари',
        payment: 'Тўлов',
        passedExam: 'Имтиҳондан ўтганлар',
        cashPayment: 'Нақд тўлов',
        userId: 'Фойдаланувчини аниқлаш',
        visitLogs: 'Ташрифлар рўйхати',
        motordromes: 'Автодром',
        errors: 'Хатолар',
        transactions: 'Транзакциялар',
        verrifyApps: 'Ҳақиқийлиги тасдиқланган аризалар',
        generatReport: 'Умумий ҳисобот',
        generalStatistics: 'Статистика отчет',
        schoolStatistics: 'Мактаблар статистикаси',
        gaiSchoolsReport: 'ЙҲХББнинг мактаблар бўйича ҳисоботи',
        sumarry: 'Хулоса',
        appeals: 'Апелляция',
        report: 'Рапортлар',
        vising: 'Визинг',
        requestForChangeData: 'Маълумотларни ўзгартириш бўйича сўровлар',
        certificates: 'Сертификатлар',
        certificatesHistory: 'История сертификата',
        calendar: 'Тақвим',
        fines: 'Жарималар',
        reception: 'Қабул',
        security: 'Xaвфсизлик',
        accounting: 'Бухгалтерия хисоби',
        cash: 'Касса',
        statistics: 'Статистика',
        integrationWithGai: 'Интеграция с гаи',
        practicalStatisticByCategory: 'Статистика ПЭ по категориям',
        timeslots: 'Вақт бўлаклари',
      },
      CategoryStatuses: {
        statusDeleted: 'Статус ўчирилган',
        erorrTryAgain: 'Хатолик юз берди. Яна бир бор уриниб кўринг',
        wantToRemove: 'Сиз ҳақиқатан ҳам тоифани статусини ўчирмоқчимисиз?',
        add: 'Тоифани статусини қўшиш',
        status: 'Статус',
        successStatus: 'Муваффақиятли натижани статуси',
        failureStatus: 'Муваффақиятсиз натижани статуси',
        order: 'Тартиб',
        start: 'Бошланди',
        finished: 'Тугади',
        createdAt: 'Яратилган санаси',
        actions: 'Ҳаракатлар',
      },
      Confirmation: {
        cancel: 'Бекор қилиш',
        success: 'Тасдиқлаш',
      },
      FileUploader: {
        fileSize: 'Файл ҳажми жуда катта',
        selectDocument: 'Хужжатни танлаш',
        selectAnotherDocument: 'Бошқа хужжатни танлаш',
        scanning: 'Сканерлаш',
        getDocument: 'Ҳужжатни олинг',
        enterPinfl: 'Пинфлни киритинг',
        enterVehicleType: 'Автомобил турини танланг',
        documentReceived: 'Ҳужжат қабул қилинди',
        docNotFound: 'Ҳужжат топилмади',
        error: 'Хато, илтимос, кейинроқ қайта уриниб кўринг',
      },
      FileUploads: {
        certificateFromSchool: 'Справка с автошколы',
        mainPassport: 'Паспорт',
        photo: 'Фотосурат',
        passport: 'Паспорт/ID карта (прописка билан)',
        employerReferral: 'Иш берувчининг йўлланмаси',
        replacement:
          'Ягона намунадаги гувоҳнома ёки узлуксиз ҳайдовчилик меҳнат фаолияти 10 йилдан ортиқ бўлган «B» ва «C» тоифали ҳайдовчилик гувоҳномаси бўлган шахсларнинг ҳайдовчилик гувоҳномасини «BЕ» ва «CЕ» тоифага алмаштириш ҳайдовчининг меҳнат дафтарчасидан кўчирма асосида',
        driverLicence_1: 'Миллий ҳайдовчилик гувоҳномаси-1',
        driverLicence_2: 'Миллий ҳайдовчилик гувоҳномаси-2',
        direction: 'Ички ишлар ваколатли органининг йўлланмаси',
        honey083_1: '083-шаклдаги тиббий маълумотнома-1',
        honey083_2: '083-шаклдаги тиббий маълумотнома-2',
        diplomaAnnex:
          'Режа асосида фанларни ўзлаштирилганлиги тўғрисида диплом ва унга илова',
        nationalDriversLicence:
          'Миллий ҳайдовчилик гувоҳномаси («C», «B» ва «C», «D», «C» и «D», «СE» ва (ёки) «DE»)',
        certificateSingleSample: 'Ягона намунадаги Гувоҳнома',
        pinflForForeign: 'ЖШШИР чет эл',
        docConfirm12:
          'Тасдиқловчи ҳужжат 12 ойгача ҳайдовчилик гувоҳномасини олган',
        appForAppeal: 'Апелляция аризаси',
        decisionAppealComission: 'Апелляция комиссиясининг қарори',
        forWorkingDrivers:
          'Ишлаётган ҳайдовчилар учун - уларга бириктирилган автомототранспорт воситасининг тури кўрсатилган ҳолда меҳнат дафтарчасидан кўчирма ёки маълумотнома (буйруқдан кўчирма);',
      },
      Footer: {
        address: 'Тошкент шаҳри, Янгиҳаёт тумани, Файзли Маҳалласи, 87',
        copyRight: '2022 барча ҳуқуқлар ҳимояланган',
      },
      CreateCategoryStatuses: {
        fillFields: 'Катакларни тўлдиринг',
        createdSuccess: 'Тоифа статуси муваффақиятли яратилган',
        alreadyExistsDefault:
          '«Дастлабки» статуси билан тоифа статуси аллақачон мавжуд»',
        alreadyExistsFinish:
          '«Тугатилган» статуси билан тоифа статуси аллақачон мавжуд',
        errorTryAgain: 'Хатолик юз берди. Бир оздан кейин уриниб кўринг',
        createStatusCategory: 'Тоифа учун статус яратиш',
        selectStatus: 'Статусни танланг',
        successStatus: 'Муваффақиятли натижани статуси',
        failureStatus: 'Муваффақиятсиз натижани статуси',
        workDays: 'Қайта уринишдан олдин иш кунлари сони',
        order: 'Тартиб',
        defaultStatus: '«Дастлабки» статус',
        finished: 'Тугади',
        cancel: 'Бекор қилиш',
        save: 'Сақлаш',
      },
      UpdateCategoryStatuses: {
        fillFields: 'Катакларни тўлдиринг',
        updateSuccess: 'Тоифа статуси ўзгартирилган',
        errorTryAgain: 'Хатолик юз берди. Бир оздан кейин уриниб кўринг',
        updateStatusCategory: 'Тоифа учун статус ўзгартириш',
        selectStatus: 'Статусни танланг',
        successStatus: 'Муваффақиятли натижани статуси',
        failureStatus: 'Муваффақиятсиз натижани статуси',
        cost: 'Нарҳ',
        workDays: 'Қайта уринишдан олдин иш кунлари сони',
        order: 'Тартиб',
        defaultStatus: '«Дастлабки» статус',
        finished: 'Тугади',
        cancel: 'Бекор қилиш',
        save: 'Сақлаш',
        alreadyExistsDefault:
          '«Дастлабки» статуси билан тоифа статуси аллақачон мавжуд',
        alreadyExistsFinish:
          '«Тугатилган» статуси билан тоифа статуси аллақачон мавжуд',
      },
      TokenModal: {
        copy: 'Нусҳа олинди',
        refresh: 'Янгилаш',
      },
      UserModal: {
        userInfo: 'Фойдаланувчи ҳақида маълумот',
        FIO: 'Ф.И.Ш.',
        dateOfBirth: 'Туғилган санаси',
        passport: 'Паспорт серияси/рақами',
        pinfl: 'ЖШШИР',
        phone: 'Телефон рақами',
        cancel: 'Бекор қилиш',
        successUser: 'Фойдаланувчини тасдиқлаш',
        name: 'Номи',
        createdAt: 'Яратилган санаси',
        actions: 'Ҳаракатлар',
      },
    },
    pages: {
      ScheduleTimePage: {
        lawText: 'Diqqat: Avtomototransport vositalarini boshqarish huquqidan mahrum bo\'lgan shaxslar uchun nazariy imtihon soat {{times}} da o\'tkaziladi.',

      },
      SchedulePage: {
        checkQueue: 'Навбатингизни текширинг',
      },
      ReportsForSchool: {
        fieldNotFilled: 'Поля не заполнены',
        schoolsStat: 'Статистика автошкол',
        search: 'Поиск',
        from: 'С',
        to: 'По',
        clear: 'Очистить',
      },
      FinesDetails: {
        from: 'Дан',
        to: 'Гача',
        penalty: 'Штраф',
        yes: 'Ҳа',
        no: 'Йўқ',
        search: 'Қидириш',
        clear: 'Тозалаш',
        createdAt: 'Яратилган сана',
        appLink: 'Аризагя хавола',
        branch: 'Филиал',
        fixed: 'Белгиланган',
        details: 'Тафсилотлар',
        go: 'ўтмоқ',
      },
      FinesPage: {
        from: 'Дан',
        to: 'Гача',
        search: 'Қидириш',
        clear: 'Тозалаш',
        fullName: 'Тўлиқ исми',
        phone: 'Телефон',
        branch: 'Филиал',
        finesNumber: 'Жарималар сони',
        details: 'Тафсилотлар',
        go: 'ўтмоқ',
      },
      OfficialReportByIdPage: {
        appConfirmed: 'Ариза тасдиқланди',
        error: 'Хато, илтимос, кейинроқ қайта уриниб кўринг',
        title: 'Маълум ўзгартириш учун сўров',
        penalty: 'Жарима',
        confirm: 'Тасдиқлаш',
        confirmedBy: 'Ким томонидан тасдиқланган',
        currentData: 'Жорий маълумотлар',
        firstName: 'Номи',
        lastName: 'Фамилияси',
        middleName: 'Отасининг исми',
        dateOfBirth: 'Туғилган сана',
        passportSerial: 'Паспорт серияси',
        passportNumber: 'Паспорт рақами',
        passportValid: 'Паспорт муддати',
        dateMed: 'Тиббий маълум муддати',
        changeData: 'Маълумотларни ўзгартириш',
        fullName: 'Тўлиқ исми',
        passportSerialNumber: 'Паспорт серияси / рақами',
        pinfl: 'ЖШШИР',
        branch: 'Филиал',
        status: 'Статус',
        phone: 'Телефон',
        transactionDate: 'Битим санаси',
        cardTypeNumber: 'Карта Тури / Рақами',
        sum: 'Миқдори',
        report: 'Ҳисобот',
      },
      OfficialReportsPage: {
        title: 'Маълумотларни ўзгартириш учун сўровлар',
        completed: 'Тугалланди',
        all: 'Ҳаммаси',
        yes: 'Ҳа',
        no: 'Йўқ',
        activity: 'Фаолият',
        branch: 'Филиал',
        user: 'Фойдаланувчи',
        search: 'Қидириш',
        clear: 'Тозалаш',
        createdAt: 'Яратилган сана',
        type: 'Тури',
        appLink: 'Аризагя хавола',
        candidate: 'Номзод',
        confirmedBy: 'Ким томонидан тасдиқланган',
        status: 'Статус',
        step: 'Қадам',
        penalty: 'Жарима',
        accomplishment: 'Муваффақият',
        details: 'Тафсилотлар',
        confirmed: 'Тасдиқланган',
        new: 'Янги',
        data: 'Маълумотлар',
        refund: 'Қайтариш',
      },
      AppealPageById: {
        fio: 'Тўлиқ исми',
        passportSerial: 'Серия / паспорт рақами',
        phone: 'Телефон',
        dateOfBirth: 'Туғилган сана',
        examType: 'Имтиҳон тури',
        applicaiton: 'Ариза',
        applicaitionLink: 'Иловага ҳавола',
        title: 'Апелляция комиссиясининг қарори',
      },
      AppealsPage: {
        appeal: 'Апелляция',
        fio: 'Тўлиқ исми.',
        phone: 'Телефон',
        createdAt: 'Яратилган сана',
        examType: 'Имтиҳон тури',
        actions: 'Амаллар',
        choiceBranch: 'Филиални танланг',
        all: 'Ҳаммаси',
      },
      //fix
      ReportPage: {
        //fix
        reportHistory: 'История протокола',
        FIO: 'ФИО',
        category: 'Категория',
        school: 'Школа',
        theryAttempt: 'Попытки теория',
        thoryScore: 'Балы теория',
        practiceAttempt: 'Поптыки практика',
        practiceScore: 'Сдал/Не сдал',
        passed: 'Сдал',
        notPassed: 'Не сдал',
        certificateNumber: 'Номер сертификата',
        print: 'Распечатать',
      },
      ReportsPage: {
        enterDate: 'Санани киритинг',
        count: 'Миқдори',
        actions: 'Ҳаракат',
        createdAt: 'Яратилган сана',
        dayNumber: 'Протокол яратиш сони',
        reports: 'Протоколлар',
        generation: 'Яратиш',
        name: 'Сарлавҳа',
        date: 'Сана',
        clear: 'Тозалаш',
        search: 'Қидириш',
        branches: 'Филиаллар',
        from: 'Дан',
        protocolNumber: 'Протокол рақами',
      },
      SummaryPage: {
        branch: 'Филиал',
        from: 'Дан',
        to: 'Гача',
        branches: 'Филиаллар',
        summary: 'Хулоса',
        application: 'Ариза',
        clear: 'Тозалаш',
        search: 'Топмоқ',
        fio: 'Тўлиқ исм',
        appCode: 'Ариза коди',
        status: 'Статус',
        createdAt: 'Яратилган сана',
        firstName: 'Исм',
        lastName: 'Фамилияси',
        middleName: 'Отасининг исми',
        categories: 'Тоифаси',
        vehicleTypes: 'Автомобил тури',
        oldStatus: 'Олдинги ҳолат',
        newStatus: 'Янги ҳолат',
        attempt: 'Уриниш',
        attempts: 'Уринишлар',
        firstAttempt: 'Биринчи уриниш',
        retake: 'Қайта олинг',
        passport: 'Серия / паспорт рақами',
        phone: 'Телефон',
        result: 'Натижа',
        true: 'Муваффақиятли',
        false: 'Муваффақиятли емас',
      },
      UpdateClassRoomPage: {
        choiceBranch: 'Выберите филиал',
        nameError: 'Название кабинета уже существует',
        fillFields: 'Заполните поля',
        updatedClassRoom: 'Кабинет изменен',
        updateClassRoom: 'Изменить кабинет',
        enterName: 'Введите название',
        back: 'Назад',
        save: 'Сохранить',
      },
      //fix
      CreateClassRoomPage: {
        choiceBranch: 'Выберите филиал',
        nameError: 'Название кабинета уже существует',
        fillFields: 'Заполните поля',
        createdClassRoom: 'Кабинет создан',
        createClassRoom: 'Создать кабинет',
        name: 'Название',
        back: 'Назад',
        save: 'Сохранить',
      },
      //fix
      ClassRoomsPage: {
        classRooms: 'Кабинеты',
        deleted: 'Кабинет удален',
        wantDeleteClassRoom: 'Вы действительно хотите удалить этот кабинет?',
        updatedDate: 'Дата изменения',
        actions: 'Действия',
        name: 'Название',
        classRoom: 'Кабинет',
      },
      ApplicationForGai: {
        fio: 'Ф.И.Ш.',
        passport: 'Паспорт',
        dateOfBirth: 'Туғилган санаси',
        phone: 'Телефон',
        vehicleType: 'Транспорт воситасининг тури',
      },
      ApplicationsForGai: {
        application: 'Аризалар',
        clear: 'Тозалаш',
        search: 'Қидирув',
        fio: 'Ф.И.Ш.',
        phone: 'Телефон рақами',
        appCode: 'Аризанинг коди',
        passCode: 'Бейжик рақами',
        status: 'Статус',
        category: 'Тоифа',
        transportType: 'Транспорт воситасининг тури',
        updatedAt: 'Ўзгартиришлар киритилган санаси',
        actions: 'Ҳаракатлар',
        serial: 'Серияси',
        number: 'Рақами',
        pinfl: 'ЖШШИР',
        createdAt: 'Яратилган санаси',
        endDate: 'Тугаш санаси',
        firstName: 'Исми',
        lastName: 'Фамилияси',
        middleName: 'Отасининг исми',
        categories: 'Тоифа',
        vehicleTypes: 'Транспорт воситалари',
        statuses: 'Статус',
      },
      VisitLogsPage: {
        visitLogs: 'Ташрифлар рўйхати',
        date: 'Сана',
        search: 'Қидирув',
        clear: 'Тозалаш',
        fio: 'Ф.И.Ш.',
        dateOfBirth: 'Туғилган санаси',
        passport: 'Паспорт серияси/рақами',
        appCategory: 'Аризанинг тури',
        createdAt: 'Яратилган санаси',
        status: 'Статус',
      },
      VehicleTypesPage: {
        deleted: 'Муваффақиятли ўчирилди',
        wantDeleteVehicle:
          'Сиз ҳақиқатан ҳам транспорт воситасини ўчиришни хоҳлайсизми?',
        vehicleTypes: 'Транспорт воситалари',
        name: 'Номи',
        actions: 'Ҳаракатлар',
      },
      //fix
      UsersPage: {
        error: 'Хатолик юз берди. Бир оздан кейин уриниб кўринг',
        users: 'Фойдаланувчилар',
        serial: 'Серияси',
        number: 'Рақами',
        firstName: 'Исми',
        lastName: 'Фамилияси',
        middleName: 'Отасининг исми',
        search: 'Қидирув',
        clear: 'Тозалаш',
        passport: 'Паспорт серияси/рақами',
        pinfl: 'ЖШШИР',
        fio: 'Ф.И.Ш.',
        phone: 'Телефон рақами',
        integrated: 'Итеграция қилинган',
        role: 'Роли',
        verrified: 'Тасдиқланган',
        status: 'Статус',
        actions: 'Ҳаракатлар',
      },
      UserIdentificationPage: {
        error: 'Хатолик юз берди. Бир оздан кейин уриниб кўринг',
        applicationNotFound: 'Ариза топилмади',
        userNotActive: 'Фойдаланувчи фаол эмас',
        statusError: 'Статус хатоси',
        appNotVerrified: 'Ариза тасдиқланмаган',
        fio: 'Ф.И.Ш.',
        dateOfBirth: 'Туғилган санаси',
        phone: 'Телефон рақами',
        passport: 'Паспорт серияси/рақами',
        pinfl: 'ЖШШИР',
        appStatus: 'Аризанинг статуси',
        appCategory: 'Аризанинг тури',
        failureDays:
          'Имтиҳонни қайта топшириш учун аввалги имтиҳон топширилган кунидан 7 иш куни ўтиши керак',
        success: 'Муваффақиятли',
        passportExp: 'Срок паспорта',
        medicalCertValid: 'Срок мед. справки',
      },
      UpdateVehicleTypePage: {
        fillFields: 'Катакларни тўлдиринг',
        vehicletypeUpdated: 'Транспорт воситаси ўзгартирилди',
        updateVehicleType: 'Транспорт воситасини ўзгартириш',
        enterName: 'Номини киритинг',
        back: 'Орқага қайтиш',
        save: 'Сақлаш',
      },
      UpdateUserPage: {
        motordrome: 'Автодром',
        phoneError: 'Бундай телефон билан фойдаланувчи мавжуд',
        passportError: 'Бундай паспорт билан фойдаланувчи мавжуд',
        pinflError: 'Бундай ЖШШИР билан фойдаланувчи мавжуд',
        updateUser: 'Фойдаланувчини янгилаш',
        serial: 'Серияси',
        number: 'Рақами',
        phone: 'Телефон рақами',
        role: 'Роли',
        firstName: 'Исми',
        lastName: 'Фамилияси',
        middleName: 'Отасининг исми',
        dateOfBirth: 'Туғилган санаси',
        pinfl: 'ЖШШИР',
        getToken: 'Токенни қабул қилиш',
        back: 'Орқага қайтиш',
        save: 'Сақлаш',
      },
      UpdateStatusPage: {
        updateStatus: 'Статусни янгилаш',
        type: 'Турини танланг',
        queue: 'Навбатни танланг',
        pass: 'Рухсатнома/бейжик',
        pay: 'Тўлов',
        name: 'Номи',
        titleLat: 'Ўзбек тилидаги сарлавҳа (лотин алифбоси)',
        titleCyr: 'Ўзбек тилидаги сарлавҳа (Кирилл алифбоси)',
        titleRu: 'Рус тилидаги сарлавҳа',
        order: 'Тартиб',
        back: 'Орқага қайтиш',
        update: 'Янгилаш',
        vehicleType: 'Тип транспортного средства',
      },
      UpdatePracticePenaltyPage: {
        updatePenalty: 'Жарима балларини янгилаш',
        nameLat: 'Ўзбек тилидаги номи (лотин алифбоси)',
        nameCyr: 'Ўзбек тилидаги номи (Кирилл алифбоси)',
        nameRu: 'Рус тилидаги номи',
        points: 'Баллар',
        cancel: 'Бекор қилиш',
        save: 'Сақлаш',
        code: 'Код',
        codeError: 'Данный код уже существует',
      },
      UpdatePracticeExercisesPage: {
        updateExercise: 'Машқни янгилаш',
        nameLat: 'Ўзбек тилидаги номи (лотин алифбоси)',
        nameCyr: 'Ўзбек тилидаги номи (Кирилл алифбоси)',
        nameRu: 'Рус тилидаги номи',
        cancel: 'Бекор қилиш',
        save: 'Сақлаш',
        code: 'Код',
        codeError: 'Данный код уже существует',
      },
      UpdateErrorTypePage: {
        fillFields: 'Катакларни тўлдиринг',
        errorTypeChanged: 'Хато тури ўзгартирилди',
        error: 'Хатолик юз берди. Бир оздан кейин уриниб кўринг',
        updateErrorType: 'Хато турини ўзгартириш',
        nameCyr: 'Ўзбек тилидаги номи (Кирилл алифбоси)',
        nameLat: 'Ўзбек тилидаги номи (лотин алифбоси)',
        nameRu: 'Рус тилидаги номи',
        back: 'Орқага қайтиш',
        save: 'Сақлаш',
      },
      UpdateDocPage: {
        required: 'Обязательный/Не обязательный',
        nameConflict: 'Документ с таким названием уже существует',
        fillFields: 'Катакларни тўлдиринг',
        docUpdated: 'Хужжат ўзгартирилди',
        error: 'Хатолик юз берди. Бир оздан кейин уриниб кўринг',
        updateDocument: 'Хужжатни таҳрирлаш',
        docName: 'Хужжат номи',
        nameCyr: 'Ўзбек тилидаги номи (Кирилл алифбоси)',
        nameLat: 'Ўзбек тилидаги номи (лотин алифбоси)',
        nameRu: 'Рус тилидаги номи',
        back: 'Орқага қайтиш',
        save: 'Сақлаш',
      },
      UpdateCategoryPage: {
        fillFields: 'Катакларни тўлдиринг',
        categoryUpdated: 'Тоифаси ўзгартирилди',
        error: 'Хатолик юз берди. Бир оздан кейин уриниб кўринг',
        updateCategory: 'Тоифани таҳрирлаш',
        data: 'Маълумотлар',
        statuses: 'Статуслар',
        categoryName: 'Тоифа номи',
        nameCyr: 'Ўзбек тилидаги номи (Кирилл алифбоси)',
        nameLat: 'Ўзбек тилидаги номи (лотин алифбоси)',
        nameRu: 'Рус тилидаги номи',
        order: 'Тартиб',
        selectDocuments: 'Хужжатни танланг',
        back: 'Орқага қайтиш',
        save: 'Сақлаш',
        vehicleTypes: 'Типы транспортных средств',
      },
      ApplicationHistoryPage: {
        branch: 'Филиал',
        actions: 'Ҳаракатлар',
        more: 'Батафсил',
        applicationHistory: 'Ариза тарихи',
        history: 'Тарих',
        result: 'Натижа',
        sucess: 'Тўғри',
        fail: 'Нотўғри',
        answer: 'Жавоб',
        question: 'Савол',
        ticketNumber: 'Билет рақами',
        createdDate: 'Яратилган сана',
        statuses: 'Статуслар',
        transactions: 'Транзакциялар',
        results: 'Натижалар',
        oldStatus: 'Олдинги ҳолат',
        nextStatus: 'Кейинги ҳолат',
        currentStatus: 'Жорий ҳолат',
        category: 'Тоифаси',
        errorMessage: 'Муваффақиятли блокланган',
        error: 'Хато, илтимос, кейинроқ қайта уриниб кўринг',
        sent: 'Жўнатилди',
        dateSendingToGai: 'ГАИ юборилган сана',
        lastSubmissionDate: 'Охирги жўнатилган сана',
        status: 'Статус ГАИ',
        message: 'Хабар',
        appeal: 'Апелляция',
        resend: 'Қайта юбориш',
        block: 'Блоклаш',
        unblock: 'Блокдан чиқариш',
        attempt: 'Уриниш',
        yesNo: 'Муваффақиятли / Емас',
      },
      UpdateApplicationPage: {
        resident: 'Ўзбекистон Республикаси фуқароси',
        noResident: 'Хорижий давлат фуқароси',
        isForeigner:
          'Ўзбекистон Республикаси фуқароси / Хорижий давлат фуқароси',
        time: 'Соат',
        branch: 'Филиал',
        choiceBranch: 'Филиални танланг',
        residencePlace: 'Яшаш жойи',
        more: 'Ариза ҳақида батафсил',
        uploadDocuments: 'Ҳужжатларни тўлдиринг',
        notInList: 'Рўйхатда йўқ',
        enterSchoolName: 'Автомактабнинг номини киритинг',
        choiceSchool: 'Автомактабни танланг',
        selectLanguage: 'Имтиҳонни ўтказиш тилини танланг',
        visitDateNotValid: 'Марказга ташриф санаси хато',
        visitDate: 'Марказга ташриф буюрган санаси',
        verification: 'Тасдиқланган фойдаланувчи',
        confirmedApplication: 'Ариза тасдиқланган',
        printCertificate: 'Сертификатни чоп этиш',
        correctPhone: 'Телефон рақамини тўғри киритинг',
        userNotReceived: 'Фойдаланувчининг маълумотлари қабул қилинмади',
        fillFields: 'Катакларни тўлдиринг',
        vehicleType: 'Транспорт воситасининг турини белгиланг',
        applicationsUpdated: 'Ариза ўзгартирилди',
        error: 'Хатолик юз берди. Бир оздан кейин уриниб кўринг',
        canceledApplication: 'Аризани бекор қилинг',
        passportConflict: 'Бундай паспорт билан фойдаланувчи мавжуд',
        applicationRejected: 'Ариза рад этилди',
        application: 'Ариза',
        updateApplication: 'Аризани ўзгартириш',
        cancelApp: 'Аризани бекор қилиш',
        save: 'Сақлаш',
        appData: 'Аризанинг маълумотлари',
        transport: 'Транспорт воситаси',
        userData: 'Фойдаланувчининг маълумотлари',
        userPhone: 'Фойдаланувчининг телефон рақамини киритинг',
        passportSeries: 'Паспорт серияси',
        passportNumber: 'Паспорт рақами',
        pinfl: 'ЖШШИР',
        firstName: 'Исми',
        lastName: 'Фамилияси',
        middleName: 'Отасининг исми',
        dateOfBirth: 'Туғилган санаси',
        back: 'Орқага қайтиш',
        phone: 'Телефон рақами',
        category: 'Тоифаси',
        transportType: 'Транспорт воситасининг тури',
        reasonsRejectedApp: 'Аризани рад этиш сабаблари',
        docsList: 'Хужжатларнинг рўйхати',
        passIssue: 'Бейжикни расмийлаштириш',
        selectCategoryAndTryAgain: 'Тоифани танлаб қайта уриниб кўринг',
        passIssued: 'Бейжик расмийлаштирилди',
        confirmApplication: 'Аризани тасдиқлаш',
        errorTryLater: 'Хатолик юз берди. Бир оздан кейин уриниб кўринг',
        conflictPinfl: 'Бундай ПИНФЛ фойдаланувчи аллақачон мавжуд',
        conflictSerialNumber:
          'Бундай серия ва паспорт рақамига эга фойдаланувчи аллақачон мавжуд',
        conflictPhone:
          'Ушбу телефон рақамига эга фойдаланувчи аллақачон мавжуд',
        requestChanges: 'Ўзгаришларни талаб қилиш',
        blacklisted: 'Қора рўйхатга киритинг',
        unblock: 'Блокдан чиқариш',
        reason: 'Номзодни қора рўйхатга киритиш сабабини кўрсатинг',
        note: 'эслатма',
        update: 'Ўзгартириш',
        add: 'Қўшиш',
        submitAReport: 'Рапорт бермоқ',
        CREATED: 'Яратилган',
        NOT_VERIFIED: 'Тасдиқланмаган',
        T_PAYMENT: 'Назарий имтиҳон учун тўланг',
        T_EXAM: 'Назариядан имтиҳон топшириш',
        T_FAILED: 'Назарий имтиҳондан йиқилдингиз',
        P_PAYMENT: 'Амалиёт имтиҳони учун тўланг',
        P_EXAM: 'Амалиёт имтиҳонини топшириш',
        P_FAILED: 'Сиз амалий имтиҳондан йиқилдингиз',
        COMPLETED: 'Якунланди',
        appeal: 'Апелляция',
        noVerified: 'Тасдиқланмаган',
        verified: 'Текширилган',
        passportValidity: 'Cрок паспорта',
        medCertificateValidity: 'Срок мед. справки',
      },
      TransactionsPage: {
        transactions: 'Транзакциялар',
        fio: 'Ф.И.Ш.',
        paymentDate: 'Тўлов санаси',
        paymentType: 'Тўлов турлари',
        sum: 'Суммаси',
        passport: 'Паспорт серияси/рақами',
        pinfl: 'ЖШШИР',
        id: 'ID',
        cardNumber: 'Карта(4 посл цифры)',
        datails: 'Детали',
        cashierName: 'Ф.И.О кассира',
        CASH: 'Наличные',
        TERMINAL: 'Терминал',
        PAYME: 'Payme',
        CLICK: 'Сlick',
        REFUND: 'Возврат',
        FREE: 'Бесплатно',
        UZCARD: 'UZCARD',
        HUMO: 'HUMO',
        BANK: 'BANK',
        EPOS: 'EPOS',
        THEORY_PAYMENT: 'Теоретический экзамен',
        PRACTICE_PAYMENT: 'Практический экзамен',
        examType: 'Тип экзамена',
        createdAt: 'C',
        endDate: 'По',
        branch: 'Филиал',
        appId: 'ID заявки',
        qrCode: 'QR код',
        exportExcel: 'Экспортировать в EXCEL',
        totalSum: 'Общая сумма',
        failedTheTheory: 'Провалил теорию',
        retake: 'Пересдача',
        paymentOnAnotherDay: 'Оплата в другой день',
        applyForRefund: 'Подать на возврат',
        changeTransactionType: 'Изменить тип транзакции',
        go: 'Перейти',
        transactionType: 'Тип транзакции',
        change: 'Изменить',
        search: 'Поиск',
        clear: 'Очистить',
        QR: 'QR'
      },
      StatusesPage: {
        categoryDeleted: 'Тоифа олиб ташланди',
        error: 'Хатолик юз берди. Бир оздан кейин уриниб кўринг',
        statuses: 'Статуслар',
        order: 'Тартиб',
        name: 'Номи',
        titleLat: 'Ўзбек тилидаги номи (лотин алифбоси)',
        titleCyr: 'Ўзбек тилидаги номи (Кирилл алифбоси) ',
        titleRu: 'Рус тилидаги номи',
        pass: 'Рухсатнома/бейжик',
        actions: 'Ҳаракатлар',
        wantDeleteStatus: 'Сиз ҳақиқатан ҳам статусни ўчирмоқчимисиз?',
      },
      PracticePenaltiesPage: {
        penaltiesDeleted: 'Жарима баллари ўчирилди',
        error: 'Хатолик юз берди. Бир оздан кейин уриниб кўринг',
        penalties: 'Жарималар',
        nameLat: 'Ўзбек тилидаги номи (лотин алифбоси)',
        nameCyr: 'Ўзбек тилидаги номи (Кирилл алифбоси) ',
        nameRu: 'Рус тилидаги номи',
        penaltyPoints: 'Жарима баллари',
        actions: 'Ҳаракатлар',
        code: 'Код',
        wantDeletePenalty: 'Сиз ҳақиқатан ҳам жарима балларини ўчирмоқчимисиз?',
      },
      PracticeExercisesPage: {
        exserciseDeleted: 'Машқ ўчирилди',
        error: 'Хатолик юз берди. Бир оздан кейин уриниб кўринг',
        praticeExercises: 'Амалий машқлар',
        titleLat: 'Заголовок на узбекском (латиница)',
        titleCyr: 'Заголовок на узбекском (кириллица)',
        titleRu: 'Заголовок на русском',
        wantDeleteExercise: 'Сиз ҳақиқатан ҳам машқни ўчирмоқчимисиз?',
        code: 'Код',
      },
      PaymentPage: {
        payment: 'Тўлов',
        search: 'Қидирув',
        fio: 'Ф.И.Ш.',
        categories: 'Тоифа',
        statuses: 'Статус',
        certificate: 'Сертификат',
        printCertificate: 'Сертификатни чоп этиш',
        sum: 'Суммаси',
        allSum: 'Умумий суммаси',
        cash: 'Нақд',
        bankCard: 'Терминал',
        pay: 'Тўлаш',
        payDate: 'Тўлов санаси',
        paymentType: 'Тўлов турлари',
        error: 'Хато',
        lastDigitsOfBankCard: 'Посл 4 цифры банк карты',
      },
      ErrorTypesPage: {
        name: 'Номи',
        createdAt: 'Яратилган санаси',
        actions: 'Ҳаракатлар',
        errorTypeDeleted: 'Хато тури ўчирилди',
        error: 'Хатолик юз берди. Бир оздан кейин уриниб кўринг',
        errors: 'Хатолар',
      },
      //fix
      MotordromesPage: {
        motordromeDeleted: 'Автодром удален',
        error: 'Произошла ошибка, попробуйте позже',
        wantDeleteMotordrome: 'Вы действительно хотите удалить автодром?',
        motordromes: 'Автодромы',
        name: 'Название',
        createdAt: 'Дата создания',
        actions: 'Действия',
      },
      //fix
      SchoolPage: {
        tin: 'ИНН',
        schoolDeleted: 'Школа удалена',
        error: 'Произошла ошибка, попробуйте позже',
        wantDeleteSchool: 'Вы действительно хотите удалить школу?',
        search: 'Поиск',
        clear: 'Очистить',
        schools: 'Школы',
        enterName: 'Введите название для поиска',
        name: 'Название',
        createdAt: 'Дата создания',
        actions: 'Действия',
      },
      DocsPage: {
        docDeleted: 'Хужжат ўчирилди',
        error: 'Хатолик юз берди. Бир оздан кейин уриниб кўринг',
        wantDeleteDoc: 'Сиз ҳақиқатан ҳам хужжатни ўчирмоқчимисиз?',
        docs: 'Хужжатлар',
        name: 'Номи',
        createdAt: 'Яратилган санаси',
        actions: 'Ҳаракатлар',
      },
      CreateVehicleTypePage: {
        fillFields: 'Катакларни тўлдиринг',
        createdVahicleType: 'Транспорт воситасининг тури яратилди',
        createCategory: 'Автомобильни ҳайдаш бўйича тоифани яратиш',
        name: 'Номини киритинг',
        back: 'Орқага қайтиш',
        save: 'Сақлаш',
      },
      //fix
      CreateStatusPage: {
        createStatus: 'Статус яратиш',
        type: 'Турини танланг',
        queue: 'Навбатни танланг',
        pass: 'Рухсатнома/бейжик',
        payment: 'Тўлов',
        name: 'Номи',
        titleLat: 'Ўзбек тилидаги номи (лотин алифбоси)',
        titleCyr: 'Ўзбек тилидаги номи (Кирилл алифбоси)',
        titleRu: 'Рус тилидаги номи',
        order: 'Тартиб',
        back: 'Орқага қайтиш',
        save: 'Сақлаш',
        vehicleType: 'Тип транспортного средства',
      },
      //fix
      CreatePracticePenaltyPage: {
        createPenalty: 'Жарима балларини яратиш',
        nameLat: 'Ўзбек тилидаги номи (лотин алифбоси)',
        nameCyr: 'Ўзбек тилидаги номи (Кирилл алифбоси)',
        nameRu: 'Рус тилидаги номи',
        scores: 'Баллар',
        cancel: 'Бекор қилиш',
        save: 'Сақлаш',
        code: 'Код',
        codeError: 'Данный код уже существует',
      },
      //fix
      CreatePracticeExercisesPage: {
        createExercisse: 'Машқ яратиш',
        nameLat: 'Ўзбек тилидаги номи (лотин алифбоси)',
        nameCyr: 'Ўзбек тилидаги номи (Кирилл алифбоси)',
        nameRu: 'Рус тилидаги номи',
        cancel: 'Бекор қилиш',
        save: 'Сақлаш',
        code: 'Код',
        codeError: 'Данный код уже существует',
      },
      CreateErrorTypePage: {
        fillFields: 'Катакларни тўлдиринг',
        error: 'Хатолик юз берди. Бир оздан кейин уриниб кўринг',
        errorCreateSuccesed: 'Хато тури муваффақиятли яратилди',
        createError: 'Хато турини яратиш',
        nameCyr: 'Ўзбек тилидаги номи (Кирилл алифбоси)',
        nameLat: 'Ўзбек тилидаги номи (лотин алифбоси)',
        nameRu: 'Рус тилидаги номи',
        back: 'Орқага қайтиш',
        save: 'Сақлаш',
      },
      UpdateMotordromePage: {
        nameCyr: 'Ўзбек тилидаги номи (Кирилл алифбоси)',
        nameLat: 'Ўзбек тилидаги номи (лотин алифбоси)',
        nameRu: 'Рус тилидаги номи',
        conflictError: 'Автодром в данной очереди уже существует',
        selectQueue: 'Выберите очередь',
        updateMotordrome: 'Изменить автодром',
        fillFields: 'Катакларни тўлдиринг',
        error: 'Хатолик юз берди. Бир оздан кейин уриниб кўринг',
        updatedMotordrome: 'Автодром изменен',
        name: 'Название автодрома',
        back: 'Орқага қайтиш',
        save: 'Сақлаш',
        vehicleTypes: 'Транспорт воситалари',
      },
      //fix
      CreateMotordromePage: {
        conflictError: 'Автодром в данной очереди уже существует',
        selectQueue: 'Выберите очередь',
        fillFields: 'Катакларни тўлдиринг',
        error: 'Хатолик юз берди. Бир оздан кейин уриниб кўринг',
        motordromeCreatedSuccess: 'Автодром создан успешно',
        createMotordrome: 'Создать автодром',
        nameCyr: 'Ўзбек тилидаги номи (Кирилл алифбоси)',
        nameLat: 'Название на узбекском (латиница)',
        nameRu: 'Рус тилидаги номи',
        name: 'Название автодрома',
        back: 'Орқага қайтиш',
        save: 'Сақлаш',
        vehicleTypes: 'Транспорт воситалари',
      },
      //fix
      UpdateSchoolPage: {
        tin: 'ИНН',
        conflict: 'Школа уже существует',
        tinConflict: 'Школа с таким ИНН уже существует',
        fillFields: 'Заполните поля',
        error: 'Произошла ошибка, попробуйте позже',
        name: 'Название школы',
        save: 'Сохранить',
        back: 'Назад',
        updateSchool: 'Изменить школу',
        updatedSchool: 'Школа изменена',
      },
      //fix
      CreateSchoolPage: {
        tin: 'ИНН',
        conflict: 'Школа уже существует',
        fillFields: 'Катакларни тўлдиринг',
        error: 'Хатолик юз берди. Бир оздан кейин уриниб кўринг',
        schoolCreatedSuccess: 'Школа создана успешно',
        createSchool: 'Создать школу',
        name: 'Название школы',
        save: 'Сақлаш',
        back: 'Орқага қайтиш',
      },
      //fix
      CreateDocPage: {
        required: 'Обязательный/Не обязательный',
        nameConflict: 'Документ с таким названием уже существует',
        fillFields: 'Катакларни тўлдиринг',
        error: 'Хатолик юз берди. Бир оздан кейин уриниб кўринг',
        docCreateSuccesed: 'Хужжат муваффақиятли яратилди',
        createDoc: 'Хужжатни яратиш',
        nameCyr: 'Ўзбек тилидаги номи (Кирилл алифбоси)',
        nameLat: 'Название на узбекском (латиница)',
        nameRu: 'Рус тилидаги номи',
        name: 'Хужжатнинг номи',
        back: 'Орқага қайтиш',
        save: 'Сақлаш',
      },
      CreateCategoryPage: {
        fillFields: 'Катакларни тўлдиринг',
        error: 'Хатолик юз берди. Бир оздан кейин уриниб кўринг',
        categoryCreatSuccessed: 'Тоифа муваффақиятли яратилди',
        createdCategory: 'Тоифани яратиш',
        categoryName: 'Тоифа номи',
        nameCyr: 'Ўзбек тилидаги номи (Кирилл алифбоси)',
        nameLat: 'Название на узбекском (латиница)',
        nameRu: 'Рус тилидаги номи',
        order: 'Тартиб',
        selectDocuments: 'Хужжатларни танланг',
        back: 'Орқага қайтиш',
        save: 'Сақлаш',
        vehicleTypes: 'Транспорт воситалари',
      },
      //fix
      CreateApplicationPageByUser: {
        resident: 'Ўзбекистон Республикаси фуқароси',
        noResident: 'Хорижий давлат фуқароси',
        isForeigner:
          'Ўзбекистон Республикаси фуқароси / Хорижий давлат фуқароси',
        choiceBranch: 'Филиални танланг',
        residencePlace: 'Яшаш жойи',
        enterSchoolName: 'Автомактабнинг номини киритинг',
        notInList: 'Рўйхатда йўқ',
        choiceSchool: 'Автомактабни танланг',
        fillFields: 'Катакларни тўлдиринг',
        selectLanguage: 'Имтиҳонни ўтказиш тилини танланг',
        visitDateNotValid: 'Не верная дата визита в центр',
        visitDate: 'Марказга ташриф буюрган санаси',
        fillDocs: 'Заполните документы',
        selectCategory: 'Тоифани танланг',
        applicationSuccessCreated: 'Ариза муваффақиятли яратилди',
        error: 'Хатолик юз берди. Бир оздан кейин уриниб кўринг',
        vehicleType: 'Транспорт воситасинининг турини белгиланг',
        createApplication: 'Ариза яратиш',
        selectVehicleType: 'Транспорт воситасинининг турини танланг',
        documentList: 'Хужжатлар рўйхати',
        back: 'Орқага қайтиш',
        save: 'Сақлаш',
        applicationAlreadyExists: 'Бундай тоифали ариза мавжуд',
        time: 'Соат',
      },
      //fix
      CreateApplicationPage: {
        send: 'Жўнатиш',
        resident: 'Ўзбекистон Республикаси фуқароси',
        noResident: 'Хорижий давлат фуқароси',
        isForeigner:
          'Ўзбекистон Республикаси фуқароси / Хорижий давлат фуқароси',
        residencePlace: 'Место проживания',
        notInList: 'Нет в списке',
        enterSchoolName: 'Введите название автошколы',
        choiceSchool: 'Выберите автошколу',
        clear: 'Очистить',
        selectLanguage: 'Имтиҳонни ўтказиш тилини танланг',
        fillFields: 'Катакларни тўлдиринг',
        vehicleType: 'Транспорт воситасинининг турини белгиланг',
        uploadDocuments: 'Хужжатларни юкланг',
        applicationSuccessCreated: 'Ариза муваффақиятли яратилди',
        applicationAlreadyExists: 'Бундай тоифали ариза мавжуд',
        error: 'Хатолик юз берди. Бир оздан кейин уриниб кўринг',
        userNotFound: 'Фойдаланувчи топилмади',
        createApplication: 'Ариза яратиш',
        enterPhoneNumber: 'Фойдаланувчининг телефон рақамини киритинг',
        pinfl: 'ЖШШИР',
        passportSerial: 'Паспорт серияси',
        passportNumber: 'Паспорт рақами',
        selectCategory: 'Тоифани танланг',
        selectVehicleType: 'Транспорт тоифасининг турини танланг',
        userData: 'Фойдаланувчининг маълумотлари',
        firstName: 'Исми',
        lastName: 'Фамилияси',
        middleName: 'Отасининг исми',
        dateOfBirth: 'Туғилган санаси',
        documentList: 'Хужжатлар рўйхати',
        back: 'Орқага қайтиш',
        save: 'Сақлаш',
        passIssued: 'Пропуск оформлен',
        choiceCategory: 'Выберите категорию',
        enterPassport: 'Введите серию и номер паспорта',
        errorPinfl: 'ЖШШИР маълумотларида хатолик мавжуд',
        errorPhone: 'Телефон рақамида хатолик мавжуд',
        passportExp: 'Срок паспорта',
        medicalCertValid: 'Срок мед. справки',
        getData: 'Маълумотларни олиш',
      },
      CategoriesPage: {
        deletedCategory: 'Тоифа ўчирилди',
        error: 'Хатолик юз берди. Бир оздан кейин уриниб кўринг',
        wantDeleteCategory: 'Сиз ҳақиқатан ҳам тоифани ўчирмоқчимисиз?',
        categories: 'Тоифалар',
        name: 'Номи',
        createdAt: 'Яратилган санаси',
        actions: 'Ҳаракатлар',
      },
      CashPayment: {
        cashPayment: 'Нақд тўлов',
        fio: 'Ф.И.Ш.',
        passport: 'Паспорт серияси/рақами',
        pinfl: 'ЖШШИР',
        date: 'Тўлов санаси',
        sum: 'Тўлов суммаси',
        details: 'Тафсилотлар',
        amountEnclosed: 'Инкассация қилинган сумма',
        dateEnclosed: 'Инкассация қилинган сана',
        fioCashier: 'Ф.И.О кассира, принимающего оплату',
        idMachine: 'Тўлов қурилмасининг идентификация рақами',
      },
      BankCardPayment: {
        cardPayment: 'Банк картаси орқали тўлов',
        fio: 'Ф.И.Ш.',
        passport: 'Паспорт серияси/рақами',
        pinfl: 'ЖШШИР',
        date: 'Тўлов санаси',
        sum: 'Тўлов суммаси',
        details: 'Тафсилотлар',
        lastNumber: 'Банк картасининг охирги 4 рақами',
        fioCashier: 'Ф.И.О кассира, принимающего оплату',
        idMachine: 'Тўлов қурилмасининг идентификация рақами',
      },
      //fix
      ApplicationsPage: {
        operator: 'Оператор',
        branch: 'Филиал',
        application: 'Аризалар',
        clear: 'Тозалаш',
        search: 'Қидирув',
        fio: 'Ф.И.Ш.',
        phone: 'Телефон',
        appCode: 'Аризанинг коди',
        passCode: 'Бейжик рақами',
        status: 'Ҳолат',
        category: 'Тоифа',
        transportType: 'Транспорт воситасининг тури',
        updatedAt: 'Ўзгартиришлар киритилган санаси',
        actions: 'Ҳаракатлар',
        serial: 'Паспорт серияси',
        number: 'Рақами',
        pinfl: 'ЖШШИР',
        createdAt: 'Яратилган санаси',
        endDate: 'Тугаш санаси',
        firstName: 'Исми',
        lastName: 'Фамилияси',
        middleName: 'Отасининг исми',
        categories: 'Тоифа',
        vehicleTypes: 'Транспорт воситалари',
        statuses: 'Статус',
        creationType: 'Ариза тури',
        choiceSchool: 'Мактабни танланг',
        dateOfBirth: 'Туғилган санаси',
        CREATED: 'Яратилган',
        NOT_VERIFIED: 'Тасдиқланмаган',
        T_PAYMENT: 'Назарий имтиҳон учун тўланг',
        T_EXAM: 'Назариядан имтиҳон топшириш',
        T_FAILED: 'Назарий имтиҳондан йиқилдингиз',
        P_PAYMENT: 'Амалиёт имтиҳони учун тўланг',
        P_EXAM: 'Амалиёт имтиҳонини топшириш',
        P_FAILED: 'Сиз амалий имтиҳондан йиқилдингиз',
        COMPLETED: 'Якунланди',
        blocked: 'Блокланган',
      },
      auth: {
        notFound: 'Телефон рақами топилмади',
        enterOtpCode: 'СМС кодини киритинг',
        //fix
        passwordNotConfirmed: 'Пароллар бир-бирига мос эмас',
        passwordNotValid:
          'Парол узунлиги камида 6та белгидан иборат бўлиши керак',
        login: 'Кириш',
        phoneNumber: 'Телефон рақами',
        password: 'Пароль',
        forgotPassword: 'Парольни унутдингизми',
        confirmPassowrd: 'Парольни тасдиқланг',
        register: 'Рўйхатдан ўтиш',
        resetPassword: 'Парольни ўчириш',
        send: 'Юбориш',
        confirmOffer: 'Оммавий таклифни (офертани) тасдиқланг',
        enterCode: 'СМС-кодни киритинг',
        newPassword: 'Янги пароль',
        smsCodeReplay: 'Код ёзилган СМСни қайта юбориш',
        sendCodeToMobile: 'Рақамингизга код ёзилган СМС юборилди',
        sendSmsLater: 'СМСни қайта юбориш',
        sendSmsAgain: 'СМСни қайта юбориш',
        authSuccess: 'Авторизация мқваффақиятли ўтди',
        error: 'Маълумотлар тўғри тўлдирилганлигини текширинг',
        notValidLoginOrPassword: 'Нотўғри логин ёки пароль киритилган',
        tryLaterAgain: 'Хатолик юз берди. Бир оздан кейин уриниб кўринг',
        editedPassword: 'Пароль ўзгартирилди',
        registed: 'Рўйхатдан ўтиш',
        codeNotValid: 'Нотўғри СМС-код',
        registrationSuccess: 'Рўйхатдан муваффақиятли ўтилди',
        alreadyUser: 'Бундай фойдаланувчи мавжуд',
        repeatPassword: 'Парольни қайта теринг',
        offer: 'Оммавий таклиф',
        back: 'Орқага қайтиш',
        cancel: 'Бекор қилиш',
        sendCode: 'Кодни юбориш',
        checkCorrectData: 'Маълумотлар тўғри тўлдирилганлигини текширинг',
        passwordChanged: 'Пароль ўзгартирилди',
      },
      //fix
      updateQueuePage: {
        choiceBranch: 'Выберите филиал',
        choiceQueueType: 'Выберите тип очереди',
        queueUpdated: 'Очередь изменена',
        practice: 'Практика',
        theory: 'Теория',
        fillFields: 'Заполните поля',
        tryAgainLater: 'Произошла ошибка, попробуйте позже',
        updateQueue: 'Изменить очередь',
        nameOz: 'Название на узбекском (кирилица)',
        nameUz: 'Название на узбекском (латиница)',
        nameRu: 'Название на русском',
        back: 'Назад',
        save: 'Сохранить',
      },
      //fix
      createQueuePage: {
        choiceBranch: 'Выберите филиал',
        choiceQueueType: 'Выберите тип очереди',
        queueCreated: 'Очередь создана успешно',
        practice: 'Практика',
        theory: 'Теория',
        fillFields: 'Заполните поля',
        tryAgainLater: 'Произошла ошибка, попробуйте позже',
        createQueue: 'Создать очередь',
        nameOz: 'Название на узбекском (кирилица)',
        nameUz: 'Название на узбекском (латиница)',
        nameRu: 'Название на русском',
        back: 'Назад',
        save: 'Сохранить',
      },
      //fix
      carsPage: {
        filter: 'Фильтр',
        choiceMotordrome: 'Выберите автодром',
        search: 'Найти',
        number: 'Номер',
        model: 'Модель',
        category: 'Категория',
        cars: 'Автомобили',
      },
      //fix
      timeslotsPage: {
        reserved: 'Резерв қилинган',
        capacity: 'Сигʻими',
        timeslotDeleted: 'Қабул вақти ўчирилди',
        createTimeslot: 'Қабул вақти яратилди',
        save: 'Сақлаш',
        back: 'Орқага',
        timeslotUpdated: 'Қабул вақти ўзгартирилди',
        updateTimeslot: 'Қабул вақтини ўзгартириш',
        updatedDate: 'Ўзгартирилган сана',
        actions: 'Ҳаракатлар',
        fromTime: 'Дан',
        toTime: 'Гача',
        branch: 'Филиал',
        choiceBranch: 'Филиални танланг',
        reservedAndCapacity: 'Резерв қилинган / Сигʻими',
        search: 'Қидириш',
        timeslots: 'Қабул вақтлари',
        addTimeslot: 'Қабул вақтини қўшиш',
        date: 'Сана',
        deleteTimeslot: 'Қабул вақтини ўчириш',
        confirmDelete: 'Сиз ростдан ҳам ушбу қабул вақтини ўчирмоқчимисиз?',
        createdTimeslot: 'Қабул вақти муваффақиятли яратилди',
        confirmDeleteTimeslot:
          'Сиз ростдан ҳам ушбу қабул вақтини ўчирмоқчимисиз?',
        fillFields: 'Майдонларни тўлдиринг',
        savedData: 'Маълумотлар сақланди',
      },
      queuePage: {
        branches: 'Филиал',
        confirmDelete: 'Удалить из очереди?',
        confirmLogout: 'Вы действительно хотите выйти?',
        usersCount: 'Количество людей в очереди',
        classRoom: 'Кабинет',
        selectClassRoom: 'Выберите кабинет',
        emptyQueue: 'Очередь пуста',
        confirmDeleteQueue: 'Сиз ҳақиқатан ҳам ушбу навбатни ўчирмоқчимисиз?',
        selectQueue: 'Навбатни танланг',
        clearedQueue: 'Навбат тозаланди',
        clear: 'Тозалаш',
        enterCount: 'Сонини киритинг',
        power: 'Ишга тушириш',
        name: 'Номи',
        updateDate: 'Ўзгартиришлар киритилган санаси',
        actions: 'Ҳаракатлар',
        notAccept: 'Кириш рад этилди. Илтимос, қабулхонага мурожаат қилинг',
        passNotValid: 'Рухсатнома ҳақиқий эмас',
        deletedQueue: 'Навбат ўчирилди',
        queue: 'Навбат',
        timeslots: 'Вақт бўлаклари',
      },
    },
  },
  uz: {
    general: {
      instance: {
        noAccess: 'Kirish taqiqlangan',
        login: 'Tizimga kiring',
        uploadDocuments: 'Xujjatlarni yuklang',
      },
    },
    components: {
      ScheduleQueue: {
        of: "ta joydan",
        available: "tasi bo'sh"
      },
      CheckQueue: {
        fio: 'F.I.Sh',
        title: 'Navbatingizni tekshiring',
        dateOfBirth: "Tug'ilgan sanani kiriting",
        pass: "O'tish raqamini kiriting",
        save: 'Saqlash',
        notFound: 'Sizning arizangiz topilmadi',
        date: 'Sana',
        time: 'Vaqt',
        datePlaceholder: 'кк.оо.yyyy',
        qrTitle: 'QR kodli o‘tish raqamini skanerga tekkizing',
        dateError: "Tug‘ilgan sana noto‘g‘ri ko‘rsatilgan"
      },
      TimeSlots: {
        noPlaces: "Joylar yo'q",
        choose: 'Tanlang',
        of: "ta joydan",
        available: "tasi bo'sh"
      },
      ReserveQueue: {
        selectCurrentTime: 'Joriy vaqtni tanlang',
        conflict: "Sizning so'rovingiz allaqachon navbatga qo'shilgan",
        dateOfBirth: "Tug'ilgan sanani kiriting",
        pass: "O'tish raqamini kiriting",
        save: 'Saqlash',
        title: 'Navbatni bron qiling',
        success: "Siz elektron navbatga muvaffaqiyatli qo'shildingiz",
        error: 'Ошибка, попробуйте позже',
        deleteApp: "Eski yozuv oʻchirilsinmi?",
        datePlaceholder: 'кк.оо.yyyy',
        notFound: 'Sizning arizangiz topilmadi',
        qrTitle: 'QR kodli chekni skanerga tekkizing',
        dateError: "Tug‘ilgan sana noto‘g‘ri ko‘rsatilgan",
        ageValidation: 'Nomzod 18 yoshdan kichik',
        blackList: "Qora ro'yxatga kiritilgan nomzod",
        expire083: "Tibbiy ma'lumotnoma muddati tugagan",
        expirePassport: 'Pasport muddati tugagan',
        appNotVerified: 'Ariza tasdiqlanmagan',
        wrongTimeslot: 'Tanlangan vaqtga navbat mavjud emas. Navbatga yozilish vaqti soat {{times}} ga belgilangan.',

      },
      Header: {
        prompt: 'Siz rostdan chiqib ketmoqchimisiz?',
      },
      //fix
      transactionModal: {
        replenished: 'Пополнение',
        writeOff: 'Списание',
        actionType: 'Действие',
        pay: 'Оплата',
        payme: 'Payme',
        click: 'Click',
        terminal: 'Терминал',
        cash: 'Наличные',
        title: 'Транзакции',
        transactionType: 'Тип',
        amount: 'Сумма',
        status: 'Статус',
        payDate: 'Дата оплаты',
        completed: 'Успешно',
        failed: 'Ошибка оплаты',
      },
      resultsModal: {
        seeApp: "Ilovani ko'rish",
        attempt: 'Urinish',
        success:
          'Siz amaliy imtihonni muvaffaqiyatli topshirdingiz, natijangiz',
        result: 'Sizning natijangiz',
        print: 'Imtihon natijani chop eting',
        exercise: 'Mashq',
        name: 'Ism',
        penaltyPoints: 'Penalti ochkolari',
        total: 'Jami',
        theorySuccess:
          'Siz nazariy imtihonni muvaffaqiyatli topshirdingiz, natijangiz',
        ticketNumber: 'Chipta raqami',
        question: 'Savol',
        selectedAnswer: 'Tanlangan javob',
        results: 'Natija',
      },
      newApplicationNotice: {
        newNotice: 'Yangi onlayn ariza',
        open: "Ko'rish",
        close: 'Закрыть',
      },
      passModal: {
        enterPassNumber: 'Beyjik raqamini kiriting',
        save: 'Saqlash',
      },
      pagination: {
        rowsPerPage: 'Sahifadagi soni',
      },
      //fix
      queueList: {
        car: 'Avtomobil',
        classRoom: 'Auditoriya',
        choiceCar: 'Avtomobilni tanlang',
        call: 'Chaqirish',
        cancel: 'Bekor qilish',
        delete: "O'chirish",
        category: 'Toifa',
      },
      //fix
      TimeLine: {
        tests: 'Test-sinovlar',
        right: "To'g'ri",
        wrong: "Noto'g'ri",
        total: "Jami yig'ilgan ballar",
        startDate: 'Boshlash sanasi',
        attempts: 'Urinishlar',
        carNumber: 'Mashina raqami',
        penaltyPoints: 'Jarima ballari',
        CREATED: 'Yaratilgan',
        NOT_VERIFIED: 'Tasdiqlanmagan',
        T_PAYMENT: "Nazariy imtihon uchun to'lang",
        T_EXAM: "Nazariy imtihondan o'ting",
        T_FAILED: "Siz nazariy imtihondan o'ta olmadingiz.",
        P_PAYMENT: "Amaliyot imtihonini to'lang",
        P_EXAM: "Amaliyot imtihonidan o'ting",
        P_FAILED: "Siz amaliy imtihondan o'ta olmadingiz.",
        COMPLETED: 'Muvaffaqiyatli yakunlandi',
        theoryEndDate: 'Nazariy imt. tugash sanasi',
      },
      //fix
      Sidebar: {
        reports: 'Protokollar',
        responsiblePerson: 'Ответственные лица',
        schools: 'Maktablar',
        enterName: 'Qidirish uchun nom kiriting',
        control: 'Navbatni boshqarish',
        classRooms: 'Kabinet',
        cars: 'Avtomobillar',
        queue: 'Navbat',
        users: 'Foydalanuvchilar',
        categories: 'Toifalar',
        docs: 'Xujjatlar',
        applications: 'Arizalar',
        statuses: 'Statuslar',
        practiceCategory: 'Transport vositalari turlari',
        payment: "To'lov",
        passedExam: "Imtihondan o'tganlar",
        cashPayment: "Naqd to'lov",
        userId: 'Foydalanuvchini aniqlash',
        visitLogs: "Tashriflar ro'yxati",
        motordromes: 'Автодром',
        errors: 'Xatolar',
        transactions: 'Tranzaksiyalar',
        verrifyApps: 'Haqiqiyligi tasdiqlangan arizalar',
        generatReport: 'Umumiy hisobot',
        generalStatistics: 'Статистика отчет',
        schoolStatistics: 'Maktablar statistikasi',
        gaiSchoolsReport: "YHXBBning maktablar bo'yicha hisoboti",
        sumarry: 'Xulosa',
        appeals: 'Apellyatsiya',
        report: 'Raportlar',
        vising: 'Vizing',
        requestForChangeData: "Ma'lumotlarni o'zgartirish bo'yicha so'rovlar",
        certificates: 'Sertifikatlar',
        certificatesHistory: 'История сертификата',
        calendar: 'Taqvim',
        fines: 'Jarimalar',
        reception: 'Qabul',
        security: 'Xavfsizlik',
        accounting: 'Buxgalteriya',
        cash: 'Kassa',
        statistics: 'Statistika',
        integrationWithGai: 'Интеграция с гаи',
        practicalStatisticByCategory: 'Статистика ПЭ по категориям',
        timeslots: 'Время приема',
      },
      CategoryStatuses: {
        statusDeleted: "Status o'chirilgan",
        erorrTryAgain: "Xatolik yuz berdi. Yana bir bor urinib ko'ring",
        wantToRemove: "Siz haqiqatan ham toifani statusini o'chirmoqchimisiz?",
        add: "Toifani statusini qo'shish",
        status: 'Status',
        successStatus: 'Muvaffaqiyatli natijani statusi',
        failureStatus: 'Muvaffaqiyatsiz natijani statusi',
        order: 'Tartib',
        start: 'Boshlandi',
        finished: 'Tugadi',
        createdAt: 'Yaratilgan sanasi',
        actions: 'Harakatlar',
      },
      Confirmation: {
        cancel: 'Bekor qilish',
        success: 'Tasdiqlash',
      },
      FileUploader: {
        fileSize: 'Fayl hajmi juda katta',
        selectDocument: 'Xujjatni tanlash',
        selectAnotherDocument: 'Boshqa xujjatni tanlash',
        scanning: 'Skanerlash',
        getDocument: 'Hujjatni oling',
        enterPinfl: 'JShShIRni kiriting',
        enterVehicleType: 'Avtomobil turini tanlang',
        documentReceived: 'Hujjat qabul qilindi',
        docNotFound: 'Hujjat topilmadi',
        error: "Xato, keyinroq harakat qilib ko'ring",
      },
      FileUploads: {
        certificateFromSchool: 'Справка с автошколы',
        mainPassport: 'Pasport',
        photo: 'Fotosurat',
        passport: 'Pasport/ID karta (propiska bilan)',
        employerReferral: "Ish beruvchining yo'llanmasi",
        replacement:
          "Yagona namunadagi guvohnoma yoki uzluksiz haydovchilik mehnat faoliyati 10 yildan ortiq bo'lgan «Á» va «Ñ» toifali haydovchilik guvohnomasi bo'lgan shaxslarning haydovchilik guvohnomasini «BE» va «CE» toifaga almashtirish haydovchining mehnat daftarchasidan ko'chirma asosida",
        driverLicence_1: 'Milliy haydovchilik guvohnomasi-1',
        driverLicence_2: 'Milliy haydovchilik guvohnomasi-2',
        direction: "Ichki ishlar vakolatli organining yo'llanmasi",
        honey083_1: "083-shakldagi tibbiy ma'lumotnoma-1",
        honey083_2: "083-shakldagi tibbiy ma'lumotnoma-2",
        diplomaAnnex:
          "Reja asosida fanlarni o'zlashtirilganligi to'g'risida diplom va unga ilova",
        nationalDriversLicence:
          'Milliy haydovchilik guvohnomasi («Ñ», «Á» va «Ñ», «Ä», «Ñ» i «Ä», «SE» va (yoki) «DE»)',
        certificateSingleSample: 'Yagona namunadagi Guvohnoma',
        pinflForForeign: 'Chet el fuq. uchun PINFL',
        docConfirm12: 'Avto 12 oygacha boshqarishni tasdiqlovchi hujjat',
        appForAppeal: 'Apellyatsiya uchun ariza',
        decisionAppealComission: 'Apellyatsiya komissiyasining qarori',
        forWorkingDrivers:
          'Для работающих водителей — выписка из трудовой книжки или справка (выписка из приказа) с указанием вида закрепленного за ним автомототранспортного средства;',
      },
      Footer: {
        address: 'Toshkent shahri, Yangihayot tumani, Fayzli Mahallasi, 87',
        copyRight: '2022 barcha huquqlar himoyalangan',
      },
      CreateCategoryStatuses: {
        fillFields: "Kataklarni to'ldiring",
        createdSuccess: 'Toifa statusi muvaffaqiyatli yaratilgan',
        alreadyExistsDefault:
          '«Dastlabki» statusi bilan toifa statusi allaqachon mavjud',
        alreadyExistsFinish:
          '«Tugatilgan» statusi bilan toifa statusi allaqachon mavjud',
        errorTryAgain: "Xatolik yuz berdi. Bir ozdan keyin urinib ko'ring",
        createStatusCategory: 'Toifa uchun status yaratish',
        selectStatus: 'Statusni tanlang',
        successStatus: 'Muvaffaqiyatli natijani statusi',
        failureStatus: 'Muvaffaqiyatsiz natijani statusi',
        workDays: 'Qayta urinishdan oldin ish kunlari soni',
        order: 'Tartib',
        defaultStatus: '«Dastlabki» status',
        finished: 'Tugadi',
        cancel: 'Bekor qilish',
        save: 'Saqlash',
      },
      UpdateCategoryStatuses: {
        fillFields: "Kataklarni to'ldiring",
        updateSuccess: "Toifa statusi o'zgartirilgan",
        errorTryAgain: "Xatolik yuz berdi. Bir ozdan keyin urinib ko'ring",
        updateStatusCategory: "Toifa uchun status o'zgartirish",
        selectStatus: 'Statusni tanlang',
        successStatus: 'Muvaffaqiyatli natijani statusi',
        failureStatus: 'Muvaffaqiyatsiz natijani statusi',
        cost: 'Narh',
        workDays: 'Qayta urinishdan oldin ish kunlari soni',
        order: 'Tartib',
        defaultStatus: '«Dastlabki» status',
        finished: 'Tugadi',
        cancel: 'Bekor qilish',
        save: 'Saqlash',
        alreadyExistsDefault:
          '«Dastlabki» statusi bilan toifa statusi allaqachon mavjud',
        alreadyExistsFinish:
          '«Tugatilgan» statusi bilan toifa statusi allaqachon mavjud',
      },
      TokenModal: {
        copy: 'Nusha olindi',
        refresh: 'Yangilash',
      },
      UserModal: {
        userInfo: "Foydalanuvchi haqida ma'lumot",
        FIO: 'F.I.Sh.',
        dateOfBirth: "Tug'ilgan sanasi",
        passport: 'Pasport seriyasi/raqami',
        pinfl: 'JShShIR',
        phone: 'Telefon raqami',
        cancel: 'Bekor qilish',
        successUser: 'Foydalanuvchini tasdiqlash',
        name: 'Nomi',
        createdAt: 'Yaratilgan sanasi',
        actions: 'Harakatlar',
      },
    },
    pages: {
      ScheduleTimePage: {
        lawText: 'Diqqat: Avtomototransport vositalarini boshqarish huquqidan mahrum bo\'lgan shaxslar uchun nazariy imtihon soat {{times}} da o\'tkaziladi.',
      },
      SchedulePage: {
        checkQueue: 'Navbatingizni tekshiring',
      },
      ReportsForSchool: {
        fieldNotFilled: 'Поля не заполнены',
        schoolsStat: 'Статистика автошкол',
        search: 'Поиск',
        from: 'С',
        to: 'По',
        clear: 'Очистить',
      },
      FinesDetails: {
        from: 'dan',
        to: 'gacha',
        penalty: 'Jarima',
        yes: 'Ha',
        no: "Yo'q",
        search: 'Qidiruv',
        clear: 'Tozalash',
        createdAt: 'Yaratilgan sana',
        appLink: 'Ariza havolasi',
        branch: 'Filial',
        fixed: 'Tuzatilgan',
        details: 'Tafsilotlar',
        go: "O'tish",
      },
      FinesPage: {
        from: 'dan',
        to: 'gacha',
        search: 'Qidiruv',
        clear: 'Tozalash',
        fullName: 'F.I.Sh.',
        phone: 'Телефон',
        branch: 'Филиал',
        finesNumber: 'Jarimalar soni',
        details: 'Tafsilotlar',
        go: "O'tish",
      },
      OfficialReportByIdPage: {
        appConfirmed: 'Ariza tasdiqlandi',
        error: "Xato, keyinroq harakat qilib ko'ring",
        title: "Ma'lumotlar uchun so'rov",
        penalty: 'Jarima',
        confirm: 'Tasdiqlash',
        confirmedBy: 'Kim tomonidan tasdiqlangan',
        currentData: "Joriy ma'lumotlar",
        firstName: 'Ism',
        lastName: 'Familiyasi',
        middleName: 'Otasining ismi',
        dateOfBirth: "Tug'ilgan sana",
        passportSerial: 'Pasport seriyasi',
        passportNumber: 'Pasport raqami',
        passportValid: 'Pasport muddati',
        dateMed: "Tibbiy ma'lum muddati",
        changeData: "O'zgartirish ma'lumotlari",
        fullName: 'F.I.SH.',
        passportSerialNumber: 'Pasport seriyasi / raqami',
        pinfl: 'JShShIR',
        branch: 'Filial',
        status: 'Status',
        phone: 'Telefon',
        transactionDate: 'Tranzaksiya sanasi',
        cardTypeNumber: 'Karta turi / raqami',
        sum: 'Miqdori',
        report: 'Hisobot',
      },
      OfficialReportsPage: {
        title: "O'zgartirish uchun so'rovlar. ma'lumotlar",
        completed: 'Tugallangan',
        all: 'Hammasi',
        yes: 'Ha',
        no: "Yo'q",
        activity: 'Faoliyat',
        branch: 'Filial',
        user: 'Foydalanuvchi',
        search: 'Qidiruv',
        clear: 'Tozalash',
        createdAt: 'Yaratilgan sana',
        type: 'Turi',
        appLink: 'Ariza havolasi',
        candidate: 'Nomzod',
        confirmedBy: 'Kim tomonidan tasdiqlangan',
        status: 'Holati',
        step: 'Qadam',
        penalty: 'Jarima',
        accomplishment: 'Amalga oshirish',
        details: 'Tafsilotlar',
        confirmed: 'Tasdiqlangan',
        new: 'Yangi',
        data: "Ma'lumotlar",
        refund: 'Qaytarish',
      },
      AppealPageById: {
        fio: 'F.I.Sh.',
        passportSerial: 'Seriya / pasport raqami',
        phone: 'Telefon',
        dateOfBirth: "Tug'ilgan sana",
        examType: 'Imtihon turi',
        applicaiton: 'Ariza',
        applicaitionLink: 'Ariza havolasi',
        title: 'Apellyatsiya komissiyasining qarori',
      },
      AppealsPage: {
        appeal: 'Apellyatsiya',
        fio: 'F.I.Sh.',
        phone: 'Telefon',
        createdAt: 'Yaratilgan sana',
        examType: 'Imtihon turi',
        actions: 'Harakatlar',
        choiceBranch: 'Filialni tanlang',
        all: 'Hammasi',
      },
      //fix
      ReportPage: {
        //fix
        reportHistory: 'История протокола',
        FIO: 'ФИО',
        category: 'Категория',
        school: 'Школа',
        theryAttempt: 'Попытки теория',
        thoryScore: 'Балы теория',
        practiceAttempt: 'Поптыки практика',
        practiceScore: 'Сдал/Не сдал',
        passed: 'Сдал',
        notPassed: 'Не сдал',
        certificateNumber: 'Номер сертификата',
        print: 'Распечатать',
      },
      ReportsPage: {
        enterDate: 'Sanani kiriting',
        count: 'Miqdori',
        actions: 'Harakat',
        createdAt: 'Yaratilgan sana',
        dayNumber: 'Protokol yaratish raqami',
        reports: 'Protokollar',
        generation: 'Yaratish',
        name: 'Nomi',
        date: 'Sana',
        clear: 'Tozalash',
        search: 'Qidiruv',
        branches: 'Filiallar',
        from: 'dan',
        protocolNumber: 'Protokol raqami',
      },
      SummaryPage: {
        branch: 'Filial',
        from: 'С',
        to: 'По',
        branches: 'Filiallar',
        summary: 'Xulosa',
        application: 'Ariza',
        clear: 'Tozalash',
        search: 'Qidirish',
        fio: 'F.I.Sh',
        appCode: 'Ariza kodi',
        status: 'Status',
        createdAt: 'Yaratilgan sana',
        firstName: 'Ism',
        lastName: 'Familiya',
        middleName: 'Otasining ismi',
        categories: 'Kategoriya',
        vehicleTypes: 'Avtomobil turi',
        oldStatus: 'Oldingi holat',
        newStatus: 'Yangi holat',
        attempt: 'Urinish',
        attempts: 'Urinishlar',
        firstAttempt: "Birinchi urinib ko'rish",
        retake: 'Qayta olish',
        passport: 'Seriya/pasport raqami',
        phone: 'Telefon',
        result: 'Natija',
        true: 'Muvaffaqiyatli',
        false: 'Muvaffaqiyatsiz',
      },
      UpdateClassRoomPage: {
        choiceBranch: 'Выберите филиал',
        nameError: 'Название кабинета уже существует',
        fillFields: 'Заполните поля',
        updatedClassRoom: 'Кабинет изменен',
        updateClassRoom: 'Изменить кабинет',
        enterName: 'Введите название',
        back: 'Назад',
        save: 'Сохранить',
      },
      //fix
      CreateClassRoomPage: {
        choiceBranch: 'Выберите филиал',
        nameError: 'Название кабинета уже существует',
        fillFields: 'Заполните поля',
        createdClassRoom: 'Кабинет создан',
        createClassRoom: 'Создать кабинет',
        name: 'Название',
        back: 'Назад',
        save: 'Сохранить',
      },
      //fix
      ClassRoomsPage: {
        classRooms: 'Кабинеты',
        deleted: 'Кабинет удален',
        wantDeleteClassRoom: 'Вы действительно хотите удалить этот кабинет?',
        updatedDate: 'Дата изменения',
        actions: 'Действия',
        name: 'Название',
        classRoom: 'Кабинет',
      },
      ApplicationForGai: {
        fio: 'F.I.Sh.',
        passport: 'Pasport',
        dateOfBirth: "Tug'ilgan sanasi",
        phone: 'Telefon',
        vehicleType: 'Transport vositasining turi',
      },
      ApplicationsForGai: {
        application: 'Arizalar',
        clear: 'Tozalash',
        search: 'Qidiruv',
        fio: 'F.I.Sh.',
        phone: 'Telefon',
        appCode: 'Arizaning kodi',
        passCode: 'Beyjik raqami',
        status: 'Status',
        category: 'Toifa',
        transportType: 'Transport vositasining turi',
        updatedAt: "O'zgartirishlar kiritilgan sanasi",
        actions: 'Harakatlar',
        serial: 'Seriyasi',
        number: 'Raqami',
        pinfl: 'JShShIR',
        createdAt: 'Yaratilgan sanasi',
        endDate: 'Tugash sanasi',
        firstName: 'Ismi',
        lastName: 'Familiyasi',
        middleName: 'Otasining ismi',
        categories: 'Toifa',
        vehicleTypes: 'Transport vositalari',
        statuses: 'Status',
      },
      VisitLogsPage: {
        visitLogs: "Tashriflar ro'yxati",
        date: 'Sana',
        search: 'Qidiruv',
        clear: 'Tozalash',
        fio: 'F.I.Sh.',
        dateOfBirth: "Tug'ilgan sanasi",
        passport: 'Pasport seriyasi/raqami',
        appCategory: 'Arizaning turi',
        createdAt: 'Yaratilgan sanasi',
        status: 'Status',
      },
      VehicleTypesPage: {
        deleted: "Muvaffaqiyatli o'chirildi",
        wantDeleteVehicle:
          "Siz haqiqatan ham transport vositasini o'chirishni xohlaysizmi?",
        vehicleTypes: 'Transport vositalari',
        name: 'Nomi',
        actions: 'Harakatlar',
      },
      UsersPage: {
        error: "Xatolik yuz berdi. Bir ozdan keyin urinib ko'ring",
        users: 'Foydalanuvchilar',
        serial: 'Seriyasi',
        number: 'Raqami',
        firstName: 'Ismi',
        lastName: 'Familiyasi',
        middleName: 'Otasining ismi',
        search: 'Qidiruv',
        clear: 'Tozalash',
        passport: 'Pasport seriyasi/raqami',
        pinfl: 'JShShIR',
        fio: 'F.I.Sh.',
        phone: 'Telefon raqami',
        integrated: 'Itegratsiya qilingan',
        role: 'Roli',
        verrified: 'Tasdiqlangan',
        status: 'Status',
        actions: 'Harakatlar',
      },
      UserIdentificationPage: {
        error: "Xatolik yuz berdi. Bir ozdan keyin urinib ko'ring",
        applicationNotFound: 'Ariza topilmadi',
        userNotActive: 'Foydalanuvchi faol emas',
        statusError: 'Status xatosi',
        appNotVerrified: 'Ariza tasdiqlanmagan',
        fio: 'F.I.Sh.',
        dateOfBirth: "Tug'ilgan sanasi",
        phone: 'Telefon raqami',
        passport: 'Pasport seriyasi/raqami',
        pinfl: 'JShShIR',
        appStatus: 'Arizaning statusi',
        appCategory: 'Arizaning turi',
        failureDays:
          "Imtihonni qayta topshirish uchun avvalgi imtihon topshirilgan kunidan 7 ish kuni o'tishi kerak",
        success: 'Muvaffaqiyatli',
        passportExp: 'Pasportning amal qilish muddati',
        medicalCertValid: 'Tibbiy atamalarga havolalar',
      },
      UpdateVehicleTypePage: {
        fillFields: "Kataklarni to'ldiring",
        vehicletypeUpdated: "Transport vositasi o'zgartirildi",
        updateVehicleType: "Transport vositasini o'zgartirish",
        enterName: 'Nomini kiriting',
        back: 'Orqaga qaytish',
        save: 'Saqlash',
      },
      //fix
      UpdateUserPage: {
        motordrome: 'Автодром',
        phoneError: 'Bunday telefon bilan foydalanuvchi mavjud',
        passportError: 'Bunday pasport bilan foydalanuvchi mavjud',
        pinflError: 'Bunday JShShIR bilan foydalanuvchi mavjud',
        updateUser: 'Foydalanuvchini yangilash',
        serial: 'Seriyasi',
        number: 'Raqami',
        phone: 'Telefon raqami',
        role: 'Roli',
        firstName: 'Ismi',
        lastName: 'Familiyasi',
        middleName: 'Otasining ismi',
        dateOfBirth: "Tug'ilgan sanasi",
        pinfl: 'JShShIR',
        getToken: 'Tokenni qabul qilish',
        back: 'Orqaga qaytish',
        save: 'Saqlash',
      },
      //fix
      UpdateStatusPage: {
        updateStatus: 'Statusni yangilash',
        type: 'Turini tanlang',
        queue: 'Navbatni tanlang',
        pass: 'Beyjik',
        pay: "To'lov",
        name: 'Nomi',
        titleLat: "O'zbek tilidagi sarlavha (lotin alifbosi)",
        titleCyr: "O'zbek tilidagi sarlavha (Kirill alifbosi)",
        titleRu: 'Rus tilidagi sarlavha',
        order: 'Tartib',
        back: 'Orqaga qaytish',
        update: 'Yangilash',
        vehicleType: 'Transport vositalari',
      },
      //fix
      UpdatePracticePenaltyPage: {
        updatePenalty: 'Jarima ballarini yangilash',
        nameLat: "O'zbek tilidagi nomi (lotin alifbosi)",
        nameCyr: "O'zbek tilidagi nomi (Kirill alifbosi)",
        nameRu: 'Rus tilidagi nomi',
        points: 'Ballar',
        cancel: 'Bekor qilish',
        save: 'Saqlash',
        code: 'Код',
        codeError: 'Данный код уже существует',
      },
      //fix
      UpdatePracticeExercisesPage: {
        updateExercise: 'Mashqni yangilash',
        nameLat: "O'zbek tilidagi nomi (lotin alifbosi)",
        nameCyr: "O'zbek tilidagi nomi (Kirill alifbosi)",
        nameRu: 'Rus tilidagi nomi',
        cancel: 'Bekor qilish',
        save: 'Saqlash',
        code: 'Код',
        codeError: 'Данный код уже существует',
      },
      UpdateErrorTypePage: {
        fillFields: "Kataklarni to'ldiring",
        errorTypeChanged: "Xato turi o'zgartirildi",
        error: "Xatolik yuz berdi. Bir ozdan keyin urinib ko'ring",
        updateErrorType: "Xato turini o'zgartirish",
        nameCyr: "O'zbek tilidagi nomi (Kirill alifbosi)",
        nameLat: "O'zbek tilidagi nomi (lotin alifbosi)",
        nameRu: 'Rus tilidagi nomi',
        back: 'Orqaga qaytish',
        save: 'Saqlash',
      },
      UpdateDocPage: {
        required: 'Обязательный/Не обязательный',
        nameConflict: 'Документ с таким названием уже существует',
        fillFields: "Kataklarni to'ldiring",
        docUpdated: "Xujjat o'zgartirildi",
        error: "Xatolik yuz berdi. Bir ozdan keyin urinib ko'ring",
        updateDocument: 'Xujjatni tahrirlash',
        docName: 'Xujjat nomi',
        nameCyr: "O'zbek tilidagi nomi (Kirill alifbosi)",
        nameLat: "O'zbek tilidagi nomi (lotin alifbosi)",
        nameRu: 'Rus tilidagi nomi',
        back: 'Orqaga qaytish',
        save: 'Saqlash',
      },
      //fix
      UpdateCategoryPage: {
        fillFields: "Kataklarni to'ldiring",
        categoryUpdated: "Toifasi o'zgartirildi",
        error: "Xatolik yuz berdi. Bir ozdan keyin urinib ko'ring",
        updateCategory: 'Toifani tahrirlash',
        data: "Ma'lumotlar",
        statuses: 'Statuslar',
        categoryName: 'Toifa nomi',
        nameCyr: "O'zbek tilidagi nomi (Kirill alifbosi)",
        nameLat: "O'zbek tilidagi nomi (lotin alifbosi)",
        nameRu: 'Rus tilidagi nomi',
        order: 'Tartib',
        selectDocuments: 'Xujjatni tanlang',
        back: 'Orqaga qaytish',
        save: 'Saqlash',
        vehicleTypes: 'Transport vositalari',
      },
      ApplicationHistoryPage: {
        branch: 'Filial',
        actions: 'Harakatlar',
        more: 'Batafsil',
        applicationHistory: 'Ariza tarixi',
        history: 'Tarix',
        result: 'Natija',
        sucess: "To'g'ri",
        fail: "Noto'g'ri",
        answer: 'Javob',
        question: 'Savol',
        ticketNumber: 'Bilet raqami',
        createdDate: 'Yaratilgan sana',
        statuses: 'Statuslar',
        transactions: 'Tranzaksiyalar',
        results: 'Natijalar',
        oldStatus: 'Oldingi holat',
        nextStatus: 'Keyingi holat',
        currentStatus: 'Joriy holat',
        category: 'Toifasi',
        errorMessage: 'Muvaffaqiyatli bloklandi',
        error: 'Xato, keyinroq qayta urinib ko‘ring',
        sent: 'Yuborildi',
        dateSendingToGai: 'GAIga yuborilgan sana',
        lastSubmissionDate: 'Oxirgi topshirish sanasi',
        status: 'Status GAI',
        message: 'Xabar',
        appeal: 'Apellyatsiya',
        resend: 'Qayta yuborish',
        block: 'Bloklash',
        unblock: 'Blokdan chiqarish',
        attempt: 'Urinish',
        yesNo: "Muvaffaqiyatli / Yo'q",
      },
      UpdateApplicationPage: {
        resident: 'O‘zbekiston Respublikasi fuqarosi',
        noResident: 'Xorijiy davlat fuqarosi',
        isForeigner:
          'O‘zbekiston Respublikasi fuqarosi / Xorijiy davlat fuqarosi',
        time: 'Soat',
        branch: 'Filial',
        choiceBranch: 'Filialni tanlang',
        residencePlace: 'Yashash joyi',
        more: 'Ilova haqida batafsil',
        uploadDocuments: "Hujjatlarni to'ldiring",
        notInList: "Ro'yxatda yo'q",
        enterSchoolName: 'Avtomaktabninig nomini kiriting',
        choiceSchool: 'Avtomaktabni tanlang',
        selectLanguage: "Imtihonni o'tkazish tilini tanlang",
        visitDateNotValid: 'Не верная дата визита в центр',
        visitDate: 'Markazga tashrif buyurgan sanasi',
        verification: 'Верифицированный пользователь',
        confirmedApplication: 'Ariza tasdiqlangan',
        printCertificate: 'Sertifikatni chop etish',
        correctPhone: "Telefon raqamini to'g'ri kiriting",
        userNotReceived: "Foydalanuvchining ma'lumotlari qabul qilinmadi",
        fillFields: "Kataklarni to'ldiring",
        vehicleType: 'Transport vositasining turini belgilang',
        applicationsUpdated: "Ariza o'zgartirildi",
        error: "Xatolik yuz berdi. Bir ozdan keyin urinib ko'ring",
        canceledApplication: 'Arizani bekor qiling',
        passportConflict: 'Bunday pasport bilan foydalanuvchi mavjud',
        applicationRejected: 'Ariza rad etildi',
        application: 'Ariza',
        updateApplication: "Arizani o'zgartirish",
        cancelApp: 'Arizani bekor qilish',
        save: 'Saqlash',
        appData: "Arizaning ma'lumotlari",
        transport: 'Transport vositasi',
        userData: "Foydalanuvchining ma'lumotlari",
        userPhone: 'Foydalanuvchining telefon raqamini kiriting',
        passportSeries: 'Pasport seriyasi',
        passportNumber: 'Pasport raqami',
        pinfl: 'JShShIR',
        firstName: 'Ismi',
        lastName: 'Familiyasi',
        middleName: 'Otasining ismi',
        dateOfBirth: "Tug'ilgan sanasi",
        back: 'Orqaga qaytish',
        phone: 'Telefon raqami',
        category: 'Toifasi',
        transportType: 'Transport vositasining turi',
        reasonsRejectedApp: 'Arizani rad etish sabablari',
        docsList: "Xujjatlarning ro'yxati",
        passIssue: 'Beyjikni rasmiylashtirish',
        selectCategoryAndTryAgain: "Toifani tanlab qayta urinib ko'ring",
        passIssued: 'Beyjik rasmiylashtirildi',
        confirmApplication: 'Arizani tasdiqlash',
        errorTryLater: "Xatolik yuz berdi. Bir ozdan keyin urinib ko'ring",
        conflictPinfl: 'Пользователь с таким ПИНФЛ уже существует',
        conflictSerialNumber:
          'Bunday seriya va pasport raqamiga ega foydalanuvchi allaqachon mavjud',
        conflictPhone:
          'Ushbu telefon raqamiga ega foydalanuvchi allaqachon mavjud',
        requestChanges: "O'zgarishlarni so'rash",
        blacklisted: "Qora ro'yxatga qo'shing",
        unblock: 'Blokdan chiqarish',
        reason: "Nomzodni qora ro'yxatga qo'shish sababini ko'rsating.",
        note: 'Eslatma',
        update: "O'zgartirish",
        add: "Qo'shish",
        submitAReport: 'Hisobot yuboring',
        CREATED: 'Yaratilgan',
        NOT_VERIFIED: 'Tasdiqlanmagan',
        T_PAYMENT: "Nazariy imtihon uchun to'lang",
        T_EXAM: "Nazariy imtihondan o'ting",
        T_FAILED: "Siz nazariy imtihondan o'ta olmadingiz.",
        P_PAYMENT: "Amaliyot imtihonini to'lang",
        P_EXAM: "Amaliyot imtihonidan o'ting",
        P_FAILED: "Siz amaliy imtihondan o'ta olmadingiz.",
        COMPLETED: 'Muvaffaqiyatli yakunlandi',
        appeal: 'Apellyatsiya',
        noVerified: 'Tasdiqlanmagan',
        verified: 'Tasdiqlangan',
        passportValidity: 'Pasportning amal qilish muddati',
        medCertificateValidity: "Tibbiy ma'l. amal qilish muddati",
      },
      TransactionsPage: {
        transactions: 'Tranzaksiyalar',
        fio: 'F.I.Sh.',
        paymentDate: "To'lov sanasi",
        paymentType: "To'lov turlari",
        sum: 'Summasi',
        passport: 'Pasport seriyasi/raqami',
        pinfl: 'JShShIR',
        id: 'ID',
        cardNumber: 'Карта(4 посл цифры)',
        datails: 'Детали',
        cashierName: 'Ф.И.О кассира',
        CASH: 'Наличные',
        TERMINAL: 'Терминал',
        PAYME: 'Payme',
        CLICK: 'Сlick',
        FREE: 'Бесплатно',
        REFUND: 'Возврат',
        UZCARD: 'UZCARD',
        HUMO: 'HUMO',
        BANK: 'BANK',
        EPOS: 'EPOS',
        THEORY_PAYMENT: 'Теоретический экзамен',
        PRACTICE_PAYMENT: 'Практический экзамен',
        examType: 'Тип экзамена',
        createdAt: 'C',
        endDate: 'По',
        branch: 'Филиал',
        appId: 'ID заявки',
        qrCode: 'QR код',
        exportExcel: 'Экспортировать в EXCEL',
        totalSum: 'Общая сумма',
        failedTheTheory: 'Провалил теорию',
        retake: 'Пересдача',
        paymentOnAnotherDay: 'Оплата в другой день',
        applyForRefund: 'Подать на возврат',
        changeTransactionType: 'Изменить тип транзакции',
        go: 'Перейти',
        transactionType: 'Тип транзакции',
        change: 'Изменить',
        search: 'Поиск',
        clear: 'Очистить',
        QR: 'QR'
      },
      StatusesPage: {
        categoryDeleted: 'Toifa olib tashlandi',
        error: "Xatolik yuz berdi. Bir ozdan keyin urinib ko'ring",
        statuses: 'Statuslar',
        order: 'Tartib',
        name: 'Nomi',
        titleLat: "O'zbek tilidagi nomi (lotin alifbosi)",
        titleCyr: "O'zbek tilidagi nomi (Kirill alifbosi)",
        titleRu: 'Rus tilidagi nomi',
        pass: 'Beyjik',
        actions: 'Harakatlar',
        wantDeleteStatus: "Siz haqiqatan ham statusni o'chirmoqchimisiz?",
      },
      PracticePenaltiesPage: {
        penaltiesDeleted: "Jarima ballari o'chirildi",
        error: "Xatolik yuz berdi. Bir ozdan keyin urinib ko'ring",
        penalties: 'Jarimalar',
        nameLat: "O'zbek tilidagi nomi (lotin alifbosi)",
        nameCyr: "O'zbek tilidagi nomi (Kirill alifbosi)",
        nameRu: 'Rus tilidagi nomi',
        penaltyPoints: 'Jarima ballari',
        actions: 'Harakatlar',
        code: 'Код',
        wantDeletePenalty:
          "Siz haqiqatan ham jarima ballarini o'chirmoqchimisiz?",
      },
      PracticeExercisesPage: {
        exserciseDeleted: "Mashq o'chirildi",
        error: "Xatolik yuz berdi. Bir ozdan keyin urinib ko'ring",
        praticeExercises: 'Amaliy mashqlar',
        titleLat: "O'zbek tilidagi sarlavha (lotin alifbosi)",
        titleCyr: "O'zbek tilidagi sarlavha (Kirill alifbosi)",
        titleRu: 'Rus tilidagi sarlavha',
        wantDeleteExercise: "Siz haqiqatan ham mashqni o'chirmoqchimisiz?",
        code: 'Код',
      },
      PaymentPage: {
        payment: "To'lov",
        search: 'Qidiruv',
        fio: 'F.I.Sh.',
        categories: 'Toifa',
        statuses: 'Status',
        certificate: 'Sertifikat',
        printCertificate: 'Sertifikatni chop etish',
        sum: 'Summasi',
        allSum: 'Umumiy summasi',
        cash: 'Naqd',
        bankCard: 'Terminal',
        pay: "To'lash",
        payDate: "To'lov sanasi",
        paymentType: "To'lov turlari",
        error: 'Xato',
        lastDigitsOfBankCard: 'Посл 4 цифры банк карты',
      },
      ErrorTypesPage: {
        name: 'Nomi',
        createdAt: 'Yaratilgan sanasi',
        actions: 'Harakatlar',
        errorTypeDeleted: "Xato turi o'chirildi",
        error: "Xatolik yuz berdi. Bir ozdan keyin urinib ko'ring",
        errors: 'Xatolar',
      },
      MotordromesPage: {
        motordromeDeleted: 'Автодром удален',
        error: "Xatolik yuz berdi. Bir ozdan keyin urinib ko'ring",
        wantDeleteMotordrome: 'Вы действительно хотите удалить автодром?',
        motordromes: 'Автодромы',
        name: 'Nomi',
        createdAt: 'Yaratilgan sanasi',
        actions: 'Harakatlar',
      },
      SchoolPage: {
        tin: 'ИНН',
        schoolDeleted: 'Школа удалена',
        error: "Xatolik yuz berdi. Bir ozdan keyin urinib ko'ring",
        wantDeleteSchool: 'Вы действительно хотите удалить школу?',
        search: 'Поиск',
        clear: 'Очистить',
        schools: 'Школы',
        enterName: 'Введите название для поиска',
        name: 'Название',
        createdAt: 'Дата создания',
        actions: 'Действия',
      },
      DocsPage: {
        docDeleted: "Xujjat o'chirildi",
        error: "Xatolik yuz berdi. Bir ozdan keyin urinib ko'ring",
        wantDeleteDoc: "Siz haqiqatan ham xujjatni o'chirmoqchimisiz?",
        docs: 'Xujjatlar',
        name: 'Nomi',
        createdAt: 'Yaratilgan sanasi',
        actions: 'Harakatlar',
      },
      CreateVehicleTypePage: {
        fillFields: "Kataklarni to'ldiring",
        createdVahicleType: 'Transport vositasining turi yaratildi',
        createCategory: "Avtomobilni haydash bo'yicha toifani yaratish",
        name: 'Nomini kiriting',
        back: 'Orqaga qaytish',
        save: 'Saqlash',
      },
      CreateStatusPage: {
        createStatus: 'Status yaratish',
        type: 'Turini tanlang',
        queue: 'Navbatni tanlang',
        pass: 'Beyjik',
        payment: "To'lov",
        name: 'Nomi',
        titleLat: "O'zbek tilidagi nomi (lotin alifbosi)",
        titleCyr: "O'zbek tilidagi nomi (Kirill alifbosi)",
        titleRu: 'Rus tilidagi nomi',
        order: 'Tartib',
        back: 'Orqaga qaytish',
        save: 'Saqlash',
        vehicleType: 'Transport vositalari',
      },
      CreatePracticePenaltyPage: {
        createPenalty: 'Jarima ballarini yaratish',
        nameLat: "O'zbek tilidagi nomi (lotin alifbosi)",
        nameCyr: "O'zbek tilidagi nomi (Kirill alifbosi)",
        nameRu: 'Rus tilidagi nomi',
        scores: 'Ballar',
        cancel: 'Bekor qilish',
        save: 'Saqlash',
        code: 'Код',
        codeError: 'Данный код уже существует',
      },
      CreatePracticeExercisesPage: {
        createExercisse: 'Mashq yaratish',
        nameLat: "O'zbek tilidagi nomi (lotin alifbosi)",
        nameCyr: "O'zbek tilidagi nomi (Kirill alifbosi)",
        nameRu: 'Rus tilidagi nomi',
        cancel: 'Bekor qilish',
        save: 'Saqlash',
        code: 'Код',
        codeError: 'Данный код уже существует',
      },
      CreateErrorTypePage: {
        fillFields: "Kataklarni to'ldiring",
        error: "Xatolik yuz berdi. Bir ozdan keyin urinib ko'ring",
        errorCreateSuccesed: 'Xato turi muvaffaqiyatli yaratildi',
        createError: 'Xato turini yaratish',
        nameCyr: "O'zbek tilidagi nomi (Kirill alifbosi)",
        nameLat: "O'zbek tilidagi nomi (lotin alifbosi)",
        nameRu: 'Rus tilidagi nomi',
        back: 'Orqaga qaytish',
        save: 'Saqlash',
      },
      UpdateMotordromePage: {
        nameCyr: "O'zbek tilidagi nomi (Kirill alifbosi)",
        nameLat: "O'zbek tilidagi nomi (lotin alifbosi)",
        nameRu: 'Rus tilidagi nomi',
        conflictError: 'Автодром в данной очереди уже существует',
        selectQueue: 'Выберите очередь',
        updateMotordrome: 'Изменить автодром',
        fillFields: "Kataklarni to'ldiring",
        error: "Xatolik yuz berdi. Bir ozdan keyin urinib ko'ring",
        updatedMotordrome: 'Автодром изменен',
        name: 'Название автодрома',
        back: 'Orqaga qaytish',
        save: 'Saqlash',
        vehicleTypes: 'Transport vositalari',
      },
      CreateMotordromePage: {
        conflictError: 'Автодром в данной очереди уже существует',
        selectQueue: 'Выберите очередь',
        fillFields: "Kataklarni to'ldiring",
        error: "Xatolik yuz berdi. Bir ozdan keyin urinib ko'ring",
        motordromeCreatedSuccess: 'Автодром создан успешно',
        createMotordrome: 'Создать автодром',
        nameCyr: "O'zbek tilidagi nomi (Kirill alifbosi)",
        nameLat: "O'zbek tilidagi nomi (lotin alifbosi)",
        nameRu: 'Rus tilidagi nomi',
        name: 'Название автодрома',
        back: 'Orqaga qaytish',
        save: 'Saqlash',
        vehicleTypes: 'Transport vositalari',
      },
      UpdateSchoolPage: {
        tin: 'ИНН',
        conflict: 'Школа уже существует',
        tinConflict: 'Школа с таким ИНН уже существует',
        fillFields: 'Заполните поля',
        error: 'Произошла ошибка, попробуйте позже',
        name: 'Название школы',
        save: 'Сохранить',
        back: 'Назад',
        updateSchool: 'Изменить школу',
        updatedSchool: 'Школа изменена',
      },
      CreateSchoolPage: {
        tin: 'ИНН',
        conflict: 'Школа уже существует',
        fillFields: "Kataklarni to'ldiring",
        error: "Xatolik yuz berdi. Bir ozdan keyin urinib ko'ring",
        schoolCreatedSuccess: 'Школа создана успешно',
        createSchool: 'Создать школу',
        name: 'Название школы',
        save: 'Saqlash',
        back: 'Orqaga qaytish',
      },
      CreateDocPage: {
        required: 'Обязательный/Не обязательный',
        nameConflict: 'Документ с таким названием уже существует',
        fillFields: "Kataklarni to'ldiring",
        error: "Xatolik yuz berdi. Bir ozdan keyin urinib ko'ring",
        docCreateSuccesed: 'Xujjat muvaffaqiyatli yaratildi',
        createDoc: 'Xujjatni yaratish',
        nameCyr: "O'zbek tilidagi nomi (Kirill alifbosi)",
        nameLat: "O'zbek tilidagi nomi (lotin alifbosi)",
        nameRu: 'Rus tilidagi nomi',
        name: 'Xujjatning nomi',
        back: 'Orqaga qaytish',
        save: 'Saqlash',
      },
      CreateCategoryPage: {
        fillFields: "Kataklarni to'ldiring",
        error: "Xatolik yuz berdi. Bir ozdan keyin urinib ko'ring",
        categoryCreatSuccessed: 'Toifa muvaffaqiyatli yaratildi',
        createdCategory: 'Toifani yaratish',
        categoryName: 'Toifa nomi',
        nameCyr: "O'zbek tilidagi nomi (Kirill alifbosi)",
        nameLat: "O'zbek tilidagi nomi (lotin alifbosi)",
        nameRu: 'Rus tilidagi nomi',
        order: 'Tartib',
        selectDocuments: 'Xujjatni tanlang',
        back: 'Orqaga qaytish',
        save: 'Saqlash',
        vehicleTypes: 'Transport vositalari',
      },
      CreateApplicationPageByUser: {
        resident: 'O‘zbekiston Respublikasi fuqarosi',
        noResident: 'Xorijiy davlat fuqarosi',
        isForeigner:
          'O‘zbekiston Respublikasi fuqarosi / Xorijiy davlat fuqarosi',
        choiceBranch: 'Filialni tanlang',
        residencePlace: 'Yashash joyi',
        enterSchoolName: 'Avtomaktabninig nomini kiriting',
        notInList: "Ro'yxatda yo'q",
        choiceSchool: 'Avtomaktabni tanlang',
        fillFields: "Kataklarni to'ldiring",
        selectLanguage: "Imtihonni o'tkazish tilini tanlang",
        visitDateNotValid: 'Не верная дата визита в центр',
        visitDate: 'Markazga tashrif buyurgan sanasi',
        fillDocs: 'Заполните документы',
        selectCategory: 'Toifani tanlang',
        applicationSuccessCreated: 'Ariza muvaffaqiyatli yaratildi',
        error: "Xatolik yuz berdi. Bir ozdan keyin urinib ko'ring",
        vehicleType: 'Transport vositasinining turini belgilang',
        createApplication: 'Ariza yaratish',
        selectVehicleType: 'Transport vositasinining turini tanlang',
        documentList: "Xujjatlar ro'yxati",
        back: 'Orqaga qaytish',
        save: 'Saqlash',
        applicationAlreadyExists: 'Bunday toifali ariza mavjud',
        time: 'Soat',
      },
      CreateApplicationPage: {
        send: 'Yuborish',
        resident: 'O‘zbekiston Respublikasi fuqarosi',
        noResident: 'Xorijiy davlat fuqarosi',
        isForeigner:
          'O‘zbekiston Respublikasi fuqarosi / Xorijiy davlat fuqarosi',
        residencePlace: 'Место проживания',
        notInList: 'Нет в списке',
        enterSchoolName: 'Введите название автошколы',
        choiceSchool: 'Выберите автошколу',
        clear: 'Очистить',
        selectLanguage: "Imtihonni o'tkazish tilini tanlang",
        fillFields: "Kataklarni to'ldiring",
        vehicleType: 'Transport vositasinining turini belgilang',
        uploadDocuments: 'Xujjatlarni yuklang',
        applicationSuccessCreated: 'Ariza muvaffaqiyatli yaratildi',
        applicationAlreadyExists: 'Bunday toifali ariza mavjud',
        error: "Xatolik yuz berdi. Bir ozdan keyin urinib ko'ring",
        userNotFound: 'Foydalanuvchi topilmadi',
        createApplication: 'Ariza yaratish',
        enterPhoneNumber: 'Foydalanuvchining telefon raqamini kiriting',
        pinfl: 'JShShIR',
        passportSerial: 'Pasport seriyasi',
        passportNumber: 'Pasport raqami',
        selectCategory: 'Toifani tanlang',
        selectVehicleType: 'Transport vositasinining turini tanlang',
        userData: "Foydalanuvchining ma'lumotlari",
        firstName: 'Ismi',
        lastName: 'Familiyasi',
        middleName: 'Otasining ismi',
        dateOfBirth: "Tug'ilgan sanasi",
        documentList: "Xujjatlar ro'yxati",
        back: 'Orqaga qaytish',
        save: 'Saqlash',
        passIssued: 'Пропуск оформлен',
        choiceCategory: 'Toifani tanlang',
        enterPassport: 'Введите серию и номер паспорта',
        errorPinfl: "JSHSHIR ma'lumotlarida xatolik mavjud",
        errorPhone: 'Telefon raqamida xatolik mavjud',
        passportExp: 'Срок паспорта',
        medicalCertValid: 'Срок мед. справки',
        getData: "Ma'lumotlarni olish",
      },
      CategoriesPage: {
        deletedCategory: "Toifa o'chirildi",
        error: 'Xatolik yuz berdi',
        wantDeleteCategory: "Siz haqiqatan ham toifani o'chirmoqchimisiz?",
        categories: 'Toifalar',
        name: 'Nomi',
        createdAt: 'Yaratilgan sanasi',
        actions: 'Harakatlar',
      },
      CashPayment: {
        cashPayment: "Naqd to'lov",
        fio: 'F.I.Sh.',
        passport: 'Pasport seriyasi/raqami',
        pinfl: 'JShShIR',
        date: "To'lov sanasi",
        sum: "To'lov summasi",
        details: 'Tafsilotlar',
        amountEnclosed: 'Inkassatsiya qilingan summa',
        dateEnclosed: 'Inkassatsiya qilingan sana',
        fioCashier: "To'lovni qabul qilgan kassirning F.I.Sh.",
        idMachine: "To'lov qurilmasining identifikatsiya raqami",
      },
      BankCardPayment: {
        cardPayment: "Bank kartasi orqali to'lov",
        fio: 'F.I.Sh.',
        passport: 'Pasport seriyasi/raqami',
        pinfl: 'JShShIR',
        date: "To'lov sanasi",
        sum: "To'lov summasi",
        details: 'Tafsilotlar',
        lastNumber: 'Последние 4 цифры банк карты',
        fioCashier: "To'lovni qabul qilgan kassirning F.I.Sh.",
        idMachine: "To'lov qurilmasining identifikatsiya raqami",
      },
      ApplicationsPage: {
        operator: 'Operator',
        branch: 'Filial',
        application: 'Arizalar',
        clear: 'Tozalash',
        search: 'Qidiruv',
        fio: 'F.I.Sh.',
        phone: 'Telefon',
        appCode: 'Arizaning kodi',
        passCode: 'Beyjik raqami',
        status: 'Holat',
        category: 'Toifa',
        transportType: 'Transport vositasining turi',
        updatedAt: "O'zgartirishlar kiritilgan sanasi",
        actions: 'Harakatlar',
        serial: 'Seriyasi',
        number: 'Raqami',
        pinfl: 'JShShIR',
        createdAt: 'Yaratilgan sanasi',
        endDate: 'Tugash sanasi',
        firstName: 'Ismi',
        lastName: 'Familiyasi',
        middleName: 'Otasining ismi',
        categories: 'Toifa',
        vehicleTypes: 'Transport vositalari',
        statuses: 'Status',
        creationType: 'Ariza turi',
        choiceSchool: 'Выберите школу',
        dateOfBirth: 'Дата рождения',
        CREATED: 'Yaratilgan',
        NOT_VERIFIED: 'Tasdiqlanmagan',
        T_PAYMENT: "Nazariy imtihon uchun to'lang",
        T_EXAM: "Nazariy imtihondan o'ting",
        T_FAILED: "Siz nazariy imtihondan o'ta olmadingiz.",
        P_PAYMENT: "Amaliyot imtihonini to'lang",
        P_EXAM: "Amaliyot imtihonidan o'ting",
        P_FAILED: "Siz amaliy imtihondan o'ta olmadingiz.",
        COMPLETED: 'Muvaffaqiyatli yakunlandi',
        blocked: 'bloklangan',
      },
      auth: {
        notFound: 'Telefon raqami topilmadi',
        enterOtpCode: 'SMS kodini kiriting',
        passwordNotConfirmed: 'Пароли не совпадают',
        passwordNotValid:
          "Parol uzunligi kamida 6ta belgidan iborat bo'lishi kerak",
        login: 'Kirish',
        phoneNumber: 'Telefon raqami',
        password: 'Parol',
        forgotPassword: 'Parolni unutdingizmi',
        confirmPassowrd: 'Parolni tasdiqlang',
        register: "Ro'yxatdan o'tish",
        resetPassword: "Parolni o'chirish",
        send: 'Yuborish',
        confirmOffer: 'Ommaviy taklifni (ofertani) tasdiqlang',
        enterCode: 'SMS-kodni kiriting',
        newPassword: 'Yangi parol',
        smsCodeReplay: 'Kod yozilgan SMSni qayta yuborish',
        sendCodeToMobile: 'Raqamingizga kod yozilgan SMS yuborildi',
        sendSmsLater: 'SMSni qayta yuborish',
        sendSmsAgain: 'SMSni qayta yuborish',
        authSuccess: "Avtorizatsiya muvaffaqiyatli o'tdi",
        error: "Ma'lumotlar to'g'ri to'ldirilganligini tekshiring",
        notValidLoginOrPassword: "Noto'g'ri login yoki parol kiritilgan",
        tryLaterAgain: "Xatolik yuz berdi. Bir ozdan keyin urinib ko'ring",
        editedPassword: "Parol o'zgartirildi",
        registed: "Ro'yxatdan o'tish",
        codeNotValid: "Noto'g'ri SMS-kod",
        registrationSuccess: "Ro'yxatdan muvaffaqiyatli o'tildi",
        alreadyUser: 'Bunday foydalanuvchi mavjud',
        repeatPassword: 'Parolni qayta tering',
        offer: 'Ommaviy oferta',
        back: 'Orqaga qaytish',
        cancel: 'Bekor qilish',
        sendCode: 'Kodni yuborish',
        checkCorrectData: "Ma'lumotlar to'g'ri to'ldirilganligini tekshiring",
        passwordChanged: "Parol o'zgartirildi",
      },
      updateQueuePage: {
        choiceBranch: 'Выберите филиал',
        choiceQueueType: 'Выберите тип очереди',
        queueUpdated: 'Очередь изменена',
        practice: 'Amaliyot',
        theory: 'Nazariya',
        fillFields: 'Заполните поля',
        tryAgainLater: 'Произошла ошибка, попробуйте позже',
        updateQueue: 'Изменить очередь',
        nameOz: 'Название на узбекском (кирилица)',
        nameUz: 'Название на узбекском (латиница)',
        nameRu: 'Название на русском',
        back: 'Назад',
        save: 'Сохранить',
      },
      createQueuePage: {
        choiceBranch: 'Выберите филиал',
        choiceQueueType: 'Выберите тип очереди',
        queueCreated: 'Очередь создана успешно',
        practice: 'Практика',
        theory: 'Теория',
        fillFields: 'Заполните поля',
        tryAgainLater: 'Произошла ошибка, попробуйте позже',
        createQueue: 'Создать очередь',
        nameOz: 'Название на узбекском (кирилица)',
        nameUz: 'Название на узбекском (латиница)',
        nameRu: 'Название на русском',
        back: 'Назад',
        save: 'Сохранить',
      },
      carsPage: {
        filter: 'Фильтр',
        choiceMotordrome: 'Выберите автодром',
        search: 'Найти',
        number: 'Номер',
        model: 'Модель',
        category: 'Категория',
        cars: 'Автомобили',
      },
      timeslotsPage: {
        reserved: 'Rezerv qilingan',
        capacity: 'Sigʻimi',
        timeslotDeleted: 'Qabul vaqti oʻchirildi',
        createTimeslot: 'Qabul vaqtini yaratish',
        save: 'Saqlash',
        back: 'Orqaga',
        timeslotUpdated: 'Qabul vaqti oʻzgartirildi',
        updateTimeslot: 'Qabul vaqtini oʻzgartirish',
        updatedDate: "O'zgartirilgan sana",
        actions: 'Harakatlar',
        fromTime: 'Dan',
        toTime: 'Gacha',
        branch: 'Filial',
        choiceBranch: 'Filialni tanlang',
        reservedAndCapacity: 'Rezerv qilingan / Sigʻimi',
        search: 'Qidirish',
        timeslots: 'Qabul vaqtlari',
        addTimeslot: 'Qabul vaqtini qoʻshish',
        date: 'Sana',
        deleteTimeslot: 'Qabul vaqtini oʻchirish',
        confirmDelete: 'Siz rostdan ham ushbu qabul vaqtini oʻchirmoqchimisiz?',
        createdTimeslot: 'Qabul vaqti muvaffaqiyatli yaratildi',
        confirmDeleteTimeslot:
          'Siz rostdan ham ushbu qabul vaqtini oʻchirmoqchimisiz?',
        fillFields: 'Maydonlarni toʻldiring',
        savedData: 'Maʼlumotlar saqlandi',
      },
      queuePage: {
        branches: 'Филиал',
        confirmDelete: 'Удалить из очереди?',
        confirmLogout: 'Вы действительно хотите выйти?',
        usersCount: 'Navbatdagi odamlar soni',
        classRoom: 'Кабинет',
        selectClassRoom: 'Выберите кабинет',
        emptyQueue: 'Очередь пуста',
        confirmDeleteQueue:
          "Siz haqiqatan ham ushbu navbatni o'chirmoqchimisiz?",
        selectQueue: 'Navbatni tanlang',
        clearedQueue: 'Navbat tozalandi',
        clear: 'Tozalash',
        enterCount: 'Sonini kiriting',
        power: 'Ishga tushirish',
        name: 'Nomi',
        updateDate: "O'zgartirishlar kiritilgan sanasi",
        actions: 'Harakatlar',
        notAccept: 'Kirish rad etildi. Iltimos, qabulxonaga murojaat qiling',
        passNotValid: 'Beyjik haqiqiy emas',
        deletedQueue: "Navbat o'chirildi",
        queue: 'Navbat',
        timeslots: "Vaqt bo'laklari",
      },
    },
  },
  ///////////////////////////////kaa
  kaa: {
    general: {
      instance: {
        noAccess: 'Кириў мүмкин емес',
        login: 'Авторизациядан өтиң',
        uploadDocuments: 'Ҳүжжетлерди жүклең',
      },
    },
    components: {
      ScheduleQueue: {
        of: 'тен',
        available: 'Eркин түрде'
      },
      CheckQueue: {
        fio: 'Ф.И.Ш',
        title: 'өз гезегин тексериў',
        dateOfBirth: 'Туўылған сәнени киргизиң',
        pass: 'Рухсатнама номерин киргизиң',
        save: 'Cақлаў',
        notFound: 'Арзаңыз табылмады',
        date: 'Cәне',
        time: 'ўақыт',
        datePlaceholder: 'кк.оо.yyyy',
        qrTitle: 'Чекти сканерге ҚР код пенен жайластырың.',
        dateError: 'Туўылған сәнеси дурыс емес'
      },
      TimeSlots: {
        of: 'тен',
        available: 'Eркин түрде',
        noPlaces: 'Орын жоқ',
        choose: 'Таңлаў',
      },
      ReserveQueue: {
        selectCurrentTime: 'Әҳмиетли ўақытты таңлаң',
        conflict: 'Сизиң арзаңыз нәўбетке қосылды',
        dateOfBirth: 'Туўылған сәнени киргизиң',
        pass: 'Рухсатнама номерин киргизиң',
        save: 'Сақлаў',
        title: 'Нәўбетти бәнтлеў',
        success: 'Сиз электрон нәўбетке қосылдыңыз',
        error: 'Қәте, кейинирек қайта тәкирарланың',
        deleteApp: 'Ески жазыў өширилсин бе?',
        datePlaceholder: 'кк.оо.yyyy',
        notFound: 'Арзаңыз табылмады',
        qrTitle: 'Чекти сканерге ҚР код пенен жайластырың.',
        dateError: 'Туўылған сәнеси дурыс емес',
        ageValidation: 'Талабан 18 жасқа толмаған',
        blackList: 'қара дизимдеги кандидат',
        expire083: 'мед мағлыўматнамасының мүддети өтти',
        expirePassport: 'Паспорттың мүддети өтти',
        appNotVerified: 'Арза тастыйықланбаған',
        wrongTimeslot: 'Выбранное время не доступно. Запись возможна на {{times}}',
      },
      Header: {
        prompt: 'Сиз ҳақыйқаттан да шығып кетежақсыз ба?',
      },
      transactionModal: {
        replenished: 'Толтырыў',
        writeOff: 'Есаптан шығарыў',
        actionType: 'Ҳәрекет',
        pay: 'Төлем',
        payme: 'Payme',
        click: 'Click',
        terminal: 'Терминал',
        cash: 'Нақ пул',
        title: 'Транзакциялар',
        transactionType: 'Түри',
        amount: 'Суммасы',
        status: 'Статусы (ҳалаты)',
        payDate: 'Төлеў сәнеси',
        completed: 'Табыслы әмелге асырылды',
        failed: 'Төлеўде қәтелик',
      },
      resultsModal: {
        seeApp: 'Арзаны көриў',
        attempt: 'Попытка',
        success: 'Вы успешно прошли практический экзамен, ваш результат',
        result: 'Ваш результат',
        print: 'Распечатать экз лист',
        exercise: 'Упражнение',
        name: 'Название',
        penaltyPoints: 'Штрафные баллы',
        total: 'Всего',
        theorySuccess: 'Вы успешно прошли теоретический экзамен, ваш результат',
        ticketNumber: 'Номер билета',
        question: 'Вопрос',
        selectedAnswer: 'Выбранный ответ',
        results: 'Результат',
      },
      newApplicationNotice: {
        newNotice: 'Жаңа онлайн арза',
        open: 'Көрип шығыў',
        close: 'Жабыў',
      },
      passModal: {
        enterPassNumber: 'Бейжик (руқсатнама) номерин киргизиң',
        save: 'Сақлап қойыў',
      },
      pagination: {
        rowsPerPage: 'Беттеги саны',
      },
      queueList: {
        car: 'Автомобиль',
        classRoom: 'Аудитория',
        choiceCar: 'Автомобилди таңлаң',
        call: 'Шақырыў',
        cancel: 'Бийкарлаў',
        delete: 'Өшириў',
        category: 'Тайпа',
      },
      //fix
      TimeLine: {
        tests: 'Тестлер',
        right: 'Дурыс',
        wrong: 'Дурыс емес',
        total: 'Жәми баллар',
        startDate: 'Басланыў сәнеси',
        attempts: 'Урыныўлар',
        carNumber: 'Машинаның номери',
        penaltyPoints: 'Жәрийма баллары',
        CREATED: 'Создан',
        NOT_VERIFIED: 'Не подтвержден',
        T_PAYMENT: 'Оплатите за экзамен теория',
        T_EXAM: 'Сдайте экзамен теория',
        T_FAILED: 'Вы провалили теоретический экзамен',
        P_PAYMENT: 'Оплатите за экзамен практика',
        P_EXAM: 'Сдайте экзамен практика',
        P_FAILED: 'Вы провалили практический экзамен',
        COMPLETED: 'Успешно окончен',
        theoryEndDate: 'Дата окончания теории',
      },
      Sidebar: {
        reports: 'Протоколлар',
        responsiblePerson: 'Ответственные лица',
        schools: 'Мектеплер',
        enterName: 'Излеў ушын атын киргизиң',
        control: 'Нәўбетти басқарыў',
        classRooms: 'Кабинет',
        cars: 'Автомобиллер',
        queue: 'Нәўбет',
        users: 'Пайдаланыўшылар',
        categories: 'Тайпалар',
        docs: 'Ҳүжжетлер',
        applications: 'Арзалар',
        statuses: 'Статуслар',
        practiceCategory: 'Транспорт қураллары түрлери',
        payment: 'Төлем',
        passedExam: 'Имтиханнан өткенлер',
        cashPayment: 'Нақ пул менен төлеў',
        userId: 'Пайдаланыўшыны анықлаў',
        visitLogs: 'Кирип-шығыўлар дизими',
        motordromes: 'Автодром',
        errors: 'Қәтеликлер',
        transactions: 'Транзакциялар',
        verrifyApps: 'Ҳақыйқыйлығы тастыйықланған арзалар',
        generatReport: 'Улыўма есабат',
        generalStatistics: 'Статистикалық есабат',
        schoolStatistics: 'Мектеплер статистикасы',
        gaiSchoolsReport: 'ЖҲҚББның мектеплер бойынша есабаты',
        sumarry: 'Жуўмақ',
        appeals: 'Апелляция',
        report: 'Рапортлар',
        vising: 'Визинг',
        requestForChangeData: 'Мағлыўматларды өзгертиў бойынша сораўлар',
        certificates: 'Сертификатлар',
        certificatesHistory: 'Сертификат тарийхы',
        calendar: 'Календарь',
        fines: 'Жәриймалар',
        reception: 'Қабыллаў',
        security: 'Қәўипсизлик',
        accounting: 'Бухгалтерия',
        cash: 'Касса',
        statistics: 'Статистика',
        integrationWithGai: 'ЖҲҚББ менен бирлесиў',
        practicalStatisticByCategory: 'Статистика ПЭ по категориям',
        timeslots: 'Время приема',
      },
      CategoryStatuses: {
        statusDeleted: 'Статус алып тасланды',
        erorrTryAgain: 'Қәтелик жүз берди. Тағы бир рет урынып көриң',
        wantToRemove:
          'Сиз ҳақыйқаттан да тайпаның статусын алып таслайжақсыз ба?',
        add: 'Тайпаның статусын қосыў',
        status: 'Статус',
        successStatus: 'Сәтли нәтийже жағдайындағы статус',
        failureStatus: 'Сәтсиз нәтийже жағдайындағы статус',
        order: 'Тәртип',
        start: 'Басланды',
        finished: 'Тамамланды',
        createdAt: 'Дүзилген сәне',
        actions: 'Ҳәрекетлер',
      },
      Confirmation: {
        cancel: 'Бийкарлаў',
        success: 'Тастыйықлаў',
      },
      FileUploader: {
        fileSize: 'Файлдың көлеми жүдә үлкен',
        selectDocument: 'Ҳүжжетти таңлаў',
        selectAnotherDocument: 'Басқа ҳүжжетти таңлаў',
        scanning: 'Сканерлеў',
        getDocument: 'ҳүжжет алыў',
        enterPinfl: 'ПИНФЛ ди киргизиң',
        enterVehicleType: 'Транспорт түрин таңлаў',
        documentReceived: 'Ҳүжжет қабыл етилди',
        docNotFound: 'Ҳүжжет табылмады',
        error: 'Қәте, кейинирек тәкирарланың',
      },
      FileUploads: {
        certificateFromSchool: 'Справка с автошколы',
        mainPassport: 'Паспорт',
        photo: 'Сүўрет',
        passport: 'Паспорт/ИД карта (прописка менен)',
        employerReferral: 'Жумыс бериўшиниң жолламасы',
        replacement:
          'Замена водительского удостоверения лиц единого образца или водительского удостоверения кагегорий "В" и "С " на срок более 10 лет непрерывной трудовой деятельности водителя категориями "ВЕ" и "СЕ" на основании выписки из трудовой книжки водителя',
        driverLicence_1: 'Миллий айдаўшылық гүўалығы-1',
        driverLicence_2: 'Миллий айдаўшылық гүўалығы-2',
        direction: 'Ишки ислер ўәкилликли органының жолламасы',
        honey083_1: '083-формадағы медициналық мағлыўматнама-1.',
        honey083_2: '083-формадағы медициналық мағлыўматнама -2.',
        diplomaAnnex:
          'Диплом и приложение к нему об усвоении предметов по плану',
        nationalDriversLicence:
          'Национальные водительские удостоверение ("C", "B" и "C", "D", "C" и "D", "СE" и (или) "DE")',
        certificateSingleSample: 'Бирден-бир үлгидеги гуўалық',
        pinflForForeign: 'Шет ел пуқарасы ушын ФШЖИН',
        docConfirm12:
          '12 айға шекем транспорт қуралын басқарғанлығын тастыйықлаўшы ҳүжжет',
        appForAppeal: 'Апелляция арзасы',
        decisionAppealComission: 'Апелляция комиссиясының қарары',
        forWorkingDrivers:
          'Жумыс ислеп атырған айдаўшылар ушын - мийнет дәптершесинен көширме ямаса оған бекитилген автомототранспорт қуралының түри көрсетилген мағлыўматнама (буйрықтан көширме)',
      },
      Footer: {
        address: 'Ташкент қаласы, Янгиҳаёт районы, Файзли көшеси, 87',
        copyRight: '2022 барлық ҳуқықлар қорғалған',
      },
      CreateCategoryStatuses: {
        fillFields: 'Майданларды толтырың',
        createdSuccess: 'Тайпа статусы табыслы жаратылды',
        alreadyExistsDefault:
          'Статус категории со статусом "по умолчанию" уже существует',
        alreadyExistsFinish:
          'Статус категории со статусом "окончен" уже существует',
        errorTryAgain: 'Қәтелик жүз берди. Кейинирек қайтадан урынып көриң',
        createStatusCategory: 'Тайпа ушын статус жаратыў',
        selectStatus: 'Статусты таңлаң',
        successStatus: 'Сәтли нәтийже жағдайындағы статус',
        failureStatus: 'Сәтсиз нәтийже жағдайындағы статус',
        workDays: 'Қайта урыныўға шекемги жумыс күнлери саны',
        order: 'Тәртип',
        defaultStatus: '«Дәслепки» статус',
        finished: 'Тамамланды',
        cancel: 'Бийкарлаў',
        save: 'Сақлап қойыў',
      },
      UpdateCategoryStatuses: {
        fillFields: 'Майданларды толтырың',
        updateSuccess: 'Тайпа статусы өзгертилди',
        errorTryAgain: 'Қәтелик жүз берди. Кейинирек қайтадан урынып көриң',
        updateStatusCategory: 'Тайпа ушын статусты өзгертиў',
        selectStatus: 'Статусты таңлаң',
        successStatus: 'Сәтли нәтийже жағдайындағы статус',
        failureStatus: 'Сәтсиз нәтийже жағдайындағы статус',
        cost: 'Баҳа',
        workDays: 'Қайта урыныўға шекемги жумыс күнлери саны',
        order: 'Тәртип',
        defaultStatus: '«Дәслепки» статус',
        finished: 'Тамамланды',
        cancel: 'Бийкарлаў',
        save: 'Сақлап қойыў',
        alreadyExistsDefault:
          'Статус категории со статусом "по умолчанию" уже существует',
        alreadyExistsFinish:
          'Статус категории со статусом "окончен" уже существует',
      },
      TokenModal: {
        copy: 'Нусқа алынды',
        refresh: 'Жаңалаў',
      },
      UserModal: {
        userInfo: 'Пайдаланыўшы ҳаққында мағлыўмат',
        FIO: 'Ф.И.Ш.',
        dateOfBirth: 'Туўылған сәнеси',
        passport: 'Паспорт сериясы/номери',
        pinfl: 'ФШЖИН',
        phone: 'Телефон номери',
        cancel: 'Бийкарлаў',
        successUser: 'Пайдаланыўшыны тастыйықлаў',
        name: 'Аты',
        createdAt: 'Дүзилген сәне',
        actions: 'Ҳәрекетлер',
      },
    },
    pages: {
      ScheduleTimePage: {
        lawText: 'Diqqat: Avtomototransport vositalarini boshqarish huquqidan mahrum bo\'lgan shaxslar uchun nazariy imtihon soat {{times}} da o\'tkaziladi.',
      },
      SchedulePage: {
        checkQueue: 'өз гезегин тексериў',
      },
      ReportsForSchool: {
        fieldNotFilled: 'Поля не заполнены',
        schoolsStat: 'Статистика автошкол',
        search: 'Поиск',
        from: 'С',
        to: 'По',
        clear: 'Очистить',
      },
      FinesDetails: {
        from: '… ден',
        to: '…ге шекем',
        penalty: 'Жәрийма',
        yes: 'Аўа',
        no: 'Жоқ',
        search: 'Излеў',
        clear: 'Тазалаў',
        createdAt: 'Жаратылған сәнеси',
        appLink: 'Арзаға силтеме',
        branch: 'Филиал',
        fixed: 'Дүзетилген',
        details: 'Деталлар',
        go: 'Өтиў',
      },
      FinesPage: {
        from: '… ден',
        to: '…ге шекем',
        search: 'Излеў',
        clear: 'Тазалаў',
        fullName: 'Ф.И.Ш.',
        phone: 'Телефон',
        branch: 'Филиал',
        finesNumber: 'Жәриймалар саны',
        details: 'Детальлар',
        go: 'Өтиў',
      },
      OfficialReportByIdPage: {
        appConfirmed: 'Арза тастыйықланды',
        error: 'Қәте, кейинирек тәкирарланың',
        title: 'Мағлыўматларды өлшеўге сораў',
        penalty: 'Жәрийма',
        confirm: 'Тастыйықлаў',
        confirmedBy: 'Ким тастыйықлаған',
        currentData: 'Ағымдағы мағлыўматлар',
        firstName: 'Исми',
        lastName: 'Фамилиясы',
        middleName: 'Әкесиниң исми',
        dateOfBirth: 'Туўылған сәнеси',
        passportSerial: 'Серия',
        passportNumber: 'Номер',
        passportValid: 'Паспорт мүддети',
        dateMed: 'мед мағлыўматнама мүддети',
        changeData: 'өзгериске байланыслы мағлыўматлар',
        fullName: 'Ф.И.Ш.',
        passportSerialNumber: 'Паспорт сериясы / номери.',
        pinfl: 'ФШЖИН',
        branch: 'Филиал',
        status: 'Статус',
        phone: 'Телефон',
        transactionDate: 'Транзакция сәнеси',
        cardTypeNumber: 'Карта түри / номери',
        sum: 'Сумма',
        report: 'Рапорт',
      },
      OfficialReportsPage: {
        title: 'Мағлыўматларды өлшеў ушын сораўлар',
        completed: 'Питкен',
        all: 'ҳәмме',
        yes: 'Аўа',
        no: 'Жоқ',
        activity: 'Активлик',
        branch: 'Филиал',
        user: 'Пайдаланыўшы',
        search: 'Излеў',
        clear: 'Тазалаў',
        createdAt: 'Жаратылған сәнеси',
        type: 'Түр',
        appLink: 'Арзаға силтеме',
        candidate: 'Талабан',
        confirmedBy: 'Ким тастыйықлаған',
        status: 'Статус',
        step: 'қәдем',
        penalty: 'Жәрийма',
        accomplishment: 'Орынлаў',
        details: 'Детальлар',
        confirmed: 'Тастыйықланған',
        new: 'Жаңа',
        data: 'мағлыўмат',
        refund: 'қайтарыў',
      },
      AppealPageById: {
        fio: 'Ф.И.Ш.',
        passportSerial: 'Паспорт сериясы/номери',
        phone: 'Телефон',
        dateOfBirth: 'Туўылған сәнеси',
        examType: 'Имтихан түри',
        applicaiton: 'Арза',
        applicaitionLink: 'Арзаға силтеме',
        title: 'Апелляция комиссиясының қарары',
      },
      AppealsPage: {
        appeal: 'Апелляция',
        fio: 'Ф.И.Ш.',
        phone: 'Телефон',
        createdAt: 'Жаратылған сәнеси',
        examType: 'Имтихан түри',
        actions: 'Хәрекетлер',
        choiceBranch: 'Филиалды таңлаў',
        all: 'Ҳәмме',
      },
      ReportPage: {
        //fix
        reportHistory: 'Протокол тарийхы',
        FIO: 'Ф.И.Ш',
        category: 'Тайпа',
        school: 'Мектеп',
        theoryAttempt: 'Теория бойынша урыныўлар',
        theoryScore: 'Теория бойынша баллар',
        practiceAttempt: 'Әмелий шынығыўлар бойынша урыныўлар',
        practiceScore: 'Тапсырды/Тапсырмады',
        passed: 'Тапсырды',
        notPassed: 'Тапсырмады',
        certificateNumber: 'Сертификат номери',
        print: 'Басып шығарыў',
      },
      ReportsPage: {
        enterDate: 'Сәнени киргизиң',
        count: 'Саны',
        actions: 'Ҳәрекет',
        createdAt: 'Дүзилген сәне',
        dayNumber: 'Протокол генерацияланған сәне',
        reports: 'Протоколлар',
        generation: 'Генерациялаў',
        name: 'Аты',
        date: 'Сәне',
        clear: 'Тазалаў',
        search: 'Излеў',
        branches: 'Филиаллар',
        from: '…ден',
        protocolNumber: 'Протокол №',
      },
      SummaryPage: {
        branch: 'Филиал',
        from: '… ден',
        to: '…ге шекем',
        branches: 'Филиаллар',
        summary: 'Жуўмақ',
        application: 'Арза',
        clear: 'Тазалаў',
        search: 'Излеў',
        fio: 'Ф.И.Ш',
        appCode: 'Арзаның коды',
        status: 'Статусы',
        createdAt: 'Дүзилген сәне',
        firstName: 'Исми',
        lastName: 'Фамилиясы',
        middleName: 'Әкесиниң исми',
        categories: 'Тайпа',
        vehicleTypes: 'Транспорт қуралының түри',
        oldStatus: 'Алдынғы ҳалат',
        newStatus: 'Жаңа ҳалат',
        attempt: 'Урыныў',
        attempts: 'Урыныўлар',
        firstAttempt: 'Биринши урыныў',
        retake: 'Қайта тапсырыў',
        passport: 'Паспорт сериясы/номери',
        phone: 'Телефон',
        result: 'Нәтийже',
        true: 'Сәтли',
        false: 'Сәтсиз',
      },
      UpdateClassRoomPage: {
        choiceBranch: 'Филиалды таңлаң',
        nameError: 'Кабинеттың аты әлле қашан бар',
        fillFields: 'Майданларды толтырың',
        updatedClassRoom: 'Кабинет өзгертилди',
        updateClassRoom: 'Кабинетти өзгертиў',
        enterName: 'Атын киргизиң',
        back: 'Артқа қайтыў',
        save: 'Сақлап қойыў',
      },
      CreateClassRoomPage: {
        choiceBranch: 'Филиалды таңлаң',
        nameError: 'Кабинеттың аты әлле қашан бар',
        fillFields: 'Майданларды толтырың',
        createdClassRoom: 'Кабинет жаратылды',
        createClassRoom: 'Кабинет жаратыў',
        name: 'Аты',
        back: 'Артқа қайтыў',
        save: 'Сақлап қойыў',
      },
      ClassRoomsPage: {
        classRooms: 'Кабинетлер',
        deleted: 'Кабинет алып тасланды',
        wantDeleteClassRoom:
          'Сиз ҳақыйқаттан да бул кабинетти алып таслайжақсыз ба?',
        updatedDate: 'Өзгерислер киргизилген сәне',
        actions: 'Ҳәрекетлер',
        name: 'Аты',
        classRoom: 'Кабинет',
      },
      ApplicationForGai: {
        fio: 'Ф.И.Ш',
        passport: 'Паспорт',
        dateOfBirth: 'Туўылған сәнеси',
        phone: 'Телефон',
        vehicleType: 'Транспорт қуралының түри',
      },
      ApplicationsForGai: {
        application: 'Арзалар',
        clear: 'Тазалаў',
        search: 'Излеў',
        fio: 'Ф.И.Ш',
        phone: 'Телефон',
        appCode: 'Арзаның коды',
        passCode: 'Бейжик номери',
        status: 'Статус',
        category: 'Тайпа',
        transportType: 'Транспорт қуралының түри',
        updatedAt: 'Өзгерислер киргизилген сәне',
        actions: 'Ҳәрекетлер',
        serial: 'Сериясы',
        number: 'Номери',
        pinfl: 'ФШЖИН',
        createdAt: 'Дүзилген сәне',
        endDate: 'Тамамланыў сәнеси',
        firstName: 'Исми',
        lastName: 'Фамилиясы',
        middleName: 'Әкесиниң исми',
        categories: 'Тайпа',
        vehicleTypes: 'Транспорт қуралының түри',
        statuses: 'Статус',
      },
      VisitLogsPage: {
        visitLogs: 'Кирип-шығыўлар дизими',
        date: 'Сәне',
        search: 'Излеў',
        clear: 'Тазалаў',
        fio: 'Ф.И.Ш',
        dateOfBirth: 'Туўылған сәнеси',
        passport: 'Паспорт сериясы/номери',
        appCategory: 'Арзаның түри',
        createdAt: 'Дүзилген сәне',
        status: 'Статусы',
      },
      VehicleTypesPage: {
        deleted: 'Табыслы алып тасланды',
        wantDeleteVehicle:
          'Вы действительно хотите удалить транспортное средство?',
        vehicleTypes: 'Транспорт қураллары',
        name: 'Аты',
        actions: 'Ҳәрекетлер',
      },
      UsersPage: {
        error: 'Қәтелик жүз берди. Кейинирек қайтадан урынып көриң',
        users: 'Пайдаланыўшылар',
        serial: 'Сериясы',
        number: 'Номери',
        firstName: 'Исми',
        lastName: 'Фамилиясы',
        middleName: 'Әкесиниң исми',
        search: 'Излеў',
        clear: 'Тазалаў',
        passport: 'Паспорт сериясы/номери',
        pinfl: 'ФШЖИН',
        fio: 'Ф.И.Ш',
        phone: 'Телефон номери',
        integrated: 'Интеграция қылынған',
        role: 'Роли',
        verrified: 'Тастыйықланған',
        status: 'Статусы',
        actions: 'Ҳәрекетлер',
      },
      UserIdentificationPage: {
        error: 'Қәтелик жүз берди. Кейинирек қайтадан урынып көриң',
        applicationNotFound: 'Арза табылмады',
        userNotActive: 'Пайдаланыўшы актив емес',
        statusError: 'Статус қәтеси',
        appNotVerrified: 'Арза тастыйықланбаған',
        fio: 'Ф.И.Ш',
        dateOfBirth: 'Туўылған сәнеси',
        phone: 'Телефон номери',
        passport: 'Паспорт сериясы/номери',
        pinfl: 'ФШЖИН',
        appStatus: 'Арзаның статусы',
        appCategory: 'Арзаның түри',
        failureDays:
          'Для повторной сдачи экзамена, должно пройти не менее 7 рабочих дней со дня проведенного экзамена',
        success: 'Сәтли',
        passportExp: 'Паспорттың әмел қылыў мүддети',
        medicalCertValid: 'Медициналық мағлыўматнаманың  әмел қылыў мүддети',
      },
      UpdateVehicleTypePage: {
        fillFields: 'Майданларды толтырың',
        vehicletypeUpdated: 'Транспорт қуралы өзгертилди',
        updateVehicleType: 'Транспорт қуралын өзгертиў',
        enterName: 'Атын киргизиң',
        back: 'Артқа қайтыў',
        save: 'Сақлап қойыў',
      },
      UpdateUserPage: {
        motordrome: 'Автодром',
        phoneError: 'Бундай телефон номери менен пайдаланыўшы бар',
        passportError: 'Бундай паспорт сериясы/номери менен пайдаланыўшы бар',
        pinflError: 'Бундай ФШЖИН менен пайдаланыўшы бар',
        updateUser: 'Пайдаланыўшыны жаңалаў',
        serial: 'Сериясы',
        number: 'Номери',
        phone: 'Телефон номери',
        role: 'Роли',
        firstName: 'Исми',
        lastName: 'Фамилиясы',
        middleName: 'Әкесиниң исми',
        dateOfBirth: 'Туўылған сәнеси',
        pinfl: 'ФШЖИН',
        getToken: 'Токенди қабыл етиў',
        back: 'Артқа қайтыў',
        save: 'Сақлап қойыў',
      },
      UpdateStatusPage: {
        updateStatus: 'Статусты жаңалаў',
        type: 'Түрин таңлаң',
        queue: 'Нәўбетти таңлаң',
        pass: 'Бейжик',
        pay: 'Төлем',
        name: 'Аты',
        titleLat: 'Өзбек тилиндеги атама (латын әлипбесинде)',
        titleCyr: 'Өзбек тилиндеги атама (кирилл әлипбесинде)',
        titleRu: 'Рус тилиндеги атама',
        order: 'Тәртип',
        back: 'Артқа қайтыў',
        update: 'Жаңалаў',
        vehicleType: 'Транспорт қуралының түри',
      },
      UpdatePracticePenaltyPage: {
        updatePenalty: 'Жәрийма балларын жаңалаў',
        nameLat: 'Өзбек тилиндеги аты (латын әлипбесинде)',
        nameCyr: 'Өзбек тилиндеги аты (кирилл әлипбесинде)',
        nameRu: 'Рус тилиндеги аты',
        points: 'Баллар',
        cancel: 'Бийкарлаў',
        save: 'Сақлап қойыў',
        code: 'Код',
        codeError: 'Бундай код бар',
      },
      UpdatePracticeExercisesPage: {
        updateExercise: 'Шынығыўды жаңалаў',
        nameLat: 'Өзбек тилиндеги аты (латын әлипбесинде)',
        nameCyr: 'Өзбек тилиндеги аты (кирилл әлипбесинде)',
        nameRu: 'Рус тилиндеги аты',
        cancel: 'Бийкарлаў',
        save: 'Сақлап қойыў',
        code: 'Код',
        codeError: 'Бундай код бар',
      },
      UpdateErrorTypePage: {
        fillFields: 'Майданларды толтырың',
        errorTypeChanged: 'Қәтелик түри өзгертилди',
        error: 'Қәтелик жүз берди. Кейинирек қайтадан урынып көриң',
        updateErrorType: 'Қәте түрин өзгертиў',
        nameCyr: 'Өзбек тилиндеги аты (кирилл әлипбесинде)',
        nameLat: 'Өзбек тилиндеги аты (латын әлипбесинде)',
        nameRu: 'Рус тилиндеги аты',
        back: 'Артқа қайтыў',
        save: 'Сақлап қойыў',
      },
      UpdateDocPage: {
        required: 'Мәжбүрий/Мәжбүрий емес',
        nameConflict: 'Бундай аттағы ҳүжжет бар',
        fillFields: 'Майданларды толтырың',
        docUpdated: 'Ҳүжжет өзгертилди',
        error: 'Қәтелик жүз берди. Кейинирек қайтадан урынып көриң',
        updateDocument: 'Ҳүжжетти редакторлаў',
        docName: 'Ҳүжжеттиң аты',
        nameCyr: 'Өзбек тилиндеги аты (кирилл әлипбесинде)',
        nameLat: 'Өзбек тилиндеги аты (латын әлипбесинде)',
        nameRu: 'Рус тилиндеги аты',
        back: 'Артқа қайтыў',
        save: 'Сақлап қойыў',
      },
      UpdateCategoryPage: {
        fillFields: 'Майданларды толтырың',
        categoryUpdated: 'Тайпа өзгертилди',
        error: 'Қәтелик жүз берди. Кейинирек қайтадан урынып көриң',
        updateCategory: 'Тайпаны редакторлаў',
        data: 'Мағлыўматлар',
        statuses: 'Статуслар',
        categoryName: 'Тайпаның аты',
        nameCyr: 'Өзбек тилиндеги аты (кирилл әлипбесинде)',
        nameLat: 'Өзбек тилиндеги аты (латын әлипбесинде)',
        nameRu: 'Рус тилиндеги аты',
        order: 'Тәртип',
        selectDocuments: 'Ҳүжжетти таңлаң',
        back: 'Артқа қайтыў',
        save: 'Сақлап қойыў',
        vehicleTypes: 'Транспорт қуралларының түрлери',
      },
      ApplicationHistoryPage: {
        branch: 'Филиал',
        actions: 'Ҳәрекетлер',
        more: 'Толық',
        applicationHistory: 'Арза тарийхы',
        history: 'Тарийхы',
        result: 'Нәтийже',
        success: 'Дурыс',
        fail: 'Дурыс емес',
        answer: 'Жуўап',
        question: 'Сораў',
        ticketNumber: 'Билет номери',
        createdDate: 'Дүзилген сәне',
        statuses: 'Статуслар',
        transactions: 'Транзакциялар',
        results: 'Нәтийжелер',
        oldStatus: 'Алдыңғы ҳалат',
        nextStatus: 'Кейинги ҳалат',
        currentStatus: 'Ҳәзирги ҳалат',
        category: 'Тайпа',
        errorMessage: 'Блокланды',
        error: 'Қәте, кейинирек тәкирарланың',
        sent: 'Жиберилген',
        dateSendingToGai: 'ГАИға жиберилген сәне',
        lastSubmissionDate: 'Соңғы жиберилген сәнеси',
        status: 'ГАИ статусы',
        message: 'Хабар',
        appeal: 'Апелляция',
        resend: 'Кайта жибериў',
        block: 'Блоктан шығарыў',
        unblock: 'Разблокировать',
        attempt: 'Урыныў',
        yesNo: 'табыслы / жоқ',
      },
      UpdateApplicationPage: {
        resident: 'Өзбекстан Республикасының пуқарасы',
        noResident: 'Шет ел пуқарасы',
        isForeigner: 'ӨзР пуқарасы/Шет ел пуқарасы',
        time: 'Ўақыт',
        branch: 'Филиал',
        choiceBranch: 'Филиалды таңлаң',
        residencePlace: 'Жасаў орны',
        more: 'Арза бойынша кеңирек мағлыўмат',
        uploadDocuments: 'Ҳүжжетлерди жүклең',
        notInList: 'Дизимде жоқ',
        enterSchoolName: 'Автомектептиң атын киргизиң',
        choiceSchool: 'Автомектепти таңлаң',
        selectLanguage: 'Имтиханды өткериў тилин таңлаң',
        visitDateNotValid: 'Орайға келиў сәнеси надурыс',
        visitDate: 'Орайға келиў сәнеси',
        verification: 'Тастыйықланған пайдаланыўшы',
        confirmedApplication: 'Арза тастыйықланған',
        printCertificate: 'Сертификатты басып шығарыў',
        correctPhone: 'Телефон номерин дурыс киргизиң',
        userNotReceived: 'Пайдаланыўшының мағлыўматлары алынбаған',
        fillFields: 'Майданларды толтырың',
        vehicleType: 'Транспорт қуралының түрин белгилең',
        applicationsUpdated: 'Арза өзгертилди',
        error: 'Қәтелик жүз берди. Кейинирек қайтадан урынып көриң',
        canceledApplication: 'Арзаны бийкарлаң',
        passportConflict:
          'Бундай паспорт сериясы/номери менен пайдаланыўшы бар',
        applicationRejected: 'Арза бийкарланды',
        application: 'Арза',
        updateApplication: 'Арзаны өзгертиў',
        cancelApp: 'Арзаны бийкарлаў ҳәм сақлап қойыў',
        save: 'Сақлап қойыў',
        appData: 'Арзадағы мағлыўматлар',
        transport: 'Транспорт қуралы',
        userData: 'Пайдаланыўшының мағлыўматлары',
        userPhone: 'Пайдаланыўшының телефон номерин киргизиң',
        passportSeries: 'Паспорт сериясы',
        passportNumber: 'Паспорт номери',
        pinfl: 'ФШЖИН',
        firstName: 'Исми',
        lastName: 'Фамилиясы',
        middleName: 'Әкесиниң исми',
        dateOfBirth: 'Туўылған сәнеси',
        back: 'Артқа қайтыў',
        phone: 'Телефон номери',
        category: 'Тайпа',
        transportType: 'Транспорт қуралының түри',
        reasonsRejectedApp: 'Арзаны бийкарлаў себеплери',
        docsList: 'Ҳүжжетлер дизими',
        passIssue: 'Бейжикти рәсмийлестириў',
        selectCategoryAndTryAgain: 'Тайпаны таңлап, қайта урынып көриң',
        passIssued: 'Бейжик рәсмийлестирилди',
        confirmApplication: 'Арзаны тастыйықлаў ҳәм сақлап қойыў',
        errorTryLater: 'Қәтелик жүз берди. Кейинирек қайтадан урынып көриң',
        conflictPinfl: 'Бундай ФШЖИН менен пайдаланыўшы бар',
        conflictSerialNumber:
          'Пользователь с такой серией и номером уже существует',
        conflictPhone: 'Бундай телефон номери менен пайдаланыўшы бар',
        requestChanges: 'Өзгерислерди сораў',
        blacklisted: '«Қара дизим»ге киргизиў',
        unblock: 'Блоктан шығарыў',
        reason: 'Талабанның «қара дизим»ге түсиў себебин көрсетиң',
        note: 'Ескертиў',
        update: 'Өзгертиў',
        add: 'Қосыў',
        CREATED: 'Создан',
        NOT_VERIFIED: 'Не подтвержден',
        T_PAYMENT: 'Оплатите за экзамен теория',
        T_EXAM: 'Сдайте экзамен теория',
        T_FAILED: 'Вы провалили теоретический экзамен',
        P_PAYMENT: 'Оплатите за экзамен практика',
        P_EXAM: 'Сдайте экзамен практика',
        P_FAILED: 'Вы провалили практический экзамен',
        COMPLETED: 'Успешно окончен',
        appeal: 'Апелляция',
        noVerified: 'Не верифицированная',
        verified: 'Верифицированная',
        passportValidity: 'Cрок паспорта',
        medCertificateValidity: 'Срок мед. справки',
        submitAReport: 'Рапорт бериў',
      },
      TransactionsPage: {
        transactions: 'Транзакциялар',
        fio: 'Ф.И.Ш',
        paymentDate: 'Төлеў сәнеси',
        paymentType: 'Төлем түри',
        sum: 'Суммасы',
        passport: 'Паспорт сериясы/номери',
        pinfl: 'ФШЖИН',
        id: 'ID',
        cardNumber: 'Карта (ақырғы 4 сан)',
        datails: 'Толық мағлыўмат',
        cashierName: 'Кассирдиң фамилиясы, исми, әкесиниң исми',
        date: 'Сәне',
        transactionsStatus: 'Транзакцияның ҳалаты',
        transactionsType: 'Транзакцияның түри',
        search: 'Излеў',
        clear: 'Тазалаў',
        CASH: 'Нақ пул',
        TERMINAL: 'Терминал',
        PAYME: 'Payme',
        CLICK: 'Click',
        REFUND: 'Қайтарыў',
        FREE: 'Бийпул',
        UZCARD: 'UZCARD',
        HUMO: 'HUMO',
        BANK: 'BANK',
        EPOS: 'EPOS',
        THEORY_PAYMENT: 'Теориялық имтихан',
        PRACTICE_PAYMENT: 'Әмелий имтихан',
        examType: 'Имтихан түри',
        createdAt: '…ден',
        endDate: '…ге шекем',
        branch: 'Филиал',
        appId: 'Арзаның ID',
        qrCode: 'QR-код',
        exportExcel: 'EXCELге экспортлаў',
        totalSum: 'Жәми сумма',
        failedTheTheory: 'Теория бойынша имтиханнан өтпеди',
        retake: 'Қайта тапсырыў',
        paymentOnAnotherDay: 'Басқа күни төлеў',
        applyForRefund: 'Қайтарыўға усыныс бериў',
        changeTransactionType: 'Транзакция түрин өзгертиў',
        go: 'Өтиў',
        transactionType: 'Транзакция түри',
        change: 'Өзгертиў',
        QR: 'QR'
      },
      StatusesPage: {
        categoryDeleted: 'Тайпа алып тасланды',
        error: 'Қәтелик жүз берди. Кейинирек қайтадан урынып көриң',
        statuses: 'Статуслар',
        order: 'Тәртип',
        name: 'Аты',
        titleLat: 'Өзбек тилиндеги аты (латын әлипбесинде)',
        titleCyr: 'Өзбек тилиндеги аты (кирилл әлипбесинде)',
        titleRu: 'Рус тилиндеги аты',
        pass: 'Бейжик',
        actions: 'Ҳәрекетлер',
        wantDeleteStatus: 'Сиз ҳақыйқаттан да статусты алып таслайжақсыз ба?',
      },
      PracticePenaltiesPage: {
        penaltiesDeleted: 'Жәрийма баллары алып тасланды',
        error: 'Қәтелик жүз берди. Кейинирек қайтадан урынып көриң',
        penalties: 'Жәриймалар',
        nameLat: 'Өзбек тилиндеги аты (латын әлипбесинде)',
        nameCyr: 'Өзбек тилиндеги аты (кирилл әлипбесинде)',
        nameRu: 'Рус тилиндеги аты',
        penaltyPoints: 'Жәрийма баллары',
        actions: 'Ҳәрекетлер',
        code: 'Код',
        wantDeletePenalty:
          'Сиз ҳақыйқаттан да жəрийма балларын алып таслайжақсыз ба?',
      },
      PracticeExercisesPage: {
        exserciseDeleted: 'Шынығыў алып тасланды',
        error: 'Қәтелик жүз берди. Кейинирек қайтадан урынып көриң',
        praticeExercises: 'Әмелий шынығыўлар',
        titleLat: 'Өзбек тилиндеги атама (латын әлипбесинде)',
        titleCyr: 'Өзбек тилиндеги атама (кирилл әлипбесинде)',
        titleRu: 'Рус тилиндеги атама',
        wantDeleteExercise:
          'Сиз ҳақыйқаттан да шынығыўды алып таслайжақсыз ба?',
        code: 'Код',
      },
      PaymentPage: {
        payment: 'Төлем',
        search: 'Излеў',
        fio: 'Ф.И.Ш',
        categories: 'Тайпа',
        statuses: 'Статус',
        certificate: 'Сертификат',
        printCertificate: 'Сертификатты басып шығарыў',
        sum: 'Суммасы',
        allSum: 'Жәми сумма',
        cash: 'НАҚ ПУЛ',
        bankCard: 'ТЕРМИНАЛ',
        pay: 'Төлеў',
        payDate: 'Төлеў сәнеси',
        paymentType: 'Төлем түри',
        error: 'Қәтелик',
        lastDigitsOfBankCard: 'Банк картасының ақырғы 4 саны',
      },
      ErrorTypesPage: {
        name: 'Аты',
        createdAt: 'Дүзилген сәне',
        actions: 'Ҳәрекетлер',
        errorTypeDeleted: 'Қәтелик түри алып тасланды',
        error: 'Қәтелик жүз берди, кейинирек қайтадан урынып көриң',
        errors: 'Қәтеликлер',
      },
      MotordromesPage: {
        motordromeDeleted: 'Автодром',
        error: 'Қәтелик жүз берди, кейинирек қайтадан урынып көриң',
        wantDeleteMotordrome:
          'Сиз ҳақыйқаттан да автодромды алып таслайжақсыз ба?',
        motordromes: 'Автодромлар',
        name: 'Аты',
        createdAt: 'Дүзилген сәне',
        actions: 'Ҳәрекетлер',
      },
      SchoolPage: {
        tin: 'СТИН',
        schoolDeleted: 'Мектеп алып тасланды',
        error: 'Қәтелик жүз берди, кейинирек қайтадан урынып көриң',
        wantDeleteSchool: 'Сиз ҳақыйқаттан да мектепти алып таслайжақсыз ба?',
        search: 'Излеў',
        clear: 'Тазалаў',
        schools: 'Мектеплер',
        enterName: 'Излеў ушын атын киргизиң',
        name: 'Аты',
        createdAt: 'Дүзилген сәне',
        actions: 'Ҳәрекетлер',
      },
      DocsPage: {
        docDeleted: 'Ҳүжжет алып тасланды',
        error: 'Қәтелик жүз берди, кейинирек қайтадан урынып көриң',
        wantDeleteDoc: 'Сиз ҳақыйқаттан да ҳүжжетти алып таслайжақсыз ба?',
        docs: 'Ҳүжжетлер',
        name: 'Аты',
        createdAt: 'Дүзилген сәне',
        actions: 'Ҳәрекетлер',
      },
      CreateVehicleTypePage: {
        fillFields: 'Майданды толтырың',
        createdVahicleType: 'Транспорт бойынша тайпа жаратылды',
        createCategory: 'Автомобилди басқарыў бойынша тайпаны жаратыў',
        name: 'Атын киргизиң',
        back: 'Артқа қайтыў',
        save: 'Сақлап қойыў',
      },
      CreateStatusPage: {
        createStatus: 'Статус жаратыў',
        type: 'Түрин таңлаң',
        queue: 'Нәўбетти таңлаң',
        pass: 'Бейжик',
        payment: 'Төлем',
        name: 'Аты',
        titleLat: 'Өзбек тилиндеги аты (латын әлипбесинде)',
        titleCyr: 'Өзбек тилиндеги аты (кирилл әлипбесинде)',
        titleRu: 'Рус тилиндеги аты',
        order: 'Тәртип',
        back: 'Артқа қайтыў',
        save: 'Сақлап қойыў',
        vehicleType: 'Транспорт қуралының түри',
      },
      CreatePracticePenaltyPage: {
        createPenalty: 'Жәрийма балларын жаратыў',
        nameLat: 'Өзбек тилиндеги аты (латын әлипбесинде)',
        nameCyr: 'Өзбек тилиндеги аты (кирилл әлипбесинде)',
        nameRu: 'Рус тилиндеги аты',
        scores: 'Баллар',
        cancel: 'Бийкарлаў',
        save: 'Сақлап қойыў',
        code: 'Код',
        codeError: 'Бундай код бар',
      },
      CreatePracticeExercisesPage: {
        createExercisse: 'Шынығыў дүзиў',
        nameLat: 'Өзбек тилиндеги аты (латын әлипбесинде)',
        nameCyr: 'Өзбек тилиндеги аты (кирилл әлипбесинде)',
        nameRu: 'Рус тилиндеги аты',
        cancel: 'Бийкарлаў',
        save: 'Сақлап қойыў',
        code: 'Код',
        codeError: 'Бундай код бар',
      },
      CreateErrorTypePage: {
        fillFields: 'Майданларды толтырың',
        error: 'Қәтелик жүз берди, кейинирек қайтадан урынып көриң',
        errorCreateSuccesed: 'Қәтелик түри табыслы жаратылды',
        createError: 'Қәтелик түрин жаратыў',
        nameCyr: 'Өзбек тилиндеги аты (кирилл әлипбесинде)',
        nameLat: 'Өзбек тилиндеги аты (латын әлипбесинде)',
        nameRu: 'Рус тилиндеги аты',
        back: 'Артқа қайтыў',
        save: 'Сақлап қойыў',
      },
      UpdateMotordromePage: {
        nameCyr: 'Өзбек тилиндеги аты (кирилл әлипбесинде)',
        nameLat: 'Өзбек тилиндеги аты (латын әлипбесинде)',
        nameRu: 'Рус тилиндеги аты',
        conflictError: 'Бул нәўбетте автодром әлле қашан бар',
        selectQueue: 'Нәўбетти таңлаң',
        updateMotordrome: 'Автодромды өзгертиў',
        fillFields: 'Майданларды толтырың',
        error: 'Қәтелик жүз берди, кейинирек қайтадан урынып көриң',
        updatedMotordrome: 'Автодром өзгертилди',
        name: 'Автодромның аты',
        back: 'Артқа қайтыў',
        save: 'Сақлап қойыў',
        vehicleTypes: 'Транспорт қуралының түрлери',
      },

      CreateMotordromePage: {
        conflictError: 'Бул нәўбетте автодром әлле қашан бар',
        selectQueue: 'Нәўбетти таңлаң',
        fillFields: 'Майданларды толтырың',
        error: 'Қәтелик жүз берди, кейинирек қайтадан урынып көриң',
        motordromeCreatedSuccess: 'Автодром табыслы жаратылды',
        createMotordrome: 'Автодром жаратыў',
        nameCyr: 'Өзбек тилиндеги аты (кирилл әлипбесинде)',
        nameLat: 'Өзбек тилиндеги аты (латын әлипбесинде)',
        nameRu: 'Рус тилиндеги аты',
        name: 'Автодромның аты',
        back: 'Артқа қайтыў',
        save: 'Сақлап қойыў',
        vehicleTypes: 'Транспорт қуралының түрлери',
      },
      UpdateSchoolPage: {
        tin: 'СТИН',
        conflict: 'Мектеп әлле қашан бар',
        tinConflict: 'Бундай СТИНли мектеп әлле қашан бар',
        fillFields: 'Майданларды толтырың',
        error: 'Қәтелик жүз берди, кейинирек қайтадан урынып көриң',
        name: 'Мектептиң аты',
        save: 'Сақлап қойыў',
        back: 'Артқа қайтыў',
        updateSchool: 'Мектепти өзгертиў',
        updatedSchool: 'Мектеп өзгертилди',
      },
      CreateSchoolPage: {
        tin: 'СТИН',
        conflict: 'Мектеп әлле қашан бар',
        fillFields: 'Майданларды толтырың',
        error: 'Қәтелик жүз берди, кейинирек қайтадан урынып көриң',
        schoolCreatedSuccess: 'Мектеп табыслы жаратылды',
        createSchool: 'Мектепти жаратыў',
        name: 'Аты',
        save: 'Сақлап қойыў',
        back: 'Артқа қайтыў',
      },
      CreateDocPage: {
        required: 'Мәжбүрий/Мәжбүрий емес',
        nameConflict: 'Бундай аттағы ҳүжжет бар',
        fillFields: 'Майданларды толтырың',
        error: 'Қәтелик жүз берди, кейинирек қайтадан урынып көриң',
        docCreateSuccesed: 'Ҳүжжет табыслы дүзилди',
        createDoc: 'Ҳүжжет дүзиў',
        nameCyr: 'Өзбек тилиндеги аты (кирилл әлипбесинде)',
        nameLat: 'Өзбек тилиндеги аты (латын әлипбесинде)',
        nameRu: 'Рус тилиндеги аты',
        name: 'Ҳүжжеттиң аты',
        back: 'Артқа қайтыў',
        save: 'Сақлап қойыў',
      },
      CreateCategoryPage: {
        fillFields: 'Майданларды толтырың',
        error: 'Қәтелик жүз берди, кейинирек қайтадан урынып көриң',
        categoryCreatSuccessed: 'Тайпа табыслы жаратылды',
        createdCategory: 'Тайпаны жаратыў',
        categoryName: 'Тайпаның аты',
        nameCyr: 'Өзбек тилиндеги аты (кирилл әлипбесинде)',
        nameLat: 'Өзбек тилиндеги аты (латын әлипбесинде)',
        nameRu: 'Рус тилиндеги аты',
        order: 'Тәртип',
        selectDocuments: 'Ҳүжжетлерди таңлаң',
        back: 'Артқа қайтыў',
        save: 'Сақлап қойыў',
        vehicleTypes: 'Транспорт қуралларының түрлери',
      },
      CreateApplicationPageByUser: {
        resident: 'ӨзР пуқарасы',
        noResident: 'Шет ел пуқарасы',
        isForeigner: 'ӨзР пуқарасы / Шет ел пуқарасы',
        choiceBranch: 'Филиалды таңлаң',
        residencePlace: 'Жасаў орны',
        enterSchoolName: 'Мектептиң атын киргизиң',
        notInList: 'Дизимде жоқ',
        choiceSchool: 'Автомектепти таңлаң',
        fillFields: 'Майданларды толтырың',
        selectLanguage: 'Имтихан тапсырыў тилин таңлаң',
        visitDateNotValid: 'Орайға келиў сәнеси надурыс',
        visitDate: 'Орайға келиў сәнеси',
        fillDocs: 'Ҳүжжетлерди толтырың',
        selectCategory: 'Тайпаны таңлаң',
        applicationSuccessCreated: 'Арза табыслы жаратылды',
        error: 'Қәтелик жүз берди, кейинирек қайтадан урынып көриң',
        vehicleType: 'Транспорт қуралының түрин белгилең',
        createApplication: 'Арза жаратыў',
        selectVehicleType: 'Транспорт түрин таңлаң',
        documentList: 'Ҳүжжетлер дизими',
        back: 'Артқа қайтыў',
        save: 'Сақлап қойыў',
        applicationAlreadyExists: 'Бундай тайпа көрсетилген арза бар',
        time: 'Ўақыт',
      },
      CreateApplicationPage: {
        send: 'Жибериў',
        resident: 'ӨзР пуқарасы',
        noResident: 'Шет ел пуқарасы',
        isForeigner: 'ӨзР пуқарасы / Шет ел пуқарасы',
        residencePlace: 'Жасаў орны',
        notInList: 'Дизимде жоқ',
        enterSchoolName: 'Автомектептиң атын киргизиң',
        choiceSchool: 'Автомектепти таңлаң',
        clear: 'Тазалаў',
        selectLanguage: 'Имтихан тапсырыў тилин таңлаң',
        fillFields: 'Майданларды толтырың',
        vehicleType: 'Транспорт қуралының түрин белгилең',
        uploadDocuments: 'Ҳүжжетлерди жүклең',
        applicationSuccessCreated: 'Арза табыслы жаратылды',
        applicationAlreadyExists: 'Бундай тайпа көрсетилген арза бар',
        error: 'Қәтелик жүз берди, кейинирек қайтадан урынып көриң',
        userNotFound: 'Пайдаланыўшы табылмады',
        createApplication: 'Арза жаратыў',
        enterPhoneNumber: 'Пайдаланыўшының телефон номерин киргизиң',
        pinfl: 'ФШЖИН',
        passportSerial: 'Паспорт сериясы.',
        passportNumber: 'Паспорт номери',
        selectCategory: 'Тайпаны таңлаң',
        selectVehicleType: 'Транспорт түрин таңлаң',
        userData: 'Пайдаланыўшының мағлыўматлары',
        firstName: 'Исми',
        lastName: 'Фамилиясы',
        middleName: 'Әкесиниң исми',
        dateOfBirth: 'Туўылған сәнеси',
        documentList: 'Ҳүжжетлер дизими',
        back: 'Артқа қайтыў',
        save: 'Сақлап қойыў',
        passIssued: 'Бейжик рәсмийлестирилди',
        choiceCategory: 'Тайпаны таңлаң',
        enterPassport: 'Паспорт сериясы ҳәм номерин киргизиң',
        errorPinfl: 'ФШЖИН майданында қәтелик',
        errorPhone: 'Телефон номери майданында қәтелик',
        passportExp: 'Паспорттың әмел етиў мүддети',
        medicalCertValid: 'Медициналық мағлыўматнаманың әмел етиў мүддети',
        getData: 'Мағлыўмат алыу',
      },
      CategoriesPage: {
        deletedCategory: 'Тайпа алып тасланды',
        error: 'Қәтелик жүз берди',
        wantDeleteCategory: 'Сиз ҳақыйқаттан да тайпаны алып таслайжақсыз ба?',
        categories: 'Тайпалар',
        name: 'Аты',
        createdAt: 'Дүзилген сәне',
        actions: 'Ҳәрекетлер',
      },
      CashPayment: {
        cashPayment: 'Нақ пул менен төлеў',
        fio: 'Ф.И.Ш',
        passport: 'Паспорт сериясы/номери',
        pinfl: 'ФШЖИН',
        date: 'Төлеў сәнеси',
        sum: 'Төлем суммасы',
        details: 'Толық мағлыўмат',
        amountEnclosed: 'Инкассацияланған сумма',
        dateEnclosed: 'Инкассация сәнеси',
        fioCashier: 'Төлемди қабыл етиўши кассирдиң Ф.И.Ш',
        idMachine: 'Төлем аппаратының идентификация номери',
      },
      BankCardPayment: {
        cardPayment: 'Банкке карта менен төлеў',
        fio: 'Ф.И.Ш',
        passport: 'Паспорт сериясы/номери',
        pinfl: 'ФШЖИН',
        date: 'Төлеў сәнеси',
        sum: 'Төлем суммасы',
        details: 'Толық мағлыўмат',
        lastNumber: 'Картаның ақырғы 4 цифры',
        fioCashier: 'Төлемди қабыл етиўши кассирдиң Ф.И.Ш',
        idMachine: 'Төлем аппаратының идентификация номери',
      },
      ApplicationsPage: {
        operator: 'Оператор',
        branch: 'Филиал',
        application: 'Арзалар',
        clear: 'Тазалаў',
        search: 'Излеў',
        fio: 'Ф.И.Ш',
        phone: 'Телефон',
        appCode: 'Арзаның  коды',
        passCode: 'Бейжиктиң номери',
        status: 'Статус',
        category: 'Тайпа',
        transportType: 'Транспорт түри',
        updatedAt: 'Өзгерислер киргизилген сәне',
        actions: 'Ҳәрекетлер',
        serial: 'Серия',
        number: 'Номер',
        pinfl: 'ФШЖИН',
        createdAt: '…ден',
        endDate: '…ге шекем',
        firstName: 'Исми',
        lastName: 'Фамилиясы',
        middleName: 'Әкесиниң исми',
        categories: 'Тайпа',
        vehicleTypes: 'Транспорт қуралының түри',
        statuses: 'Статус',
        creationType: 'Арза түри',
        choiceSchool: 'Мектепти таңлаң',
        dateOfBirth: 'Туўылған сәнеси',
        NOT_VERIFIED: 'NOT_VERIFIED',
        T_PAYMENT: 'T_PAYMENT',
        T_EXAM: 'T_EXAM',
        T_FAILED: 'T_FAILED',
        P_PAYMENT: 'P_PAYMENT',
        P_EXAM: 'P_EXAM',
        P_FAILED: 'P_FAILED',
        COMPLETED: 'COMPLETED',
        blocked: 'Блокланған',
      },
      auth: {
        notFoundUser: 'Телефон номери табылмады',
        enterOtpCode: 'СМС кодын киргизиң',
        passwordNotConfirmed: 'Пароллер сәйкес келмейди',
        passwordNotValid: 'Пароль кеминде 6 белгиден ибарат болыўы керек',
        login: 'Кириў',
        phoneNumber: 'Телефон номери',
        password: 'Пароль',
        forgotPassword: 'Пароль ядыңыздан шықты ма?',
        confirmPassowrd: 'Паролди тастыйықлаң',
        register: 'Дизимге алыў',
        resetPassword: 'Паролди өшириў',
        send: 'Жибериў',
        confirmOffer: 'Ғалабалық офертаны тастыйықлаң',
        enterCode: 'СМС-кодты киргизиң',
        newPassword: 'Жаңа пароль',
        smsCodeReplay: 'Қайта СМС жибериў',
        sendCodeToMobile: 'Сизиң номериңизге … коды менен СМС жиберилди',
        sendSmsLater: '…кейин СМС ти қайтадан жибериў',
        sendSmsAgain: 'СМС ти қайтадан жибериў',
        authSuccess: 'Авторизация табыслы өтти',
        error: 'Мағлыўматлардың дурыс толтырылғанлығын тексериң',
        notValidLoginOrPassword: 'Надурыс логин ямаса пароль киргизилген',
        tryLaterAgain: 'Қәтелик жүз берди, кейинирек қайтадан урынып көриң',
        editedPassword: 'Пароль өзгертилди',
        registed: 'Дизимнен өтиў',
        codeNotValid: 'Надурыс СМС-код',
        registrationSuccess: 'Дизимнен табыслы өтилди',
        alreadyUser: 'Бундай пайдаланыўшы бар',
        repeatPassword: 'Паролди тәкирарлаң',
        offer: 'Ғалабалық оферта',
        back: 'Артқа қайтыў',
        cancel: 'Бийкарлаў',
        sendCode: 'Кодты жибериў',
        checkCorrectData: 'Мағлыўматлардың дурыс толтырылғанлығын тексериң',
        passwordChanged: 'Пароль өзгертилди',
      },
      updateQueuePage: {
        choiceBranch: 'Филиалды таңлаў',
        choiceQueueType: 'Нәўбет түрин таңлаў',
        queueUpdated: 'Нәўбет өзгертилди',
        practice: 'Әмелият',
        theory: 'Теория',
        fillFields: 'Майданларды толтырың',
        tryAgainLater: 'Қәтелик жүз берди, кейинирек қайтадан урынып көриң',
        updateQueue: 'Нәўбетти өзгертиў',
        nameOz: 'Өзбек тилиндеги аты (кирилл әлипбесинде)',
        nameUz: 'Өзбек тилиндеги аты (латын әлипбесинде)',
        nameRu: 'Рус тилиндеги аты',
        back: 'Артқа қайтыў',
        save: 'Сақлап қойыў',
      },
      createQueuePage: {
        choiceBranch: 'Филиалды таңлаў',
        choiceQueueType: 'Нәўбет түрин таңлаў',
        queueCreated: 'Нәўбет табыслы жаратылды',
        practice: 'Әмелият',
        theory: 'Теория',
        fillFields: 'Майданларды толтырың',
        tryAgainLater: 'Қәтелик жүз берди, кейинирек қайтадан урынып көриң',
        createQueue: 'Нәўбет жаратыў',
        nameOz: 'Өзбек тилиндеги аты (кирилл әлипбесинде)',
        nameUz: 'Өзбек тилиндеги аты (латын әлипбесинде)',
        nameRu: 'Рус тилиндеги аты',
        back: 'Артқа қайтыў',
        save: 'Сақлап қойыў',
      },
      carsPage: {
        filter: 'Фильтр',
        choiceMotordrome: 'Автодромды таңлаң',
        search: 'Излеў',
        number: 'Номер',
        model: 'Модель',
        category: 'Тайпа',
        cars: 'Автомобиллер',
      },
      timeslotsPage: {
        reserved: 'Резервленген',
        capacity: 'Сыйымлылығы',
        timeslotDeleted: 'Қабыл етиў ўақыты алып тасланды',
        createTimeslot: 'Қабыл етиў ўақытын жаратыў',
        save: 'Сақлап қойыў',
        back: 'Артқа қайтыў',
        timeSlotUpdated: 'Қабыл етиў ўақыты өзгертилди',
        updateTimeslot: 'Қабыл етиў ўақытын өзгертиў',
        updatedDate: 'Өзгертиў санеси',
        actions: 'Ҳәрекетлер',
        fromTime: 'Басынан',
        toTime: 'Аяғына шекем',
        branch: 'Филиал',
        choiceBranch: 'Филиалды таңлаң',
        reservedAndCapacity: 'Резервленген / Сыйымлылығы',
        search: 'Излеў',
        timeslots: 'Ўақыт бөліністері',
        addTimeslot: 'Ўақыт бөлінісин қосуды',
        date: 'Сәне',
        deleteTimeslot: 'Ўақыт бөлінісин алып таслауды',
        confirmDelete:
          'Сиз ҳақыйқаттан да бул ўақыт бөлінісин алып таслайжақсыз ба?',
        createdTimeslot: 'Ўақыт бөлініси табыслы жаратылды',
        confirmDeleteTimeslot:
          'Сиз ҳақыйқаттан да бул ўақыт бөлінісин алып таслайжақсыз ба?',
        fillFields: 'Майданларды толтырың',
        savedData: 'Мағлыўматлар сақталды',
      },
      queuePage: {
        branches: 'Филиал',
        confirmDelete: 'Нәўбеттен шығарып таслаў керек пе?',
        confirmLogout: 'Сиз ҳақыйқаттан да шығып кетежақсыз ба?',
        usersCount: 'Нәўбеттеги адамлар саны',
        classRoom: 'Кабинет',
        selectClassRoom: 'Кабинетти таңлаң',
        emptyQueue: 'Нәўбет бос',
        confirmDeleteQueue:
          'Сиз ҳақыйқаттан да бул нәўбетти алып таслайжақсыз ба?',
        selectQueue: 'Нәўбетти таңлаң',
        clearedQueue: 'Нәўбет тазартылды',
        clear: 'Тазалаў',
        enterCount: 'Санын киргизиң',
        power: 'Иске түсириў',
        name: 'Аты',
        updateDate: 'Өзгерислер киргизилген сәне',
        actions: 'Ҳәрекетлер',
        notAccept: 'Рухсат берилмеди, қабыллаўға хабарласың',
        passNotValid: 'Әмелде болмаған бейжик (рухсатнама)',
        deletedQueue: 'Нәўбет алып тасланды',
        queue: 'Нәўбет',
        timeslots: 'Уақыт бөліністері',
      },
    },
  },
  en: {
    general: {
      instance: {
        noAccess: 'There is no access',
        login: 'Pass the authorization',
        uploadDocuments: 'Download the documents',
      },
    },
    components: {
      ScheduleQueue: {
        of: 'of',
        available: 'Available'
      },
      CheckQueue: {
        fio: 'Full name',
        title: 'Check your turn',
        dateOfBirth: 'Enter date of birth',
        pass: 'Enter pass number',
        save: 'Save',
        notFound: 'Your application was not found.',
        date: 'Date',
        time: 'Time',
        datePlaceholder: 'dd.mm.yyyy',
        qrTitle: 'Place the pass with the QR code on the scanner',
        dateError: 'The date of birth is incorrect.'

      },
      TimeSlots: {
        noPlaces: 'There are no places',
        choose: 'Choose',
        of: 'of',
        available: 'Available'
      },
      ReserveQueue: {
        selectCurrentTime: 'Please select the current time',
        conflict: 'Your request has already been added to the queue',
        dateOfBirth: 'Enter date of birth',
        pass: 'Enter pass number',
        save: 'Save',
        title: 'Reserve a queue',
        success: 'You have been successfully added to the electronic queue',
        error: 'Error, try again later',
        deleteApp: 'Delete old entry?',
        datePlaceholder: 'dd.mm.yyyy',
        notFound: 'Your application was not found.',
        qrTitle: 'Place the receipt with the QR code on the scanner',
        dateError: 'The date of birth is incorrect.',
        ageValidation: 'The candidate is under 18 years of age',
        blackList: 'Blacklisted candidate',
        expire083: 'The medical certificate has expired',
        expirePassport: 'The passport has expired',
        appNotVerified: 'The application has not been verified',
        wrongTimeslot: 'Выбранное время не доступно. Запись возможна на {{times}}',
      },
      Header: {
        prompt: 'Do you really want to go out?',
      },
      transactionModal: {
        replenished: 'Replenishment',
        writeOff: 'Written off',
        actionType: 'Action',
        pay: 'Payment',
        payme: 'Payme',
        click: 'Click',
        terminal: 'Terminal',
        cash: 'Cash',
        title: 'Transactions',
        transactionType: 'Type',
        amount: 'Sum',
        status: 'Status',
        payDate: 'Date of payment',
        completed: 'Successfully',
        failed: 'Payment error',
      },
      resultsModal: {
        seeApp: 'See the application',
        attempt: 'Attempt',
        success: 'You have successfully passed the practical exam, your result',
        result: 'Your result',
        print: 'Print copy sheet',
        exercise: 'Exercise',
        name: 'Name',
        penaltyPoints: 'Penalty points',
        total: 'Total',
        theorySuccess:
          'You have successfully passed the theoretical exam, your result',
        ticketNumber: 'Ticket number',
        question: 'Question',
        selectedAnswer: 'Selected Answer',
        results: 'Result',
      },
      newApplicationNotice: {
        newNotice: 'New online application',
        open: 'View',
        close: 'Close',
      },
      passModal: {
        enterPassNumber: 'Enter the pass number',
        save: 'Save',
      },
      pagination: {
        rowsPerPage: 'Number on the page',
      },
      queueList: {
        car: 'Automobile',
        classRoom: 'Audience',
        choiceCar: 'Choose a car',
        call: 'Call',
        cancel: 'Cancel',
        delete: 'Delete',
        category: 'Category',
      },
      TimeLine: {
        tests: 'Tests',
        right: 'Right',
        wrong: 'Wrong',
        total: 'Total points',
        startDate: 'start date',
        attempts: 'Attempts',
        carNumber: 'Car number',
        penaltyPoints: 'Penalty points',
        CREATED: 'CREATED',
        NOT_VERIFIED: 'NOT_VERIFIED',
        T_PAYMENT: 'T_PAYMENT',
        T_EXAM: 'T_EXAM',
        T_FAILED: 'T_FAILED',
        P_PAYMENT: 'P_PAYMENT',
        P_EXAM: 'P_EXAM',
        P_FAILED: 'P_FAILED',
        COMPLETED: 'COMPLETED',
        theoryEndDate: 'Theory end date',
      },
      Sidebar: {
        reports: 'Protocols',
        responsiblePerson: 'Ответственные лица',
        schools: 'Schools',
        enterName: 'Enter the name for the search',
        control: 'Drive management',
        classRooms: 'Cabinets',
        cars: 'Cars',
        queue: 'Queue',
        users: 'Users',
        categories: 'Categories',
        docs: 'Documents',
        applications: 'Applications',
        statuses: 'Statuses',
        practiceCategory: 'Types of vehicles',
        payment: 'Payment',
        passedExam: 'Passed the exam',
        cashPayment: 'Cash payment',
        userId: 'User identification',
        visitLogs: 'The history of visits',
        motordromes: 'Avtodrom',
        errors: 'Mistakes',
        transactions: 'Transactions',
        verrifyApps: 'Verified applications',
        generatReport: 'General report',
        generalStatistics: 'Statistics report',
        schoolStatistics: 'Statistics on schools',
        gaiSchoolsReport: 'Traffic police report on schools',
        sumarry: 'CTI',
        appeals: 'Appeal',
        report: 'Reports',
        vising: 'Visting',
        requestForChangeData: 'Requests for amm. ',
        certificates: 'Certificates',
        certificatesHistory: 'Certificate History',
        calendar: 'Calendar',
        fines: 'Fines',
        reception: 'Reception',
        security: 'Security',
        accounting: 'Accounting',
        cash: 'Cash register',
        statistics: 'Statistics',
        integrationWithGai: 'Integration with the traffic police',
        practicalStatisticByCategory: 'Статистика ПЭ по категориям',
        timeslots: 'Time slots',
      },
      CategoryStatuses: {
        statusDeleted: 'The status is deleted',
        erorrTryAgain: 'Try the error again',
        wantToRemove: 'Do you really want to delete category status?',
        add: 'Add category status',
        status: 'Status',
        successStatus: 'Status in case of success',
        failureStatus: 'Status in case of failure',
        order: 'Order',
        start: 'Started',
        finished: 'Complete',
        createdAt: 'The date of creation',
        actions: 'Actions',
      },
      Confirmation: {
        cancel: 'Cancellation',
        success: 'Confirm',
      },
      FileUploader: {
        fileSize: 'Too large file size',
        selectDocument: 'Select a document',
        selectAnotherDocument: 'Choose another document',
        scanning: 'Scan',
        getDocument: 'Get document',
        enterPinfl: 'Enter the pinfl',
        enterVehicleType: 'Select the type of vehicle',
        documentReceived: 'Document received',
        docNotFound: 'The document was not found',
        error: 'Error, please try again later',
      },
      FileUploads: {
        certificateFromSchool: 'Справка с автошколы',
        mainPassport: 'Passport',
        photo: 'Photo',
        passport: 'Passport/ID card (with registration)',
        employerReferral: 'The direction of the employer',
        replacement:
          "Replacement of a driver’s license of persons of a single sample or driver’s license of the Kaggary “C” and “C” for a period of more than 10 years of continuous labor activity of the driver categories “Ve” and “CE” on the basis of an extract from the driver's work book",
        driverLicence_1: 'National Driving Rights-1',
        driverLicence_2: 'National Driving Rights-2',
        direction: 'Direction of the authorized internal affairs body',
        honey083_1: 'Med. certificate 083-1',
        honey083_2: 'Med. certificate 083-2',
        diplomaAnnex:
          'Diploma and an application to it about the assimilation of objects according to the plan',
        nationalDriversLicence:
          'National driver’s license (“c”, “b” and “c”, “d”, “c” and “d”, “s” and (or) “de”)',
        certificateSingleSample: 'Certificate of a single sample',
        pinflForForeign: 'Pinfl for foreign gr.',
        docConfirm12:
          'The document approving up to 12 months drove the vehicle',
        appForAppeal: 'Application for appeal',
        decisionAppealComission: 'The decision of the appeal commission',
        forWorkingDrivers:
          'For working drivers - an extract from the work book or a certificate (extract from the order) indicating the type of vehicle assigned to it;',
      },
      Footer: {
        address: 'Tashkent, Yangikhayatsky district, st. ',
        copyRight: '2022 All rights are protected',
      },
      CreateCategoryStatuses: {
        fillFields: 'Fill in the fields',
        createdSuccess: 'Category status was created successfully',
        alreadyExistsDefault:
          'Category status with the default status already exists',
        alreadyExistsFinish:
          "Category status with the status 'Completely' already exists",
        errorTryAgain: 'Try the error later',
        createStatusCategory: 'Create status for category',
        selectStatus: 'Choose the status',
        successStatus: 'Status in case of success',
        failureStatus: 'Status in case of failure',
        workDays: 'Number of working days before re-attempt',
        order: 'Order',
        defaultStatus: 'Default status',
        finished: 'Complete',
        cancel: 'Cancel',
        save: 'Save',
      },
      UpdateCategoryStatuses: {
        fillFields: 'Fill in the fields',
        updateSuccess: 'Category status is changed',
        errorTryAgain: 'Try the error later',
        updateStatusCategory: 'Change the status for the category',
        selectStatus: 'Choose the status',
        successStatus: 'Status in case of success',
        failureStatus: 'Status in case of failure',
        cost: 'Price',
        workDays: 'Number of working days before re-attempt',
        order: 'Order',
        defaultStatus: 'Default status',
        finished: 'Complete',
        cancel: 'Cancel',
        save: 'Save',
        alreadyExistsDefault:
          'Category status with the default status already exists',
        alreadyExistsFinish:
          "Category status with the status 'Completely' already exist",
      },
      TokenModal: {
        copy: 'Cooped to the exchange buffer',
        refresh: 'Update',
      },
      UserModal: {
        userInfo: 'User information',
        FIO: 'Full name',
        dateOfBirth: 'Date of birth',
        passport: 'Series/Passport number',
        pinfl: 'Pinfl',
        phone: 'Phone number',
        cancel: 'Cancel',
        successUser: 'Confirm the user',
        name: 'Name',
        createdAt: 'The date of creation',
        actions: 'Actions',
      },
    },
    pages: {
      ScheduleTimePage: {
        
      },
      SchedulePage: {
        checkQueue: 'Check your turn',
      },
      ReportsForSchool: {
        fieldNotFilled: 'Поля не заполнены',
        schoolsStat: 'Статистика автошкол',
        search: 'Поиск',
        from: 'С',
        to: 'По',
        clear: 'Очистить',
      },
      FinesDetails: {
        from: 'From',
        to: 'To',
        penalty: 'Penalty',
        yes: 'Yes',
        no: 'No',
        search: 'Search',
        clear: 'Clear',
        createdAt: 'Created at',
        appLink: 'App link',
        branch: 'Branch',
        fixed: 'Fixed',
        details: 'Details',
        go: 'Go',
      },
      FinesPage: {
        from: 'From',
        to: 'To',
        search: 'Search',
        clear: 'Clear',
        fullName: 'Full name',
        phone: 'Phone',
        branch: 'Branch',
        finesNumber: 'Number of fines',
        details: 'Details',
        go: 'Follow',
      },
      OfficialReportByIdPage: {
        appConfirmed: 'Заявка подтверждена',
        error: 'Ошибка, попробуйте позже',
        title: 'Запрос на изм данных',
        penalty: 'Penalty',
        confirm: 'Confirm',
        confirmedBy: 'Confirmed by whom',
        currentData: 'Current data',
        firstName: 'First name',
        lastName: 'Last name',
        middleName: 'Middle name',
        dateOfBirth: 'Date of birth',
        passportSerial: 'Passport serial',
        passportNumber: 'Passport number',
        passportValid: 'Passport valid',
        dateMed: 'The date of the med. ref',
        changeData: 'Change data',
        fullName: 'Full name',
        passportSerialNumber: 'Passport serial / number',
        pinfl: 'PINFL',
        branch: 'Branch',
        status: 'Status',
        phone: 'Phone',
        transactionDate: 'Transaction date',
        cardTypeNumber: 'Card type / number',
        sum: 'Sum',
        report: 'Report',
      },
      OfficialReportsPage: {
        title: 'Requests for data modification',
        completed: 'Completed',
        all: 'All',
        yes: 'Yes',
        no: 'No',
        activity: 'Activity',
        branch: 'Branch',
        user: 'User',
        search: 'Search',
        clear: 'Clear',
        createdAt: 'Created at',
        type: 'Type',
        appLink: 'Link to the application',
        candidate: 'Candidate',
        confirmedBy: 'Confirmed by whom',
        status: 'Status',
        step: 'Step',
        penalty: 'Penalty',
        accomplishment: 'Accomplishment',
        details: 'Details',
        confirmed: 'Confirmed',
        new: 'New',
        data: 'Data',
        refund: 'Refund',
      },
      AppealPageById: {
        fio: 'Full name',
        passportSerial: 'Passport searial / number',
        phone: 'Phone',
        dateOfBirth: 'Date of birth',
        examType: 'Exam type',
        applicaiton: 'Application',
        applicaitionLink: 'Application link',
        title: 'The decision of the Appeal Commission',
      },
      AppealsPage: {
        appeal: 'Appeal',
        fio: 'Full name',
        phone: 'Phone',
        createdAt: 'Created at',
        examType: 'Type of exam',
        actions: 'Actions',
        choiceBranch: 'Select a branch',
        all: 'All',
      },
      ReportPage: {
        reportHistory: 'The history of the protocol',
        FIO: 'Full name',
        category: 'Category',
        school: 'School',
        theoryAttempt: 'Attempts theory',
        theoryScore: 'BALS Theory',
        practiceAttempt: 'Poptyki practice',
        practiceScore: 'I passed/did not pass',
        passed: 'Passed',
        notPassed: 'I did not give it up',
        certificateNumber: 'Certificate number',
        print: 'Print',
      },
      ReportsPage: {
        enterDate: 'Enter the date',
        count: 'Quantity',
        actions: 'Action',
        createdAt: 'The date of creation',
        dayNumber: 'The number of generation of the protocol',
        reports: 'Protocols',
        generation: 'Generate',
        name: 'Name',
        date: 'Date',
        clear: 'Clear',
        search: 'Search',
        branches: 'Branches',
        from: 'From',
        protocolNumber: 'Protocol number',
      },
      SummaryPage: {
        branch: 'Branch',
        from: 'WITH',
        to: 'By',
        branches: 'Branches',
        summary: 'Summary',
        application: 'Bid',
        clear: 'Clean',
        search: 'Find',
        fio: 'F.I.O.',
        appCode: 'Application code',
        status: 'Status',
        createdAt: 'The date of creation',
        firstName: 'Name',
        lastName: 'Surname',
        middleName: 'Surname',
        categories: 'Category',
        vehicleTypes: 'Type of vehicle',
        oldStatus: 'Previous status',
        newStatus: 'New status',
        attempt: 'Attempt',
        attempts: 'Attempts',
        firstAttempt: 'The first attempt',
        retake: 'Purchant',
        passport: 'Series/Passport number',
        phone: 'Telephone',
        result: 'Result',
        true: 'Successfully',
        false: 'Not successful',
      },
      UpdateClassRoomPage: {
        choiceBranch: 'Select a branch',
        nameError: 'The name of the cabinet already exists',
        fillFields: 'Fill in the fields',
        updatedClassRoom: 'The office is changed',
        updateClassRoom: 'Change the cabinet',
        enterName: 'Enter the name',
        back: 'Back',
        save: 'Save',
      },
      CreateClassRoomPage: {
        choiceBranch: 'Select a branch',
        nameError: 'The name of the cabinet already exists',
        fillFields: 'Fill in the fields',
        createdClassRoom: 'The office is created',
        createClassRoom: 'Create an office',
        name: 'Name',
        back: 'Back',
        save: 'Save',
      },
      ClassRoomsPage: {
        classRooms: 'Cabinets',
        deleted: 'The office is deleted',
        wantDeleteClassRoom: 'Do you really want to delete this office?',
        updatedDate: 'The date of change',
        actions: 'Actions',
        name: 'Name',
        classRoom: 'Cabinet',
      },
      ApplicationForGai: {
        fio: 'F.I.O.',
        passport: 'Passport',
        dateOfBirth: 'Date of birth',
        phone: 'Telephone',
        vehicleType: 'Type of vehicle',
      },
      ApplicationsForGai: {
        application: 'Applications',
        clear: 'Clean',
        search: 'Find',
        fio: 'F.I.O.',
        phone: 'Telephone',
        appCode: 'Application code',
        passCode: 'Pass number',
        status: 'Status',
        category: 'Category',
        transportType: 'Type of vehicle',
        updatedAt: 'The date of change',
        actions: 'Actions',
        serial: 'Series',
        number: 'Number',
        pinfl: 'Pinfl',
        createdAt: 'The date of creation',
        endDate: 'The end of the end',
        firstName: 'Name',
        lastName: 'Surname',
        middleName: 'Surname',
        categories: 'Category',
        vehicleTypes: 'Type of vehicle',
        statuses: 'Status',
      },
      VisitLogsPage: {
        visitLogs: 'The history of visits',
        date: 'Date',
        search: 'Search',
        clear: 'Clean',
        fio: 'F.I.O.',
        dateOfBirth: 'Date of birth',
        passport: 'Series/Passport number',
        appCategory: 'The category of applications',
        createdAt: 'The date of creation',
        status: 'Status',
      },
      VehicleTypesPage: {
        deleted: 'Successfully deleted',
        wantDeleteVehicle: 'Do you really want to remove the vehicle?',
        vehicleTypes: 'Vehicles',
        name: 'Name',
        actions: 'Actions',
      },
      UsersPage: {
        error: 'Error, try later',
        users: 'Users',
        serial: 'Series',
        number: 'Number',
        firstName: 'Name',
        lastName: 'Surname',
        middleName: 'Surname',
        search: 'Search',
        clear: 'Clean',
        passport: 'Series/Passport number',
        pinfl: 'Pinfl',
        fio: 'F.I.O.',
        phone: 'Telephone',
        integrated: 'Integrated',
        role: 'Role',
        verrified: 'Confirmed',
        status: 'Status',
        actions: 'Actions',
      },
      UserIdentificationPage: {
        error: 'Error, try later',
        applicationNotFound: 'The application was not found',
        userNotActive: 'The user is not active',
        statusError: 'Status error',
        appNotVerrified: 'The application is not confirmed',
        fio: 'F.I.O.',
        dateOfBirth: 'Date of birth',
        phone: 'Telephone',
        passport: 'Seria and passport number',
        pinfl: 'Pinfl',
        appStatus: 'Application status',
        appCategory: 'The category of applications',
        failureDays:
          'For re -passing the exam, at least 7 working days from the date of the exam should pass',
        success: 'Successfully',
        passportExp: 'Passport period',
        medicalCertValid: 'Term medical. ',
      },
      UpdateVehicleTypePage: {
        fillFields: 'Fill in the field',
        vehicletypeUpdated: 'The vehicle is changed',
        updateVehicleType: 'Change the vehicle',
        enterName: 'Enter the name',
        back: 'Back',
        save: 'Save',
      },
      UpdateUserPage: {
        motordrome: 'Avtodrom',
        phoneError: 'A user with such a phone already exists',
        passportError: 'A user with such a passport already exists',
        pinflError: 'User with such Pinfl already exists',
        updateUser: 'Update the user',
        serial: 'Series',
        number: 'Number',
        phone: 'Phone number',
        role: 'Role',
        firstName: 'Name',
        lastName: 'Surname',
        middleName: 'Surname',
        dateOfBirth: 'Date of birth',
        pinfl: 'Pinfl',
        getToken: 'Get a token',
        back: 'Back',
        save: 'Save',
      },
      UpdateStatusPage: {
        updateStatus: 'Update the status',
        type: 'Select the type',
        queue: 'Select the queue',
        pass: 'Pass',
        pay: 'Payment',
        name: 'Name',
        titleLat: 'Title on Uzbek (Latin)',
        titleCyr: 'Title on Uzbek (Cyrillic)',
        titleRu: 'Title in Russian',
        order: 'Order',
        back: 'Back',
        update: 'Update',
        vehicleType: 'Type of vehicle',
      },
      UpdatePracticePenaltyPage: {
        updatePenalty: 'Update penalty points',
        nameLat: 'Name on Uzbek (Latin)',
        nameCyr: 'Name on Uzbek (Cyrillic)',
        nameRu: 'The name is in Russian',
        points: 'Points',
        cancel: 'Cancellation',
        save: 'Save',
        code: 'Code',
        codeError: 'This code already exists',
      },
      UpdatePracticeExercisesPage: {
        updateExercise: 'Update the exercise',
        nameLat: 'Name on Uzbek (Latin)',
        nameCyr: 'Name on Uzbek (Cyrillic)',
        nameRu: 'The name is in Russian',
        cancel: 'Cancellation',
        save: 'Save',
        code: 'Code',
        codeError: 'This code already exists',
      },
      UpdateErrorTypePage: {
        fillFields: 'Fill in the fields',
        errorTypeChanged: 'The type of error is changed',
        error: 'An error has occurred, try it later',
        updateErrorType: 'Change the type of error',
        nameCyr: 'Name on Uzbek (Cyrillic)',
        nameLat: 'Name on Uzbek (Latin)',
        nameRu: 'The name is in Russian',
        back: 'Back',
        save: 'Save',
      },
      UpdateDocPage: {
        required: 'Mandatory/not mandatory',
        nameConflict: 'A document with this name already exists',
        fillFields: 'Fill in the fields',
        docUpdated: 'The document is changed',
        error: 'An error has occurred, try it later',
        updateDocument: 'Edit the document',
        docName: 'The name of the document',
        nameCyr: 'Name on Uzbek (Cyrillic)',
        nameLat: 'Name on Uzbek (Latin)',
        nameRu: 'The name is in Russian',
        back: 'Back',
        save: 'Save',
      },
      UpdateCategoryPage: {
        fillFields: 'Fill in the fields',
        categoryUpdated: 'The category is changed',
        error: 'An error has occurred, try it later',
        updateCategory: 'Edit the category',
        data: 'Data',
        statuses: 'Statuses',
        categoryName: 'The name of the category',
        nameCyr: 'Name on Uzbek (Cyrillic)',
        nameLat: 'Name on Uzbek (Latin)',
        nameRu: 'The name is in Russian',
        order: 'Order',
        selectDocuments: 'Select the documents',
        back: 'Back',
        save: 'Save',
        vehicleTypes: 'Types of vehicles',
      },
      ApplicationHistoryPage: {
        branch: 'Branch',
        actions: 'Action',
        more: 'Read more',
        applicationHistory: 'The history of the application',
        history: 'Story',
        result: 'Result',
        success: 'Right',
        fail: 'Wrong',
        answer: 'Answer',
        question: 'Question',
        ticketNumber: 'Ticket number',
        createdDate: 'The date of creation',
        statuses: 'Statuses',
        transactions: 'Transactions',
        results: 'Results',
        oldStatus: 'Previous status',
        nextStatus: 'The next status',
        currentStatus: 'Current status',
        category: 'Category',
        errorMessage: 'Blocked successfully',
        error: 'Error, try again later',
        sent: 'Sent',
        dateSendingToGai: 'Date of dispatch to the GAI',
        lastSubmissionDate: 'Last Submission Date',
        status: 'Status GAI',
        message: 'Message',
        appeal: 'Appeal',
        resend: 'Resend',
        block: 'Block',
        unblock: 'Unblock',
        attemattempt: 'Attempt',
        yesNo: 'Successful / No',
      },
      UpdateApplicationPage: {
        resident: 'Citizen RUZ',
        noResident: 'Foreigner',
        isForeigner: 'Citizen Ruz / Foreigner',
        time: 'Time',
        branch: 'Branch',
        choiceBranch: 'Select a branch',
        residencePlace: 'Place of residence',
        more: 'Read more about the application',
        uploadDocuments: 'Fill in the documents',
        notInList: 'No on the list',
        enterSchoolName: 'Enter the name of the driving school',
        choiceSchool: 'Choose a driving school',
        selectLanguage: 'Choose the language of the exam',
        visitDateNotValid: 'Not correct date for the visit to the center',
        visitDate: 'Date of visit to the center',
        verification: 'Verified user',
        confirmedApplication: 'The application is confirmed',
        printCertificate: 'Print a certificate',
        correctPhone: 'Enter the correct phone number',
        userNotReceived: 'User data not received',
        fillFields: 'Fill in the fields',
        vehicleType: 'Indicate the type of vehicle',
        applicationsUpdated: 'The application is changed',
        error: 'An error has occurred, try it later',
        canceledApplication: 'Cancel the application',
        passportConflict: 'A user with such a passport already exists',
        applicationRejected: 'The application is rejected',
        application: 'Bid',
        updateApplication: 'Change the application',
        cancelApp: 'Cancel and maintain an application',
        save: 'Save',
        appData: 'These applications',
        transport: 'Transport',
        userData: 'User data',
        userPhone: 'Enter the user phone number',
        passportSeries: 'A series of passport',
        passportNumber: 'Passport number',
        pinfl: 'Pinfl',
        firstName: 'Name',
        lastName: 'Surname',
        middleName: 'Surname',
        dateOfBirth: 'Date of birth',
        back: 'Back',
        phone: 'Telephone',
        category: 'Category',
        transportType: 'Type of transport',
        reasonsRejectedApp: 'Reasons for the deviation of the application',
        docsList: 'List of documents',
        passIssue: 'Make a pass',
        selectCategoryAndTryAgain: 'Select the category and try again',
        passIssued: 'The pass is issued',
        confirmApplication: 'Confirm and save the application',
        errorTryLater: 'Try the error later',
        conflictPinfl: 'User with such Pinfl already exists',
        conflictSerialNumber:
          'A user with such a series and number already exists',
        conflictPhone: 'A user with such a phone number already exists',
        requestChanges: 'Request changes',
        blacklisted: 'Blacklist',
        unblock: 'Unlock',
        reason: 'Indicate the reason for adding a candidate to the black list',
        note: 'note',
        update: 'Change',
        add: 'Add',
        submitAReport: 'Submit a report',
        CREATED: 'CREATED',
        NOT_VERIFIED: 'NOT_VERIFIED',
        T_PAYMENT: 'T_PAYMENT',
        T_EXAM: 'T_EXAM',
        T_FAILED: 'T_FAILED',
        P_PAYMENT: 'P_PAYMENT',
        P_EXAM: 'P_EXAM',
        P_FAILED: 'P_FAILED',
        COMPLETED: 'COMPLETED',
        appeal: 'Appeal',
        noVerified: 'No verified',
        verified: 'Verified',
        passportValidity: 'Passport validity',
        medCertificateValidity: 'Med certificate validity',
      },
      TransactionsPage: {
        transactions: 'Transactions',
        fio: 'F.I.O.',
        paymentDate: 'Date of payment',
        paymentType: 'Type of payment',
        sum: 'Sum',
        passport: 'Passport data',
        pinfl: 'Pinfl',
        id: 'ID',
        cardNumber: 'Card (4 foreign numbers)',
        datails: 'Details',
        cashierName: 'F.I.',
        date: 'Date',
        transactionsStatus: 'Transaction status',
        transactionsType: 'Type of transaction',
        search: 'Search',
        clear: 'Clean',
        CASH: 'Cash',
        TERMINAL: 'Terminal',
        PAYME: 'Payme',
        CLICK: 'Click',
        REFUND: 'Return',
        FREE: 'For free',
        UZCARD: 'Uzcard',
        HUMO: 'Humo',
        BANK: 'Bank',
        EPOS: 'EPOS',
        THEORY_PAYMENT: 'Theoretical exam',
        PRACTICE_PAYMENT: 'Practical exam',
        examType: 'Type of exam',
        createdAt: 'C.',
        endDate: 'By',
        branch: 'Branch',
        appId: 'ID applications',
        qrCode: 'QR code',
        exportExcel: 'Export to Excel',
        totalSum: 'Total amount',
        failedTheTheory: 'He failed the theory',
        retake: 'Purchant',
        paymentOnAnotherDay: 'Payment on another day',
        applyForRefund: 'Submit for a return',
        changeTransactionType: 'Change the type of transaction',
        go: 'Go',
        transactionType: 'Type of transaction',
        change: 'Change',
        QR: 'QR'
      },
      StatusesPage: {
        categoryDeleted: 'The category is deleted',
        error: 'An error has occurred, try it later',
        statuses: 'Statuses',
        order: 'Order',
        name: 'Name',
        titleLat: 'Name on Uzbek (Latin)',
        titleCyr: 'Name on Uzbek (Cyrillic)',
        titleRu: 'The name is in Russian',
        pass: 'Pass',
        actions: 'Actions',
        wantDeleteStatus: 'Do you really want to remove a status?',
      },
      PracticePenaltiesPage: {
        penaltiesDeleted: 'Penalty points are removed',
        error: 'An error has occurred, try it later',
        penalties: 'Fines',
        nameLat: 'Name on Uzbek (Latin)',
        nameCyr: 'Name on Uzbek (Cyrillic)',
        nameRu: 'The name is in Russian',
        penaltyPoints: 'Penalty glasses',
        actions: 'Actions',
        code: 'Code',
        wantDeletePenalty: 'Do you really want to remove penalties?',
      },
      PracticeExercisesPage: {
        exserciseDeleted: 'The exercise is removed',
        error: 'An error has occurred, try it later',
        praticeExercises: 'Practical exercises',
        titleLat: 'Title on Uzbek (Latin)',
        titleCyr: 'Title on Uzbek (Cyrillic)',
        titleRu: 'Title in Russian',
        wantDeleteExercise: 'Do you really want to remove the exercise?',
        code: 'Code',
      },
      PaymentPage: {
        payment: 'Payment',
        search: 'Find',
        fio: 'F.I.O.',
        categories: 'Category',
        statuses: 'Status',
        certificate: 'Certificate',
        printCertificate: 'Spread a certificate',
        sum: 'Sum',
        allSum: 'The whole amount',
        cash: 'CASH',
        bankCard: 'TERMINAL',
        pay: 'Pay',
        payDate: 'Date of payment',
        paymentType: 'Type of payment',
        error: 'Error',
        lastDigitsOfBankCard: 'After 4 digits card bank',
      },
      ErrorTypesPage: {
        name: 'Name',
        createdAt: 'The date of creation',
        actions: 'Actions',
        errorTypeDeleted: 'The type of error is removed',
        error: 'An error has occurred, try it later',
        errors: 'Mistakes',
      },
      MotordromesPage: {
        motordromeDeleted: 'Avtodrom is removed',
        error: 'An error has occurred, try it later',
        wantDeleteMotordrome: 'Do you really want to delete the Autodrome?',
        motordromes: 'Avtodroms',
        name: 'Name',
        createdAt: 'The date of creation',
        actions: 'Actions',
      },
      SchoolPage: {
        tin: 'TIN',
        schoolDeleted: 'The school is removed',
        error: 'An error has occurred, try it later',
        wantDeleteSchool: 'Do you really want to remove school?',
        search: 'Search',
        clear: 'Clean',
        schools: 'Schools',
        enterName: 'Enter the name for the search',
        name: 'Name',
        createdAt: 'The date of creation',
        actions: 'Actions',
      },
      DocsPage: {
        docDeleted: 'The document is deleted',
        error: 'An error has occurred, try it later',
        wantDeleteDoc: 'Do you want to delete the document?',
        docs: 'Documents',
        name: 'Name',
        createdAt: 'The date of creation',
        actions: 'Actions',
      },
      CreateVehicleTypePage: {
        fillFields: 'Fill in the field',
        createdVahicleType: 'The transport category has been created',
        createCategory: 'Create a car driving category',
        name: 'Enter the name',
        back: 'Back',
        save: 'Save',
      },
      CreateStatusPage: {
        createStatus: 'Create status',
        type: 'Select the type',
        queue: 'Select the queue',
        pass: 'Pass',
        payment: 'Payment',
        name: 'Name',
        titleLat: 'Name on Uzbek (Latin)',
        titleCyr: 'Name on Uzbek (Cyrillic)',
        titleRu: 'The name is in Russian',
        order: 'Order',
        back: 'Back',
        save: 'Save',
        vehicleType: 'Type of vehicle',
      },
      CreatePracticePenaltyPage: {
        createPenalty: 'Create penalty points',
        nameLat: 'Name on Uzbek (Latin)',
        nameCyr: 'Name on Uzbek (Cyrillic)',
        nameRu: 'The name is in Russian',
        scores: 'Points',
        cancel: 'Cancellation',
        save: 'Save',
        code: 'Code',
        codeError: 'This code already exists',
      },
      CreatePracticeExercisesPage: {
        createExercisse: 'Create an exercise',
        nameLat: 'Name on Uzbek (Latin)',
        nameCyr: 'Name on Uzbek (Cyrillic)',
        nameRu: 'The name is in Russian',
        cancel: 'Cancellation',
        save: 'Save',
        code: 'Code',
        codeError: 'This code already exists',
      },
      CreateErrorTypePage: {
        fillFields: 'Fill in the fields',
        error: 'An error has occurred, try it later',
        errorCreateSuccesed: 'Type of error is created successfully',
        createError: 'Create a type of error',
        nameCyr: 'Name on Uzbek (Cyrillic)',
        nameLat: 'Name on Uzbek (Latin)',
        nameRu: 'The name is in Russian',
        back: 'Back',
        save: 'Save',
      },
      UpdateMotordromePage: {
        nameCyr: 'Name on Uzbek (Cyrillic)',
        nameLat: 'Name on Uzbek (Latin)',
        nameRu: 'The name is in Russian',
        conflictError: 'Avtodrom in this queue already exists',
        selectQueue: 'Select the queue',
        updateMotordrome: 'Change the autodrome',
        fillFields: 'Fill in the fields',
        error: 'An error has occurred, try it later',
        updatedMotordrome: 'Avtodrod is changed',
        name: 'The name of the Avtodrome',
        back: 'Back',
        save: 'Save',
        vehicleTypes: 'Types of the vehicle',
      },
      CreateMotordromePage: {
        conflictError: 'Avtodrom in this queue already exists',
        selectQueue: 'Select the queue',
        fillFields: 'Fill in the fields',
        error: 'An error has occurred, try it later',
        motordromeCreatedSuccess: 'Avtodr was created successfully',
        createMotordrome: 'Create an autodrome',
        nameCyr: 'Name on Uzbek (Cyrillic)',
        nameLat: 'Name on Uzbek (Latin)',
        nameRu: 'The name is in Russian',
        name: 'The name of the Avtodrome',
        back: 'Back',
        save: 'Save',
        vehicleTypes: 'Types of the vehicle',
      },
      UpdateSchoolPage: {
        tin: 'TIN',
        conflict: 'The school already exists',
        tinConflict: 'A school with such a TIN already exists',
        fillFields: 'Fill in the fields',
        error: 'An error has occurred, try it later',
        name: 'School name',
        save: 'Save',
        back: 'Back',
        updateSchool: 'Change school',
        updatedSchool: 'The school is changed',
      },
      CreateSchoolPage: {
        tin: 'TIN',
        conflict: 'The school already exists',
        fillFields: 'Fill in the fields',
        error: 'An error has occurred, try it later',
        schoolCreatedSuccess: 'The school was created successfully',
        createSchool: 'Create a school',
        name: 'Name',
        save: 'Save',
        back: 'Back',
      },
      CreateDocPage: {
        required: 'Mandatory/not mandatory',
        nameConflict: 'A document with this name already exists',
        fillFields: 'Fill in the fields',
        error: 'An error has occurred, try it later',
        docCreateSuccesed: 'The document was created successfully',
        createDoc: 'Create a document',
        nameCyr: 'Name on Uzbek (Cyrillic)',
        nameLat: 'Name on Uzbek (Latin)',
        nameRu: 'The name is in Russian',
        name: 'The name of the document',
        back: 'Back',
        save: 'Save',
      },
      CreateCategoryPage: {
        fillFields: 'Fill in the fields',
        error: 'An error has occurred, try it later',
        categoryCreatSuccessed: 'The category was created successfully',
        createdCategory: 'Create a category',
        categoryName: 'The name of the category',
        nameCyr: 'Name on Uzbek (Cyrillic)',
        nameLat: 'Name on Uzbek (Latin)',
        nameRu: 'The name is in Russian',
        order: 'Order',
        selectDocuments: 'Select the documents',
        back: 'Back',
        save: 'Save',
        vehicleTypes: 'Types of vehicles',
      },
      CreateApplicationPageByUser: {
        resident: 'Citizen RUZ',
        noResident: 'Foreigner',
        isForeigner: 'Citizen Ruz / Foreigner',
        choiceBranch: 'Select a branch',
        residencePlace: 'Place of residence',
        enterSchoolName: 'Enter the name of the school',
        notInList: 'No on the list',
        choiceSchool: 'Choose a driving school',
        fillFields: 'Fill in the fields',
        selectLanguage: 'Choose the language of the exam',
        visitDateNotValid: 'Not correct date for the visit to the center',
        visitDate: 'Date of visit to the center',
        fillDocs: 'Fill in the documents',
        selectCategory: 'Select the category',
        applicationSuccessCreated: 'The application was made successfully',
        error: 'An error has occurred, try it later',
        vehicleType: 'Indicate the type of vehicle',
        createApplication: 'Create an application',
        selectVehicleType: 'Select the type of transport',
        documentList: 'List of documents',
        back: 'Back',
        save: 'Save',
        applicationAlreadyExists:
          'An application with this category already exists',
        time: 'Time',
      },
      CreateApplicationPage: {
        send: 'Send',
        resident: 'Citizen RUZ',
        noResident: 'Foreigner',
        isForeigner: 'Citizen Ruz / Foreigner',
        residencePlace: 'Place of residence',
        notInList: 'No on the list',
        enterSchoolName: 'Enter the name of the driving school',
        choiceSchool: 'Choose a driving school',
        clear: 'Clean',
        selectLanguage: 'Choose the language of the exam',
        fillFields: 'Fill in the fields',
        vehicleType: 'Indicate the type of vehicle',
        uploadDocuments: 'Download the documents',
        applicationSuccessCreated: 'The application was made successfully',
        applicationAlreadyExists:
          'An application with this category already exists',
        error: 'An error has occurred, try it later',
        userNotFound: 'The user was not found',
        createApplication: 'Create an application',
        enterPhoneNumber: 'Enter the user phone number',
        pinfl: 'Pinfl',
        passportSerial: 'A series of passport',
        passportNumber: 'Passport number',
        selectCategory: 'Select the category',
        selectVehicleType: 'Select the type of transport',
        userData: 'User data',
        firstName: 'Name',
        lastName: 'Surname',
        middleName: 'Surname',
        dateOfBirth: 'Date of birth',
        documentList: 'List of documents',
        back: 'Back',
        save: 'Save',
        passIssued: 'The pass is issued',
        choiceCategory: 'Select the category',
        enterPassport: 'Enter the series and passport number',
        errorPinfl: 'Pinfl Field Error',
        errorPhone: 'Error in the phone number',
        passportExp: 'Passport period',
        medicalCertValid: 'Term honey. ',
        getData: 'Get data',
      },
      CategoriesPage: {
        deletedCategory: 'The category is deleted',
        error: 'An error occurred',
        wantDeleteCategory: 'Do you really want to delete the category?',
        categories: 'Categories',
        name: 'Name',
        createdAt: 'The date of creation',
        actions: 'Actions',
      },
      CashPayment: {
        cashPayment: 'Cash payment',
        fio: 'F.I.O.',
        passport: 'Series/Passport number',
        pinfl: 'Pinfl',
        date: 'Date of payment',
        sum: 'The amount of payment',
        details: 'Details',
        amountEnclosed: 'The collection of the amount',
        dateEnclosed: 'The date of collection',
        fioCashier: 'Full name of the cashier receiving payment',
        idMachine: 'The identification number of the payment apparatus',
      },
      BankCardPayment: {
        cardPayment: 'Bank payment by card',
        fio: 'F.I.O.',
        passport: 'Series/Passport number',
        pinfl: 'Pinfl',
        date: 'Date of payment',
        sum: 'The amount of payment',
        details: 'Details',
        lastNumber: 'Last 4 digits of the card',
        fioCashier: 'Full name of the cashier receiving payment',
        idMachine: 'The identification number of the payment apparatus',
      },
      ApplicationsPage: {
        operator: 'Operator',
        branch: 'Branch',
        application: 'Applications',
        clear: 'Clean',
        search: 'Find',
        fio: 'F.I.O.',
        phone: 'Telephone',
        appCode: 'Application code',
        passCode: 'Pass number',
        status: 'Status',
        category: 'Category',
        transportType: 'Type of transport',
        updatedAt: 'The date of change',
        actions: 'Actions',
        serial: 'Series',
        number: 'Number',
        pinfl: 'Pinfl',
        createdAt: 'C.',
        endDate: 'By',
        firstName: 'Name',
        lastName: 'Surname',
        middleName: 'Surname',
        categories: 'Category',
        vehicleTypes: 'Type of vehicle',
        statuses: 'Status',
        creationType: 'The type of application',
        choiceSchool: 'Choose a school',
        dateOfBirth: 'Date of birth',
        CREATED: 'CREATED',
        NOT_VERIFIED: 'NOT_VERIFIED',
        T_PAYMENT: 'T_PAYMENT',
        T_EXAM: 'T_EXAM',
        T_FAILED: 'T_FAILED',
        P_PAYMENT: 'P_PAYMENT',
        P_EXAM: 'P_EXAM',
        P_FAILED: 'P_FAILED',
        COMPLETED: 'COMPLETED',
        blocked: 'Blocked',
      },
      auth: {
        notFoundUser: 'Phone number was not found',
        enterOtpCode: 'Enter the SMS code',
        passwordNotConfirmed: 'Passwords do not match',
        passwordNotValid:
          'The length of the foles should be at least 6 characters',
        login: 'Enter',
        phoneNumber: 'Phone number',
        password: 'Password',
        forgotPassword: 'Forgot the password',
        confirmPassowrd: 'Confirm the password',
        register: 'Registration',
        resetPassword: 'Throw out the password',
        send: 'Send',
        confirmOffer: 'Confirm the public offer',
        enterCode: 'Enter SMS code',
        newPassword: 'New Password',
        smsCodeReplay: 'Send SMS again',
        sendCodeToMobile: 'SMS with code sent to your number',
        sendSmsLater: 'Repeat the sending of SMS through',
        sendSmsAgain: 'Repeat SMS sending',
        authSuccess: 'Authorization was successful',
        error: 'Check the correctness of the data filling',
        notValidLoginOrPassword: 'Wrong login or password',
        tryLaterAgain: 'Error, try later',
        editedPassword: 'The password is changed!',
        registed: 'Register',
        codeNotValid: 'Inappropriate SMS code',
        registrationSuccess: 'Registration was successful',
        alreadyUser: 'The user already exists',
        repeatPassword: 'Repeat password',
        offer: 'Public Offer',
        back: 'Back',
        cancel: 'Cancellation',
        sendCode: 'Send the code',
        checkCorrectData: 'Check the correctness of the data filling',
        passwordChanged: 'The password is changed',
      },
      updateQueuePage: {
        choiceBranch: 'Select a branch',
        choiceQueueType: 'Choose the type of queue',
        queueUpdated: 'The queue is changed',
        practice: 'Practice',
        theory: 'Theory',
        fillFields: 'Fill in the fields',
        tryAgainLater: 'An error has occurred, try it later',
        updateQueue: 'Change the queue',
        nameOz: 'Name on Uzbek (Kirilitsa)',
        nameUz: 'Name on Uzbek (Latin)',
        nameRu: 'The name is in Russian',
        back: 'Back',
        save: 'Save',
      },
      createQueuePage: {
        choiceBranch: 'Select a branch',
        choiceQueueType: 'Choose the type of queue',
        queueCreated: 'The queue was created successfully',
        practice: 'Practice',
        theory: 'Theory',
        fillFields: 'Fill in the fields',
        tryAgainLater: 'An error has occurred, try it later',
        createQueue: 'Create a queue',
        nameOz: 'Name on Uzbek (Kirilitsa)',
        nameUz: 'Name on Uzbek (Latin)',
        nameRu: 'The name is in Russian',
        back: 'Back',
        save: 'Save',
      },
      carsPage: {
        filter: 'Filter',
        choiceMotordrome: 'Choose an autodrome',
        search: 'Find',
        number: 'Number',
        model: 'Model',
        category: 'Category',
        cars: 'Cars',
      },
      timeslotsPage: {
        reserved: 'Reserved',
        capacity: 'Capacity',
        timeslotDeleted: 'Time slot deleted',
        createTimeslot: 'Create time slot',
        save: 'Save',
        back: 'Back',
        timeslotUpdated: 'Time slot updated',
        updateTimeslot: 'Update time slot',
        updatedDate: 'The date of change',
        actions: 'Actions',
        fromTime: 'From',
        toTime: 'To',
        branch: 'Branch',
        choiceBranch: 'Select a branch',
        reservedAndCapacity: 'Reserved / Capacity',
        search: 'Search',
        timeslots: 'Time slots',
        addTimeslot: 'Add a time slot',
        date: 'Date',
        deleteTimeslot: 'Delete a time slot',
        confirmDelete: 'Are you sure you want to delete this time slot?',
        createdTimeslot: 'The time slot was created successfully',
        confirmDeleteTimeslot:
          'Are you sure you want to delete this time slot?',
        fillFields: 'Fill in the fields',
        savedData: 'Data saved successfully',
      },
      queuePage: {
        branches: 'Branch',
        confirmDelete: 'Remove from the queue?',
        confirmLogout: 'Do you really want to go out?',
        usersCount: 'The number of people in line',
        classRoom: 'Cabinet',
        selectClassRoom: 'Select the office',
        emptyQueue: 'The queue is empty',
        confirmDeleteQueue: 'Do you really want to remove this line?',
        selectQueue: 'Select the queue',
        clearedQueue: 'The queue is cleaned',
        clear: 'Clean',
        enterCount: 'Enter the quantity',
        power: 'Launch',
        name: 'Name',
        updateDate: 'The date of change',
        actions: 'Actions',
        notAccept: 'Refused access, contact the reception',
        passNotValid: 'The pass is not valid',
        deletedQueue: 'The queue is removed',
        queue: 'Queue',
        timeslots: 'Time slots',
      },
    },
  },
};

export default data;
